import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.datasets');
import { formatWorkspaceDate } from "src/libs/portal/season/util/workspace-date";
import { OnInit, OnDestroy, HostListener, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
import { activateListRow } from "src/libs/portal/season/util/list-row";

@Component({
    selector: 'wiz-page-datasets',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.datasets/view.scss */
@charset "UTF-8";
:host {
  display: block;
  color: var(--ui-ink);
  background: var(--ui-paper);
  min-height: calc(100dvh - 80px);
}

.datasets-content {
  max-width: 1800px;
  margin: auto;
  padding: 24px 32px 28px;
  font-size: 14px;
}

*, *::before, *::after {
  box-sizing: border-box;
}

h1 {
  font-size: 26px;
  line-height: 1.3;
  font-weight: 700;
  letter-spacing: -0.03em;
  margin: 0;
  overflow-wrap: anywhere;
}

h2 {
  font-size: 17px;
  font-weight: 650;
  margin: 0;
  line-height: 1.5;
}

h2 span {
  color: var(--ui-accent);
  margin-left: 6px;
  font-variant-numeric: tabular-nums;
}

h3 {
  font-size: 15px;
  line-height: 1.6;
  margin: 0;
}

p {
  line-height: 1.6;
  margin: 6px 0 0;
}

.page-heading, .section-heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.page-heading {
  margin-bottom: 20px;
}

.heading-copy {
  min-width: 0;
}

.page-description, .muted, .panel-help {
  color: var(--ui-muted);
}

.page-description {
  font-size: 14px;
  margin-top: 6px;
}

.panel {
  background: var(--ui-paper);
  border: 1px solid var(--ui-line);
  border-radius: 8px;
  min-width: 0;
  overflow: hidden;
}

.panel-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 18px;
  border-bottom: 1px solid var(--ui-line);
}

.panel-heading > .muted {
  font-size: 13px;
}

.panel-help {
  font-size: 13px;
  padding: 10px 18px;
  margin: 0;
}

.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 44px;
  padding: 8px 14px;
  border: 1px solid transparent;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  text-decoration: none;
  cursor: pointer;
}

.primary {
  background: var(--ui-accent);
  color: var(--ui-paper);
}

.primary:hover:not(:disabled) {
  background: var(--ui-accent-hover);
}

.secondary {
  border-color: var(--ui-line);
  background: var(--ui-paper);
  color: var(--ui-text);
}

.secondary:hover:not(:disabled) {
  background: var(--ui-soft);
}

button:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

button:focus-visible, a:focus-visible, input:focus-visible, select:focus-visible, summary:focus-visible, [tabindex]:focus-visible {
  outline: 2px solid var(--ui-accent);
  outline-offset: 3px;
}

input, select {
  border: 1px solid var(--ui-line);
  border-radius: 6px;
  padding: 9px 10px;
  min-height: 44px;
  color: var(--ui-ink);
  background: var(--ui-paper);
  width: 100%;
  caret-color: var(--ui-accent);
  font-size: 14px;
}

input::placeholder {
  color: var(--ui-muted);
}

input[type=checkbox] {
  width: 18px;
  min-height: 18px;
  height: 18px;
  accent-color: var(--ui-accent);
}

label {
  display: block;
  font-size: 14px;
  font-weight: 600;
}

label input, label select {
  display: block;
  margin-top: 7px;
  font-weight: 450;
}

small {
  display: block;
  color: var(--ui-muted);
  font-size: 12px;
  line-height: 1.6;
  margin-top: 4px;
  font-weight: 450;
  overflow-wrap: anywhere;
}

.required {
  color: var(--ui-muted);
  font-size: 12px;
  font-weight: 450;
  margin-left: 4px;
}

.text-button {
  color: var(--ui-accent);
  background: none;
  border: 0;
  padding: 8px;
  font-size: 13px;
  font-weight: 600;
  text-underline-offset: 3px;
  cursor: pointer;
  white-space: nowrap;
}

.text-button:hover {
  text-decoration: underline;
}

.folder-icon {
  color: var(--ui-warning);
}

.table-wrap {
  overflow: auto;
  scrollbar-color: var(--ui-control) var(--ui-soft);
}

table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  font-size: 14px;
}

th {
  background: var(--ui-soft);
  font-weight: 600;
  color: var(--ui-text);
  padding: 10px 16px;
  white-space: nowrap;
}

td {
  padding: 12px 18px;
  border-bottom: 1px solid var(--ui-line);
  vertical-align: middle;
  font-variant-numeric: tabular-nums;
}

tr:last-child td {
  border-bottom: 0;
}

td:first-child {
  min-width: 170px;
  max-width: 440px;
  overflow-wrap: anywhere;
}

td strong {
  font-weight: 600;
}

td a {
  color: var(--ui-accent);
  text-underline-offset: 3px;
}

.dataset-table tbody tr {
  cursor: pointer;
}

.dataset-table tbody tr:hover, .dataset-table tbody tr:focus-within {
  background: var(--ui-soft);
}

.dataset-title-cell {
  display: flex;
  gap: 12px;
  align-items: center;
}

.unused-type-mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 34px;
  height: 34px;
  background: var(--ui-selected);
  color: var(--ui-accent-hover);
  border: 1px solid var(--ui-line);
  border-radius: 6px;
  font-size: 11px;
  font-weight: 700;
}

.dataset-name {
  color: var(--ui-ink);
  font-size: 15px;
  font-weight: 650;
  text-decoration: none;
  overflow-wrap: anywhere;
}

.dataset-name:hover {
  text-decoration: underline;
}

.date {
  color: var(--ui-muted);
  font-size: 13px;
  white-space: nowrap;
}

.state {
  background: var(--ui-selected);
  color: var(--ui-accent-hover);
  padding: 3px 8px;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.6;
}

.state[data-tone=good] {
  color: var(--ui-success);
  background: var(--ui-success-soft);
}

.state[data-tone=attention] {
  color: var(--ui-warning);
  background: #fff4e3;
}

.state[data-tone=danger] {
  color: var(--ui-danger);
  background: #fff0f1;
}

.state[data-tone=neutral] {
  color: var(--ui-muted);
  background: var(--ui-canvas);
}

progress {
  display: block;
  width: 100%;
  height: 6px;
  border: 0;
  margin: 8px 0 0;
  appearance: none;
  accent-color: var(--ui-accent);
}

progress::-webkit-progress-bar {
  background: var(--ui-canvas);
  border-radius: 3px;
}

progress::-webkit-progress-value {
  background: var(--ui-accent);
  border-radius: 3px;
}

progress::-moz-progress-bar {
  background: var(--ui-accent);
}

.table-progress {
  width: 140px;
  max-width: 100%;
  font-size: 13px;
  color: var(--ui-muted);
}

.table-progress strong {
  color: var(--ui-ink);
}

.table-progress progress {
  height: 4px;
  margin-top: 6px;
}

.register-footer {
  padding: 12px 18px;
  border-top: 1px solid var(--ui-line);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  color: var(--ui-muted);
  font-size: 12px;
}

.pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 12px;
  font-size: 13px;
  font-variant-numeric: tabular-nums;
}

.pagination .button {
  min-height: 34px;
  padding: 6px 10px;
  font-size: 13px;
}

.register-footer .pagination {
  padding: 0;
}

.draft-notice {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 18px;
  background: var(--ui-selected);
  border-bottom: 1px solid var(--ui-line);
}

.draft-notice > i {
  font-size: 18px;
  color: var(--ui-accent);
}

.draft-notice > div {
  flex: 1;
  min-width: 0;
}

.draft-notice strong {
  font-size: 13px;
}

.draft-notice span {
  display: block;
  color: var(--ui-muted);
  font-size: 13px;
  margin-top: 3px;
  overflow-wrap: anywhere;
}

.empty {
  padding: 56px 20px;
  text-align: center;
}

.empty > i {
  font-size: 28px;
  color: var(--ui-accent);
  margin-bottom: 16px;
}

.empty p {
  color: var(--ui-muted);
  margin-bottom: 20px;
}

.inline-empty {
  padding: 36px 18px;
  color: var(--ui-muted);
  font-size: 14px;
  text-align: center;
}

.message {
  padding: 10px 16px;
  margin: 12px 0;
  background: var(--ui-selected);
  line-height: 1.6;
  overflow-wrap: anywhere;
}

.message.error {
  color: var(--ui-danger);
  background: #fff3f4;
}

.message.success {
  color: var(--ui-success);
  background: var(--ui-success-soft);
}

.loading {
  padding: 40px 0;
  color: var(--ui-muted);
}

::selection {
  background: var(--ui-selected);
  color: var(--ui-ink);
}

.heading-count {
  display: inline-block;
  margin-left: 10px;
  color: var(--ui-muted);
  font-size: 18px;
  font-weight: 500;
  vertical-align: middle;
}

.page-heading {
  min-height: 42px;
  margin-bottom: 16px;
}

.dataset-type {
  color: var(--ui-muted);
  font-size: 12px;
  font-weight: 500;
}

.dataset-title-cell {
  flex-wrap: wrap;
  column-gap: 10px;
  row-gap: 4px;
}

.dataset-register .date {
  font-size: 13px;
}

.dataset-table th {
  padding: 12px 18px;
}

.dataset-table td:nth-child(4) {
  white-space: nowrap;
}

.dataset-table td:nth-child(4) small {
  display: inline;
  margin-left: 8px;
  font-size: 13px;
}

.table-progress {
  font-size: 14px;
  width: 132px;
}

.mobile-label, .mobile-close, .mobile-back-icon {
  display: none;
}

.creation-frame {
  border: 1px solid var(--ui-line);
  border-radius: 8px;
  background: var(--ui-paper);
  overflow: clip;
}

.creation-workspace {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  align-items: start;
  min-height: 0;
}

.settings {
  border-bottom: 1px solid var(--ui-line);
  background: var(--ui-soft);
  min-width: 0;
}

.settings .panel-heading {
  border: 0;
  padding: 14px 16px 0;
}

.settings-body {
  padding: 12px 16px 16px;
}

.settings-grid {
  display: grid;
  grid-template-columns: minmax(240px, 2fr) minmax(200px, 1fr);
  gap: 12px;
}

.settings-grid label {
  font-weight: 600;
}

.settings-grid small {
  font-size: 12px;
}

.quantity-field {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-top: 7px;
}

.quantity-field input {
  width: 112px;
  margin: 0;
}

.quantity-field span {
  color: var(--ui-muted);
  font-weight: 450;
}

.policy-note {
  font-size: 13px;
  color: var(--ui-muted);
  border-top: 1px solid var(--ui-line);
  padding-top: 8px;
  margin-top: 12px;
}

.policy-note summary, .execution-policy summary {
  cursor: pointer;
  font-weight: 500;
  padding: 6px 0;
}

.execution-policy {
  color: var(--ui-muted);
  margin-top: 0;
  font-size: 13px;
}

.creation-materials {
  min-width: 0;
}

.material-heading {
  padding: 10px 16px;
  min-height: 60px;
  flex-wrap: wrap;
}

.material-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}

.material-heading p {
  font-size: 13px;
  color: var(--ui-muted);
  margin: 4px 0 0;
}

.source-empty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 32px 20px;
  color: var(--ui-muted);
  text-align: center;
  min-height: 240px;
}

.source-empty i {
  font-size: 32px;
  margin-bottom: 16px;
}

.source-empty h3 {
  color: var(--ui-ink);
  font-size: 18px;
}

.source-empty p {
  margin: 8px 0 20px;
  font-size: 14px;
}

.selection-list {
  list-style: none;
  margin: 0;
  padding: 0 20px;
  max-height: 280px;
  overflow: auto;
  scrollbar-color: var(--ui-control) var(--ui-soft);
}

.selection-list li {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 0;
  border-bottom: 1px solid var(--ui-line);
}

.selection-list li > i {
  width: 20px;
  font-size: 18px;
}

.selection-list li > div {
  min-width: 0;
  flex: 1;
}

.selection-list strong {
  font-size: 15px;
  overflow-wrap: anywhere;
}

.selection-list small {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.source-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 16px;
  border-bottom: 1px solid var(--ui-line);
}

.source-actions > .muted {
  font-size: 13px;
}

.source-actions .button {
  font-size: 13px;
  min-height: 36px;
  padding: 7px 10px;
}

.basket-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 0;
  color: var(--ui-muted);
  font-weight: 500;
}

.basket-toggle i {
  font-size: 10px;
}

.readiness-strip {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  padding: 6px 16px;
  font-size: 13px;
  color: var(--ui-muted);
}

.readiness-strip strong {
  font-size: 14px;
  color: var(--ui-success);
}

.readiness-strip strong i {
  margin-right: 8px;
}

.preparation .message {
  margin: 0 20px 12px;
}

.preparation-table td {
  padding: 12px 16px;
  vertical-align: top;
}

.preparation-table td:first-child {
  min-width: 160px;
  max-width: 320px;
}

.preparation-table td:first-child small {
  display: none;
}

.preparation-table th {
  padding: 10px 16px;
}

.preparation-table input:not([type=checkbox]) {
  width: 80px;
  min-height: 34px;
  padding: 6px 8px;
  margin: 0;
}

.preparation-table td a {
  display: block;
  font-size: 13px;
  margin-top: 6px;
}

.creation-footer {
  position: sticky;
  bottom: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 14px 20px;
  margin: 0;
  background: var(--ui-paper);
  border-top: 1px solid var(--ui-line);
}

.creation-summary strong {
  font-size: 14px;
  font-weight: 600;
}

.creation-summary small {
  font-size: 12px;
}

.footer-actions {
  display: flex;
  gap: 8px;
}

.execution-overview {
  border: 0;
  border-bottom: 1px solid var(--ui-line);
  background: var(--ui-paper);
  margin-bottom: 0;
}

.overview-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 18px;
}

.detail-summary {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  font-size: 13px;
  color: var(--ui-muted);
}

.action-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.job-actions .button {
  min-height: 34px;
  font-size: 13px;
  padding: 6px 10px;
}

.job-actions .text-button {
  font-size: 13px;
}

.generation-progress {
  display: flex;
  align-items: flex-start;
  gap: 24px;
  padding: 0 18px 14px;
}

.goal-line {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 0;
  font-size: 13px;
  line-height: 1.5;
}

.goal-line > span:first-child {
  white-space: nowrap;
}

.goal-line strong {
  font-size: 19px;
  font-weight: 650;
  color: var(--ui-accent);
  margin-left: 4px;
}

.goal-target {
  font-size: 14px;
}

.goal-line progress {
  flex: 1;
  max-width: 220px;
  min-width: 50px;
  margin: 0;
  height: 5px;
}

.goal-line > .muted {
  font-size: 12px;
  white-space: nowrap;
}

.run-details {
  width: 300px;
  flex-shrink: 0;
  font-size: 12px;
  color: var(--ui-muted);
  padding-top: 3px;
}

.run-details > summary {
  cursor: pointer;
  line-height: 24px;
}

.run-details > summary span {
  margin-right: 12px;
}

.run-details > summary .run-detail-label {
  color: var(--ui-accent);
  margin-right: 0;
}

.run-attention {
  color: var(--ui-warning);
}

.run-details-body {
  padding: 12px 0 0;
  font-size: 13px;
  line-height: 1.6;
}

.run-details-body p {
  overflow-wrap: anywhere;
}

.progress-label {
  font-size: 12px;
  color: var(--ui-muted);
  font-weight: 450;
  margin: 0 0 12px;
}

.progress-label > span {
  float: right;
}

.progress-label progress {
  height: 4px;
}

.ready-note {
  padding: 0 18px 16px;
  color: var(--ui-muted);
  font-size: 14px;
}

.detail-workspace {
  margin: 0;
  border: 0;
  border-radius: 0;
  overflow: visible;
}

.workspace-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border-bottom: 1px solid var(--ui-line);
  padding: 0 18px;
}

.workspace-tabs {
  display: flex;
  gap: 24px;
  min-width: 0;
}

.workspace-tabs button {
  border: 0;
  border-bottom: 2px solid transparent;
  padding: 12px 0 9px;
  background: none;
  color: var(--ui-muted);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
}

.workspace-tabs button[aria-pressed=true] {
  color: var(--ui-accent);
  border-bottom-color: var(--ui-accent);
}

.workspace-tabs button span {
  margin-left: 4px;
  font-size: 12px;
}

.result-toolbar {
  padding: 8px 0;
}

.result-toolbar label {
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--ui-muted);
  font-size: 12px;
  white-space: nowrap;
}

.result-toolbar select {
  margin: 0;
  min-height: 34px;
  width: 126px;
  padding: 6px 8px;
  font-size: 13px;
}

.qa-workbench {
  display: grid;
  grid-template-columns: minmax(260px, 0.7fr) minmax(0, 1.3fr);
  min-height: 420px;
}

.qa-list-pane {
  border-right: 1px solid var(--ui-line);
  max-height: calc(100dvh - 290px);
  min-height: 420px;
  overflow: auto;
  scrollbar-color: var(--ui-control) var(--ui-soft);
  background: var(--ui-soft);
  min-width: 0;
}

.qa-result-row {
  position: relative;
  padding: 16px 36px 16px 18px;
  border-bottom: 1px solid var(--ui-line);
}

.qa-result-row:hover {
  background: var(--ui-soft);
}

.qa-result-row.selected {
  background: var(--ui-selected);
}

.result-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  font-size: 12px;
  color: var(--ui-muted);
  margin-bottom: 8px;
}

.qa-result-row strong {
  display: block;
  line-height: 1.6;
  font-size: 15px;
  overflow-wrap: anywhere;
}

.qa-result-row p {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin: 4px 0 0;
  font-size: 13px;
  color: var(--ui-muted);
}

.result-open {
  position: absolute;
  inset: 0;
  border: 0;
  background: none;
  color: var(--ui-accent);
  cursor: pointer;
  text-align: right;
  padding: 14px;
  width: 100%;
}

.result-open i {
  font-size: 11px;
}

.result-open:focus-visible {
  outline-offset: -3px;
}

.inspector-empty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 32px;
  text-align: center;
  color: var(--ui-muted);
}

.inspector-empty > i {
  font-size: 28px;
  margin-bottom: 16px;
}

.inspector-empty h3 {
  color: var(--ui-text);
  font-size: 16px;
}

.inspector-empty p {
  font-size: 14px;
}

.qa-inspector {
  min-width: 0;
  max-height: calc(100dvh - 290px);
  min-height: 420px;
  overflow: auto;
  scrollbar-color: var(--ui-control) var(--ui-soft);
}

.inspector-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 24px 0;
}

.inspector-state {
  display: flex;
  align-items: center;
  gap: 8px;
}

.inspector-state small {
  margin: 0;
  font-size: 12px;
}

.qa-question {
  padding: 12px 24px 20px;
}

.qa-question h3 {
  font-size: 21px;
  line-height: 1.6;
  font-weight: 650;
  letter-spacing: -0.02em;
  overflow-wrap: anywhere;
}

.inspector-tabs {
  display: flex;
  gap: 20px;
  padding: 0 24px;
  border-bottom: 1px solid var(--ui-line);
}

.inspector-tabs button {
  border: 0;
  border-bottom: 2px solid transparent;
  padding: 0 0 10px;
  background: none;
  color: var(--ui-muted);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  min-height: 32px;
}

.inspector-tabs button[aria-pressed=true] {
  color: var(--ui-accent);
  border-bottom-color: var(--ui-accent);
}

.inspector-body {
  padding: 20px 24px 28px;
}

.qa-label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: var(--ui-muted);
  margin-bottom: 8px;
}

.qa-answer, .evidence-text {
  margin: 0;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  max-width: 75ch;
  font-size: 15px;
  line-height: 1.85;
}

.qa-answer-section {
  margin: 0;
}

.issue-list {
  margin-top: 20px;
  padding: 12px 16px;
  background: #fff4e3;
  color: var(--ui-warning);
  font-size: 13px;
}

.citations {
  margin-top: 24px;
}

.citations h3 {
  font-size: 13px;
  color: var(--ui-muted);
  font-weight: 600;
}

.qa-inspector blockquote {
  margin: 10px 0 0;
  padding: 12px 16px;
  border-left: 1px solid var(--ui-control);
  background: var(--ui-soft);
  color: var(--ui-text);
  font-size: 14px;
}

.qa-inspector blockquote p {
  margin: 0;
}

.snapshot-file {
  border-bottom: 1px solid var(--ui-line);
  padding: 16px 0;
}

.snapshot-file:last-child {
  border: 0;
  padding-bottom: 0;
}

.snapshot-file header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.snapshot-file header > i {
  font-size: 20px;
  color: var(--ui-muted);
  margin-top: 4px;
}

.snapshot-file header > div {
  flex: 1;
  min-width: 0;
}

.snapshot-file header > span {
  color: var(--ui-muted);
  font-size: 13px;
}

.snapshot-file h3 {
  font-size: 16px;
  overflow-wrap: anywhere;
}

.source-path {
  font-size: 12px;
  color: var(--ui-muted);
  margin-top: 4px;
}

.source-path summary {
  cursor: pointer;
}

.source-path p {
  overflow-wrap: anywhere;
  font-size: 12px;
}

.snapshot-pages {
  display: flex;
  flex-wrap: wrap;
  margin-top: 16px;
  gap: 8px;
}

.snapshot-page {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 190px;
  gap: 4px 16px;
  padding: 12px 16px;
  border: 1px solid var(--ui-line);
  border-radius: 6px;
  background: var(--ui-soft);
  font-size: 13px;
}

.snapshot-page > span {
  color: var(--ui-muted);
}

.snapshot-page small {
  width: 100%;
  margin: 0;
}

.snapshot-page.changed {
  background: #fff4e3;
  color: var(--ui-warning);
}

.check-section + .check-section {
  margin-top: 24px;
}

.check-section h3 {
  margin-bottom: 8px;
}

.check-list details {
  border-bottom: 1px solid var(--ui-line);
  font-size: 13px;
}

.check-list summary {
  padding: 10px 0;
  cursor: pointer;
}

.check-list summary > span:first-child {
  margin-left: 4px;
}

.check-verdict {
  float: right;
  font-size: 12px;
  color: var(--ui-success);
  font-weight: 600;
}

.check-verdict.failed {
  color: var(--ui-warning);
}

.check-list details p {
  padding: 0 0 12px;
  color: var(--ui-muted);
}

.inspector-body .panel-help {
  padding: 0;
  margin-bottom: 12px;
}

.evidence-item {
  padding: 12px 0;
  border-bottom: 1px solid var(--ui-line);
}

.evidence-item summary {
  font-size: 14px;
  cursor: pointer;
  overflow-wrap: anywhere;
  font-weight: 600;
}

.evidence-item p {
  margin: 14px 0;
  font-size: 13px;
}

.evidence-item a {
  color: var(--ui-accent);
  font-size: 13px;
}

.detail-tab-content {
  padding: 20px 18px;
}

.detail-tab-content .sources-section > p {
  margin: 6px 0 16px;
  font-size: 13px;
}

.execution-info dl {
  margin: 20px 0 0;
  max-width: 720px;
}

.execution-info dl > div {
  display: grid;
  grid-template-columns: 140px minmax(0, 1fr);
  padding: 12px 0;
  border-bottom: 1px solid var(--ui-line);
}

.execution-info dt {
  color: var(--ui-muted);
  font-weight: 450;
}

.execution-info dd {
  margin: 0;
  overflow-wrap: anywhere;
}

.datasets-content table {
  white-space: normal;
}

.datasets-content th {
  display: table-cell;
  font-size: 13px;
}

.datasets-content td {
  font-size: 14px;
}

.datasets-content input[type=checkbox] {
  appearance: auto;
  -webkit-appearance: checkbox;
  padding: 0;
}

.datasets-content select {
  appearance: auto;
}

.datasets-content .page-description {
  font-size: 14px;
}

.datasets-content .page-heading h1 {
  letter-spacing: -0.03em;
}

@media (max-width: 1100px) {
  .datasets-content {
    padding: 20px 24px;
  }
  .creation-workspace {
    grid-template-columns: minmax(0, 1fr);
  }
  .settings .panel-heading {
    padding: 18px 16px 0;
  }
  .settings-body {
    padding: 18px 16px;
  }
  .material-heading, .source-actions, .readiness-strip {
    padding-left: 16px;
    padding-right: 16px;
  }
  .source-actions {
    flex-wrap: wrap;
  }
  .preparation-table td, .preparation-table th {
    padding: 10px;
  }
  .run-details {
    width: 240px;
  }
  .goal-line > .muted {
    display: none;
  }
  .qa-workbench {
    grid-template-columns: minmax(250px, 0.8fr) minmax(0, 1.2fr);
  }
}
@media (max-width: 767px) {
  :host {
    min-height: calc(100dvh - 100px);
  }
  .datasets-content {
    padding: 16px 12px 24px;
  }
  h1 {
    font-size: 23px;
  }
  .heading-count {
    font-size: 16px;
    margin-left: 8px;
  }
  .page-heading {
    gap: 12px;
    margin-bottom: 14px;
    align-items: center;
    flex-wrap: wrap;
  }
  .heading-copy {
    flex: 1;
    min-width: 140px;
  }
  .page-heading > .button {
    font-size: 13px;
    min-height: 38px;
    padding: 8px 10px;
  }
  .panel-heading {
    padding: 14px;
  }
  .draft-notice {
    padding: 12px;
    gap: 8px;
  }
  .draft-notice > i {
    display: none;
  }
  .draft-notice .button {
    padding: 8px;
    font-size: 12px;
  }
  .register-footer {
    flex-direction: column;
    gap: 12px;
    padding: 12px;
  }
  .datasets-content table, .datasets-content tbody {
    display: block;
  }
  .datasets-content thead {
    display: none;
  }
  .datasets-content tr {
    display: block;
    padding: 14px;
    border-bottom: 1px solid var(--ui-line);
  }
  .datasets-content tr:last-child {
    border: 0;
  }
  .datasets-content td {
    display: grid;
    grid-template-columns: 110px minmax(0, 1fr);
    gap: 8px;
    align-items: start;
    padding: 6px 0;
    border: 0;
    min-width: 0;
    max-width: none;
    white-space: normal;
  }
  .datasets-content td:first-child {
    display: block;
    padding: 0 0 10px;
  }
  .datasets-content td[data-label]::before {
    content: attr(data-label);
    color: var(--ui-muted);
    font-size: 13px;
  }
  .datasets-content td .state {
    justify-self: start;
  }
  .datasets-content .dataset-table tr {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: 6px 10px;
    padding: 14px;
  }
  .datasets-content .dataset-table td {
    display: block;
    padding: 0;
  }
  .datasets-content .dataset-table td:first-child {
    grid-column: 1/-1;
  }
  .datasets-content .dataset-table td[data-label]::before {
    display: none;
  }
  .dataset-title-cell {
    flex-wrap: nowrap;
    align-items: baseline;
    justify-content: space-between;
  }
  .dataset-name {
    font-size: 15px;
    line-height: 1.5;
  }
  .dataset-type {
    font-size: 11px;
    flex-shrink: 0;
  }
  .datasets-content .dataset-table td:nth-child(3) {
    text-align: right;
  }
  .table-progress {
    width: 100%;
    font-size: 13px;
  }
  .table-progress progress {
    display: none;
  }
  .mobile-label {
    display: inline;
    font-size: 11px;
    color: var(--ui-muted);
  }
  .dataset-table td:nth-child(4) {
    font-size: 12px;
    color: var(--ui-muted);
    white-space: normal;
  }
  .dataset-table td:nth-child(4) small {
    font-size: 12px;
    margin-left: 5px;
  }
  .datasets-content .dataset-table .date {
    font-size: 11px;
    line-height: 1.8;
    text-align: right;
  }
  .creation-workspace {
    grid-template-columns: 1fr;
    min-height: 0;
  }
  .settings {
    border-right: 0;
    border-bottom: 1px solid var(--ui-line);
  }
  .settings .panel-heading {
    padding: 14px 14px 0;
  }
  .settings-body {
    padding: 10px 14px 12px;
  }
  .settings-grid {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: 10px 12px;
  }
  .name-field {
    grid-column: 1/-1;
  }
  .settings-grid input, .settings-grid select {
    font-size: 13px;
  }
  .quantity-field input {
    width: 90px;
  }
  .quantity-field {
    gap: 6px;
  }
  .settings-grid small {
    font-size: 11px;
  }
  .policy-note {
    margin-top: 10px;
    padding-top: 6px;
  }
  .execution-policy {
    margin-top: 0;
  }
  .policy-note, .execution-policy {
    font-size: 12px;
  }
  .material-heading {
    align-items: center;
    gap: 10px;
  }
  .material-heading h2 {
    font-size: 16px;
  }
  .material-heading p {
    font-size: 12px;
  }
  .material-heading .button {
    padding: 8px;
    font-size: 12px;
  }
  .source-empty {
    min-height: 260px;
    padding: 28px 16px;
  }
  .source-empty h3 {
    font-size: 17px;
  }
  .source-empty p {
    font-size: 13px;
  }
  .selection-list {
    padding: 0 14px;
  }
  .selection-list li {
    gap: 10px;
  }
  .selection-list strong {
    font-size: 14px;
  }
  .source-actions {
    padding: 10px 14px;
    gap: 8px;
  }
  .source-actions .button {
    margin-left: auto;
    font-size: 12px;
  }
  .source-actions .text-button {
    font-size: 12px;
  }
  .readiness-strip {
    padding: 6px 14px;
    gap: 4px 12px;
  }
  .readiness-strip .basket-toggle {
    flex-basis: 100%;
  }
  .material-heading {
    padding: 10px 14px;
    gap: 6px;
  }
  .material-actions {
    gap: 6px;
  }
  .material-actions .button {
    white-space: normal;
  }
  .material-actions .button:first-child {
    white-space: nowrap;
  }
  .readiness-strip strong {
    font-size: 13px;
  }
  .readiness-strip > span {
    font-size: 12px;
  }
  .preparation-table td a {
    grid-column: 2;
  }
  .creation-footer {
    padding: 12px 14px;
    flex-wrap: wrap;
    gap: 12px;
  }
  .footer-actions {
    width: 100%;
  }
  .footer-actions .button {
    flex: 1;
  }
  .creation-summary small {
    font-size: 11px;
  }
  .overview-heading {
    padding: 12px;
    flex-wrap: wrap;
    gap: 8px;
  }
  .detail-summary {
    gap: 8px;
    font-size: 12px;
  }
  .job-actions {
    gap: 6px;
  }
  .job-actions .button, .job-actions .text-button {
    font-size: 12px;
    min-height: 32px;
    padding: 6px 8px;
  }
  .generation-progress {
    display: block;
    padding: 0 12px 10px;
  }
  .goal-line {
    gap: 10px;
    font-size: 12px;
  }
  .goal-line strong {
    font-size: 19px;
  }
  .goal-line progress {
    max-width: none;
  }
  .goal-line > .muted {
    display: none;
  }
  .run-details {
    width: auto;
    padding-top: 6px;
  }
  .run-details > summary {
    font-size: 12px;
  }
  .run-details-body {
    padding-top: 8px;
  }
  .execution-overview {
    margin-bottom: 12px;
  }
  .workspace-toolbar {
    padding: 0 12px;
    gap: 8px;
    flex-wrap: wrap;
  }
  .workspace-tabs {
    gap: 18px;
  }
  .workspace-tabs button {
    font-size: 13px;
    padding: 12px 0 10px;
  }
  .result-toolbar {
    padding: 8px 0;
  }
  .result-toolbar label {
    font-size: 0;
    gap: 0;
  }
  .result-toolbar select {
    width: 100px;
    font-size: 12px;
    min-height: 32px;
  }
  .workspace-tabs button span {
    font-size: 11px;
    margin-left: 2px;
  }
  .qa-workbench {
    display: block;
    min-height: 0;
  }
  .qa-list-pane {
    border-right: 0;
    min-height: 0;
    max-height: none;
  }
  .qa-result-row {
    padding: 14px 30px 14px 14px;
  }
  .qa-result-row strong {
    font-size: 15px;
  }
  .result-meta {
    gap: 8px;
  }
  .inspector-empty {
    display: none;
  }
  .has-selection .qa-list-pane {
    display: none;
  }
  .qa-inspector {
    min-height: 0;
    max-height: none;
  }
  .inspector-heading {
    padding: 12px 14px 0;
    gap: 8px;
  }
  .inspector-heading .text-button {
    font-size: 12px;
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 0;
  }
  .inspector-state {
    gap: 6px;
  }
  .inspector-state small {
    font-size: 11px;
  }
  .desktop-close {
    display: none;
  }
  .mobile-close, .mobile-back-icon {
    display: inline;
  }
  .qa-question {
    padding: 14px 14px 16px;
  }
  .qa-question h3 {
    font-size: 19px;
  }
  .inspector-tabs {
    padding: 0 14px;
    gap: 22px;
  }
  .inspector-body {
    padding: 18px 14px 24px;
  }
  .qa-answer {
    font-size: 15px;
  }
  .qa-inspector blockquote {
    padding: 10px 12px;
    font-size: 13px;
  }
  .detail-tab-content {
    padding: 18px 14px;
  }
  .snapshot-file {
    padding: 14px 0;
  }
  .snapshot-file h3 {
    font-size: 15px;
  }
  .snapshot-pages {
    display: grid;
    grid-template-columns: 1fr 1fr;
    margin-top: 12px;
  }
  .snapshot-page {
    width: auto;
    padding: 10px;
    font-size: 12px;
    gap: 4px;
    flex-direction: column;
    align-items: flex-start;
  }
  .snapshot-page small {
    font-size: 11px;
  }
  .execution-info dl > div {
    grid-template-columns: 100px minmax(0, 1fr);
  }
}
.include-label {
  display: none;
}

.qa-question h3, .qa-answer, .evidence-text, .preview-text {
  word-break: keep-all;
  overflow-wrap: anywhere;
}

/* Dataset workspaces: collection, input preview, evidence review. */
.collection-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  border-bottom: 1px solid var(--ui-line);
}

.collection-search {
  display: flex;
  align-items: center;
  flex: 1;
  max-width: 440px;
  gap: 10px;
  border: 1px solid var(--ui-line);
  border-radius: 6px;
  padding: 0 10px;
}

.collection-search > i {
  color: var(--ui-muted);
}

.collection-search input {
  margin: 0;
  border: 0;
  min-width: 0;
  padding: 9px 0;
}

.collection-search .text-button {
  flex-shrink: 0;
  padding: 8px 0;
}

.collection-toolbar > select {
  width: auto;
  min-width: 112px;
}

.collection-toolbar > select[name=sort] {
  margin-left: auto;
}

.dataset-table td {
  height: 52px;
  padding-top: 8px;
  padding-bottom: 8px;
}

.dataset-table th {
  border-bottom: 1px solid var(--ui-line);
}

.dataset-table .dataset-name {
  color: var(--ui-ink);
}

.dataset-table .dataset-type {
  background: var(--ui-soft);
  border: 0;
  border-radius: 4px;
  padding: 2px 7px;
}

.dataset-table .table-progress progress {
  display: none;
}

.dataset-table .date {
  font-variant-numeric: tabular-nums;
}

.materials-preview-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
}

.prepared-files {
  min-width: 0;
  max-height: 560px;
  overflow: auto;
  scrollbar-color: var(--ui-control) var(--ui-soft);
}

.file-preview-button {
  border: 0;
  padding: 0;
  background: none;
  color: var(--ui-ink);
  display: flex;
  gap: 10px;
  align-items: flex-start;
  text-align: left;
  cursor: pointer;
  font: inherit;
}

.file-preview-button i {
  color: var(--ui-muted);
  margin-top: 3px;
}

.file-preview-button[aria-pressed=true] {
  color: var(--ui-accent);
}

.source-preview {
  min-width: 0;
  background: var(--ui-soft);
  border-left: 1px solid var(--ui-line);
}

.source-preview header {
  padding: 10px 16px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  border-bottom: 1px solid var(--ui-line);
}

.source-preview header > div {
  flex: 1;
  min-width: 0;
}

.source-preview header .text-button {
  padding: 4px;
}

.source-preview header small {
  font-size: 13px;
}

.preview-controls {
  padding: 8px 16px;
  border-bottom: 1px solid var(--ui-line);
}

.preview-controls label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  font-size: 13px;
  color: var(--ui-muted);
}

.preview-controls select {
  width: auto;
  max-width: 80%;
  margin: 0;
  min-height: 34px;
  padding: 6px;
}

.preview-text {
  padding: 16px;
  margin: 0;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  font-size: 15px;
  line-height: 1.85;
  max-height: 430px;
  overflow: auto;
  scrollbar-color: var(--ui-control) var(--ui-soft);
}

.is-detail {
  padding-top: 18px;
}

.is-detail .page-heading {
  margin-bottom: 8px;
}

.is-detail .overview-heading {
  padding: 0 0 8px;
  gap: 20px;
  align-items: flex-start;
  flex-wrap: wrap;
}

.is-detail .detail-summary {
  min-height: 44px;
}

.is-detail .job-actions {
  min-height: 44px;
  margin-left: auto;
}

.is-detail .generation-progress {
  display: block;
  flex: 1;
  min-width: 300px;
  padding: 0;
}

.is-detail .run-details {
  width: auto;
  padding-top: 0;
}

.is-detail .goal-line {
  min-height: 28px;
}

.is-detail .workspace-toolbar {
  padding: 0;
}

.qa-workbench {
  grid-template-columns: 260px minmax(0, 1fr);
  height: max(480px, 100dvh - 284px);
  min-height: 0;
  border: 1px solid var(--ui-line);
  border-top: 0;
}

.queue-heading {
  position: sticky;
  top: 0;
  z-index: 1;
  display: flex;
  justify-content: space-between;
  padding: 12px 16px;
  background: var(--ui-soft);
  border-bottom: 1px solid var(--ui-line);
  font-size: 13px;
  font-weight: 600;
  color: var(--ui-text);
}

.queue-heading span {
  font-variant-numeric: tabular-nums;
  color: var(--ui-muted);
}

.qa-list-pane {
  max-height: none;
  min-height: 0;
  height: 100%;
  background: var(--ui-paper);
  border-color: var(--ui-line);
}

.qa-result-row {
  padding: 14px 30px 14px 16px;
}

.qa-result-row strong {
  font-size: 14px;
  font-weight: 550;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.result-meta {
  gap: 6px;
  font-size: 11px;
}

.result-meta .state {
  font-size: 11px;
  padding: 2px 6px;
}

.qa-inspector {
  display: flex;
  flex-direction: column;
  max-height: none;
  min-height: 0;
  height: 100%;
  overflow: hidden;
}

.inspector-heading {
  padding: 6px 16px;
  border-bottom: 1px solid var(--ui-line);
  min-height: 46px;
  flex-wrap: wrap;
}

.item-navigation {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  font-size: 12px;
  color: var(--ui-muted);
  font-variant-numeric: tabular-nums;
}

.icon-button {
  width: 32px;
  height: 32px;
  border: 1px solid var(--ui-line);
  border-radius: 4px;
  background: var(--ui-paper);
  color: var(--ui-text);
  cursor: pointer;
}

.icon-button:hover:not(:disabled) {
  background: var(--ui-soft);
}

.inspection-columns {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 340px;
  flex: 1;
  min-height: 0;
  overflow: auto;
  align-items: stretch;
  scrollbar-color: var(--ui-control) var(--ui-soft);
}

.qa-reading {
  min-width: 0;
  padding: 16px 24px 24px;
  max-height: none;
  min-height: 0;
  overflow: visible;
}

.qa-question {
  padding: 0 0 16px;
}

.qa-question h3 {
  font-size: 22px;
  line-height: 1.5;
  font-weight: 650;
  letter-spacing: -0.02em;
}

.qa-label {
  color: var(--ui-muted);
  font-size: 13px;
  margin-bottom: 6px;
}

.qa-answer {
  font-size: 16px;
  line-height: 1.85;
}

.qa-support {
  border-left: 1px solid var(--ui-line);
  background: var(--ui-soft);
  min-width: 0;
  padding: 18px 20px;
  max-height: none;
  min-height: 0;
  overflow: visible;
}

.source-evidence > h3 {
  font-size: 14px;
  display: flex;
  justify-content: space-between;
}

.source-evidence > h3 span {
  color: var(--ui-muted);
  font-weight: 450;
}

.evidence-item {
  padding: 16px 0;
}

.evidence-item summary {
  font-size: 13px;
  line-height: 1.6;
}

.evidence-item .evidence-text {
  font-size: 16px;
  line-height: 1.8;
  max-height: none;
  overflow: visible;
}

.evidence-item a {
  display: inline-block;
  padding: 4px 0;
}

.review-disclosure {
  border-top: 1px solid var(--ui-line);
  margin-top: 20px;
  padding-top: 16px;
}

.review-disclosure > summary {
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.review-disclosure > summary span {
  display: block;
  margin: 6px 0 0 16px;
  font-size: 12px;
  font-weight: 450;
  color: var(--ui-muted);
}

.review-content {
  padding-top: 18px;
}

.check-section h3 {
  font-size: 13px;
}

.check-list summary {
  line-height: 1.7;
}

.check-verdict {
  float: none;
  display: inline-block;
  margin-left: 8px;
}

.citations {
  padding-top: 20px;
  border-top: 1px solid var(--ui-line);
  margin-top: 28px;
}

@media (max-width: 1279px) {
  .qa-workbench {
    grid-template-columns: 220px minmax(0, 1fr);
  }
  .inspection-columns {
    grid-template-columns: minmax(0, 1fr) 300px;
  }
  .qa-reading {
    padding: 16px 20px;
  }
  .qa-support {
    padding: 16px;
  }
  .source-preview {
    border-left: 0;
    border-top: 1px solid var(--ui-line);
  }
  .prepared-files {
    max-height: 360px;
  }
}
@media (max-width: 1050px) {
  .qa-workbench {
    height: auto;
  }
  .qa-inspector {
    height: auto;
    overflow: visible;
  }
  .qa-list-pane {
    max-height: calc(100dvh - 280px);
  }
  .inspection-columns {
    grid-template-columns: 1fr;
  }
  .qa-reading {
    max-height: none;
    min-height: 0;
  }
  .qa-support {
    border-left: 0;
    border-top: 1px solid var(--ui-line);
    max-height: none;
    min-height: 0;
  }
  .collection-toolbar {
    flex-wrap: wrap;
  }
  .collection-search {
    max-width: none;
    flex-basis: 100%;
  }
}
@media (max-width: 767px) {
  .collection-toolbar {
    padding: 12px;
    gap: 8px;
  }
  .collection-toolbar > select {
    min-width: 0;
    flex: 1;
    width: calc(33% - 8px);
    font-size: 12px;
    padding: 8px 4px;
  }
  .dataset-table td {
    height: auto;
  }
  .collection-toolbar > select[name=sort] {
    margin-left: 0;
  }
  .qa-workbench {
    display: block;
    min-height: 0;
  }
  .qa-list-pane {
    max-height: none;
    min-height: 0;
    height: auto;
  }
  .qa-inspector {
    min-height: 0;
  }
  .inspector-heading {
    padding: 6px 12px;
    gap: 6px;
  }
  .inspector-state small {
    font-size: 11px;
  }
  .item-navigation {
    gap: 4px;
  }
  .item-navigation span {
    font-size: 11px;
  }
  .inspector-heading > .text-button {
    margin-left: auto;
  }
  .qa-reading {
    padding: 16px 16px 24px;
  }
  .qa-question {
    padding: 0 0 16px;
  }
  .qa-question h3 {
    font-size: 20px;
  }
  .qa-support {
    padding: 18px 16px;
  }
  .qa-answer {
    font-size: 15px;
  }
  .is-detail .overview-heading {
    padding: 0 0 6px;
    gap: 4px 12px;
  }
  .is-detail .detail-summary {
    min-height: 32px;
  }
  .is-detail .job-actions {
    min-height: 32px;
  }
  .is-detail .generation-progress {
    order: 3;
    flex-basis: 100%;
    min-width: 0;
  }
  .is-detail .execution-overview {
    margin-bottom: 0;
  }
  .is-detail .generation-progress {
    padding: 0;
  }
  .source-preview header {
    padding: 14px 16px;
  }
  .preview-text {
    padding: 16px;
    max-height: 360px;
  }
}
.source-picker {
  width: min(1240px, 100vw - 64px);
  max-width: none;
  height: min(800px, 100dvh - 64px);
  max-height: calc(100dvh - 32px);
  padding: 0;
  border: 0;
  border-radius: 12px;
  background: var(--ui-paper);
  color: var(--ui-ink);
  margin: auto;
  box-shadow: 0 24px 72px rgba(35, 39, 47, 0.2509803922);
  overflow: hidden;
}

.source-picker[open] {
  display: flex;
  flex-direction: column;
}

.source-picker::backdrop {
  background: rgba(35, 39, 47, 0.4392156863);
}

.picker-header {
  display: flex;
  align-items: flex-start;
  gap: 24px;
  justify-content: space-between;
  padding: 24px 28px 20px;
  border-bottom: 1px solid var(--ui-line);
  flex-shrink: 0;
}

.picker-header h2 {
  font-size: 22px;
  margin: 0;
}

.picker-header p {
  color: var(--ui-muted);
  margin-top: 8px;
}

.picker-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border: 0;
  border-radius: 6px;
  color: var(--ui-text);
  background: transparent;
  cursor: pointer;
}

.picker-close:hover:not(:disabled) {
  background: var(--ui-selected);
}

.picker-body {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 290px;
  flex: 1;
  min-height: 0;
}

.picker-browser {
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  padding: 16px 24px 0;
}

.picker-breadcrumbs {
  display: flex;
  align-items: center;
  gap: 6px;
  overflow-x: auto;
  flex-shrink: 0;
  min-height: 44px;
}

.picker-breadcrumbs button {
  padding: 8px 4px;
  background: transparent;
  border: 0;
  color: var(--ui-accent);
  flex-shrink: 0;
  max-width: 320px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}

.picker-breadcrumbs button[aria-current] {
  color: var(--ui-ink);
  font-weight: 600;
}

.picker-search {
  display: flex;
  gap: 8px;
  margin: 12px 0 16px;
  flex-shrink: 0;
}

.picker-search input {
  min-width: 0;
}

.picker-files {
  flex: 1;
  overflow: auto;
  min-height: 0;
  scrollbar-color: var(--ui-control) var(--ui-soft);
}

.picker-column-heading, .picker-file-row {
  display: grid;
  grid-template-columns: 20px minmax(0, 1fr) 112px;
  gap: 12px;
  align-items: center;
  padding: 10px 12px;
}

.picker-column-heading {
  background: var(--ui-soft);
  color: var(--ui-muted);
  font-size: 13px;
  position: sticky;
  top: 0;
  z-index: 1;
}

.picker-file-row {
  min-height: 54px;
  border-bottom: 1px solid var(--ui-line);
}

.picker-file-row:hover {
  background: var(--ui-soft);
}

.picker-file-row.picker-checked {
  background: var(--ui-selected);
}

.picker-file-name {
  display: flex;
  align-items: center;
  gap: 10px;
  text-align: left;
  color: var(--ui-ink);
  border: 0;
  background: transparent;
  min-width: 0;
  padding: 6px 0;
  cursor: pointer;
}

.picker-file-name span {
  overflow-wrap: anywhere;
  flex: 1;
}

.picker-file-name .fa-chevron-right {
  font-size: 11px;
  color: var(--ui-muted);
}

.picker-file-name .fa-file-pdf {
  color: var(--ui-danger);
}

.picker-file-state {
  color: var(--ui-muted);
  font-size: 13px;
}

.picker-parent {
  display: flex;
  align-items: center;
  gap: 14px;
  min-height: 48px;
  padding: 10px 12px 10px 44px;
  width: 100%;
  border: 0;
  background: transparent;
  color: var(--ui-accent);
  cursor: pointer;
  text-align: left;
}

.picker-parent:hover {
  background: var(--ui-soft);
}

.picker-empty {
  padding: 40px 12px;
  color: var(--ui-muted);
  flex: 1;
}

.picker-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 0;
  color: var(--ui-muted);
  flex-shrink: 0;
  font-size: 13px;
}

.picker-pagination > div {
  display: flex;
  align-items: center;
  gap: 12px;
}

.picker-pagination .button {
  padding: 7px 10px;
  min-height: 36px;
}

.picker-selection {
  border-left: 1px solid var(--ui-line);
  padding: 20px;
  overflow: auto;
  background: var(--ui-soft);
  min-width: 0;
}

.picker-selection h3 {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 14px;
}

.picker-selection h3 span {
  color: var(--ui-accent);
  margin-left: 8px;
}

.picker-selection p {
  color: var(--ui-muted);
  font-size: 14px;
}

.picker-selection ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.picker-selection li {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 12px 0;
  border-bottom: 1px solid var(--ui-line);
}

.picker-selection li > div {
  flex: 1;
  min-width: 0;
}

.picker-selection strong {
  font-size: 14px;
  font-weight: 550;
  overflow-wrap: anywhere;
}

.picker-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 28px;
  border-top: 1px solid var(--ui-line);
  flex-shrink: 0;
}

.picker-footer > div {
  display: flex;
  gap: 8px;
}

.picker-folder-note {
  color: var(--ui-muted);
  font-size: 13px;
}

@media (max-width: 767px) {
  .source-picker {
    width: calc(100vw - 16px);
    height: calc(100dvh - 24px);
    max-height: calc(100dvh - 16px);
  }
  .picker-header {
    padding: 16px;
    gap: 8px;
  }
  .picker-header h2 {
    font-size: 20px;
  }
  .picker-header p {
    font-size: 13px;
  }
  .picker-body {
    display: flex;
    flex-direction: column;
    overflow: auto;
  }
  .picker-browser {
    padding: 8px 12px 0;
    flex: 1 0 300px;
  }
  .picker-selection {
    border-left: 0;
    border-top: 1px solid var(--ui-line);
    padding: 12px 16px;
    max-height: 160px;
    flex-shrink: 0;
  }
  .picker-selection h3 {
    margin-bottom: 6px;
  }
  .picker-selection li {
    padding: 8px 0;
  }
  .picker-column-heading, .picker-file-row {
    grid-template-columns: 20px minmax(0, 1fr);
    gap: 8px;
    padding: 10px 8px;
  }
  .picker-column-heading > span:last-child {
    display: none;
  }
  .picker-file-state {
    grid-column: 2;
    margin-top: -6px;
  }
  .picker-footer {
    padding: 12px;
    gap: 8px;
    flex-wrap: wrap;
  }
  .picker-footer > div {
    margin-left: auto;
  }
  .picker-folder-note {
    display: none;
  }
  .picker-pagination {
    gap: 6px;
  }
}
/* Inline material preview and a shared navigation row for QA + evidence. */
.source-preview {
  position: relative;
  display: grid;
  grid-template-columns: 240px minmax(0, 1fr);
  grid-template-rows: auto 1fr;
  background: var(--ui-soft);
  border: 0;
  border-top: 1px solid var(--ui-line);
  overflow: hidden;
  scroll-margin-top: 88px;
}

.source-preview header {
  grid-column: 1;
  border: 0;
}

.source-preview .preview-controls {
  grid-column: 1;
  border: 0;
  align-self: start;
}

.source-preview .preview-text, .source-preview > .inline-empty, .source-preview > .message {
  grid-column: 2;
  grid-row: 1/3;
  border-left: 1px solid var(--ui-line);
}

.source-preview header, .preview-controls {
  flex-shrink: 0;
}

.source-preview header h3 {
  outline-offset: 4px;
}

.source-preview .preview-text {
  min-height: 120px;
  max-height: 320px;
  overflow: auto;
}

.source-preview .inline-empty {
  padding: 16px;
}

.field-error {
  color: var(--ui-danger);
  font-size: 13px;
  margin: 6px 0;
}

.results-tools {
  display: grid;
  grid-template-columns: 260px minmax(0, 1fr);
  border: 1px solid var(--ui-line);
  border-bottom: 0;
  background: var(--ui-soft);
  min-height: 52px;
}

.results-tools .queue-heading {
  position: static;
  align-items: center;
  border-bottom: 0;
  border-right: 1px solid var(--ui-line);
  background: transparent;
}

.inspector-controls {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px 12px;
  min-width: 0;
}

.inspector-controls .inspector-state {
  flex-wrap: wrap;
}

.result-search {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 180px;
  max-width: 400px;
  margin-left: auto;
  background: var(--ui-paper);
  border: 1px solid var(--ui-line);
  border-radius: 6px;
  padding: 0 10px;
}

.result-search input {
  border: 0;
  margin: 0;
  min-width: 0;
  min-height: 36px;
  padding: 6px 0;
}

.result-search .text-button {
  flex-shrink: 0;
  padding: 8px 0;
}

.result-search > i {
  color: var(--ui-muted);
}

.result-jump {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: var(--ui-text);
}

.result-jump input {
  width: 64px;
  min-height: 34px;
  margin: 0;
  padding: 6px 8px;
}

.result-jump .button {
  min-height: 34px;
  padding: 6px 10px;
}

.settings-policies {
  display: flex;
  align-items: flex-start;
  gap: 24px;
  border-top: 1px solid var(--ui-line);
  margin-top: 12px;
  padding-top: 4px;
}

.settings-policies details {
  margin: 0;
  padding: 0;
  border: 0;
}

.settings-policies details[open] {
  flex: 1;
}

.settings-policies p {
  max-width: 70ch;
}

.settings-grid label {
  min-width: 0;
}

.question-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 6px;
}

.question-heading .qa-label {
  margin: 0;
}

.question-state {
  display: none;
}

.is-detail .workspace-toolbar {
  gap: 20px;
  min-height: 52px;
}

.item-navigation {
  gap: 6px;
}

.item-navigation .icon-button {
  width: 34px;
  height: 34px;
  flex-shrink: 0;
}

.inspector-controls > .text-button {
  flex-shrink: 0;
}

@media (max-width: 1279px) {
  .results-tools {
    grid-template-columns: 220px minmax(0, 1fr);
  }
  .inspector-controls {
    gap: 8px;
  }
  .inspector-controls .inspector-state small {
    display: none;
  }
}
@media (max-width: 1050px) {
  .is-detail .workspace-toolbar {
    flex-wrap: wrap;
    gap: 8px 16px;
    padding: 4px 0 8px;
  }
  .workspace-tabs {
    width: 100%;
  }
  .result-search {
    max-width: none;
    margin-left: 0;
  }
  .result-toolbar {
    padding: 0;
  }
  .settings-grid {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }
  .settings-grid .name-field {
    grid-column: 1/-1;
  }
}
@media (max-width: 1050px) {
  .inspection-columns {
    overflow: visible;
    flex: none;
  }
}
@media (max-width: 767px) {
  .source-preview {
    display: flex;
    flex-direction: column;
    scroll-margin-top: 112px;
  }
  .source-preview .preview-text, .source-preview > .inline-empty, .source-preview > .message {
    border-left: 0;
    border-top: 1px solid var(--ui-line);
  }
  .source-preview .preview-text {
    max-height: 280px;
  }
  .results-tools {
    grid-template-columns: minmax(0, 1fr);
  }
  .results-tools .queue-heading {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    border: 0;
    clip-path: inset(50%);
    overflow: hidden;
  }
  .inspector-controls {
    gap: 8px;
    flex-wrap: wrap;
    padding: 8px;
  }
  .inspector-controls .inspector-state {
    display: none;
  }
  .inspector-controls .inspector-state small {
    display: none;
  }
  .inspector-controls > .text-button {
    order: -1;
    margin-left: 0;
    padding: 8px 4px;
  }
  .creation-footer {
    position: static;
  }
  .question-state {
    display: inline-flex;
  }
  .result-search {
    min-width: 0;
  }
  .result-toolbar label {
    font-size: 0;
    gap: 0;
  }
  .result-toolbar select {
    width: 104px;
    min-height: 36px;
  }
  .item-navigation {
    gap: 4px;
    margin-left: auto;
  }
  .item-navigation .icon-button {
    width: 36px;
    height: 36px;
  }
  .result-jump input {
    width: 56px;
    min-height: 36px;
  }
  .result-jump .button {
    min-height: 36px;
  }
  .settings-policies {
    gap: 8px 20px;
    flex-wrap: wrap;
  }
  .settings-policies details[open] {
    flex-basis: 100%;
  }
  .settings-grid {
    gap: 12px;
  }
  .quantity-field input {
    width: 90px;
  }
  .preview-controls select {
    max-width: 75%;
  }
  .source-empty {
    min-height: 0;
    padding: 28px 16px;
  }
}
/* QA review extends the existing KIOM workbench. */
.qa-workbench {
  height: max(550px, 100dvh - 280px);
}

.inspection-columns {
  grid-template-columns: minmax(0, 1fr) minmax(300px, 0.8fr);
}

.qa-question .question-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
}

.qa-question .question-heading .qa-label {
  margin: 0;
}

.qa-label {
  display: block;
  font-size: 14px;
  font-weight: 650;
  color: var(--ui-text);
}

.result-meta, .result-meta .state {
  font-size: 12px;
}

.qa-result-row strong {
  font-size: 15px;
  font-weight: 550;
}

.qa-reading textarea {
  display: block;
  width: 100%;
  padding: 12px;
  border: 1px solid var(--ui-control);
  border-radius: 6px;
  color: var(--ui-ink);
  background: var(--ui-paper);
  font: 500 16px/1.75 Pretendard, sans-serif;
  resize: vertical;
  caret-color: var(--ui-accent);
}

.qa-reading textarea.review-question-input {
  font-weight: 650;
  font-size: 18px;
}

.review-taxonomy {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin: 20px 0;
}

.review-taxonomy label, .review-fields label {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: var(--ui-text);
}

.review-taxonomy select {
  width: 100%;
}

.evidence-item .evidence-quotes blockquote {
  padding: 0;
  margin: 12px 0;
  border: 0;
  background: transparent;
  color: var(--ui-ink);
  font-size: 15px;
  line-height: 1.85;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.source-context {
  margin: 12px 0;
}

.source-context > summary {
  color: var(--ui-muted);
  font-size: 13px;
}

.source-evidence > h3 {
  font-size: 16px;
}

.source-change {
  display: block;
  color: var(--ui-warning);
  font-size: 13px;
  margin-top: 8px;
}

.review-disclosure p, .review-history-item dd {
  font-size: 14px;
  line-height: 1.75;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.review-disclosure small {
  display: block;
  color: var(--ui-muted);
  font-size: 12px;
  line-height: 1.6;
}

.review-history-item {
  padding: 14px 0;
  border-bottom: 1px solid var(--ui-line);
}

.review-history-item summary {
  font-size: 14px;
}

.review-history-item dt {
  margin-top: 12px;
  color: var(--ui-muted);
  font-size: 13px;
}

.review-history-item dd {
  margin: 4px 0;
}

.review-bar {
  flex: none;
  background: var(--ui-paper);
  border-top: 1px solid var(--ui-line);
  padding: 14px 20px 10px;
}

.review-fields {
  display: flex;
  align-items: end;
  gap: 12px;
}

.decision-field {
  width: 142px;
  flex: none;
}

.review-note-field {
  flex: 1;
  min-width: 80px;
}

.review-fields input, .review-fields select {
  width: 100%;
  min-height: 36px;
  font-size: 13px;
}

.review-save-actions {
  display: flex;
  gap: 8px;
  flex: none;
}

.review-save-actions button {
  min-height: 36px;
  white-space: nowrap;
}

.review-bar-note {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 4px 14px;
  font-size: 12px;
  line-height: 1.6;
  color: var(--ui-muted);
  margin-top: 8px;
}

.review-bar-note [role=status] {
  color: var(--ui-accent-hover);
}

.review-feedback {
  font-size: 14px;
  line-height: 1.6;
  margin: 0 0 10px;
  color: var(--ui-danger);
}

.review-fields input::placeholder {
  color: var(--ui-muted);
  opacity: 1;
}

.qa-inspector :is(textarea, input, select, button):focus-visible {
  outline: 2px solid var(--ui-accent);
  outline-offset: 3px;
}

.qa-inspector ::selection {
  background: var(--ui-selected);
  color: var(--ui-ink);
}

@media (max-width: 1279px) {
  .inspection-columns {
    grid-template-columns: minmax(0, 1fr) minmax(270px, 0.85fr);
  }
  .review-fields {
    flex-wrap: wrap;
  }
  .review-save-actions {
    margin-left: auto;
  }
}
@media (max-width: 1050px) {
  .qa-workbench {
    height: auto;
  }
  .inspection-columns {
    grid-template-columns: 1fr;
  }
  .review-bar {
    position: static;
  }
}
@media (max-width: 767px) {
  .review-bar {
    position: static;
    padding: 16px;
  }
  .review-fields {
    display: grid;
    grid-template-columns: 1fr 1.3fr;
    gap: 12px;
  }
  .decision-field {
    width: auto;
  }
  .review-save-actions {
    grid-column: 1/-1;
    width: 100%;
  }
  .review-save-actions button {
    flex: 1;
  }
  .qa-workbench {
    min-height: 0;
  }
  .qa-question h3 {
    font-size: 20px;
  }
  .qa-support {
    padding: 18px 16px;
  }
}
.merge-toolbar {
  display: flex;
  align-items: end;
  flex-wrap: wrap;
  gap: 12px;
  padding: 16px 18px;
  background: var(--ui-soft);
  border-bottom: 1px solid var(--ui-line);
}

.merge-toolbar > strong {
  align-self: center;
  white-space: nowrap;
}

.merge-toolbar > label {
  flex: 1 1 240px;
}

.merge-toolbar > .merge-target {
  flex: 0 1 140px;
}

.dataset-title-cell > .merge-checkbox {
  flex: 0 0 18px;
  margin: 0 4px 0 0;
  cursor: pointer;
}

.run-history {
  margin-top: 28px;
}

.run-history h3 {
  margin-bottom: 12px;
}

.run-history h3 span {
  margin-left: 8px;
  color: var(--ui-muted);
  font-weight: 500;
}

.run-history-row {
  display: grid;
  grid-template-columns: minmax(200px, 1fr) auto 110px 100px;
  align-items: center;
  gap: 12px 20px;
  padding: 16px 0;
  border-top: 1px solid var(--ui-line);
  font-variant-numeric: tabular-nums;
}

.run-name {
  min-width: 0;
  overflow-wrap: anywhere;
}

.run-actions {
  grid-column: 1/-1;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.run-actions:empty {
  display: none;
}

@media (max-width: 767px) {
  .merge-toolbar {
    padding: 14px;
    gap: 12px;
  }
  .merge-toolbar > strong, .merge-toolbar > label {
    flex-basis: 100%;
  }
  .merge-toolbar > .merge-target {
    flex: 1 1 120px;
  }
  .run-history-row {
    grid-template-columns: 1fr 1fr;
    gap: 10px;
  }
  .run-name {
    grid-column: 1/-1;
  }
  .run-history-row > .state {
    justify-self: start;
  }
}
/* Review work, generation provenance and collection management have distinct hierarchy. */
.heading-actions, .review-start-actions, .execution-heading {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.execution-heading {
  justify-content: space-between;
}

.dataset-title-cell {
  justify-content: flex-start;
}

.dataset-name {
  display: inline-flex;
  align-items: center;
  min-height: 44px;
}

.merge-check {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 44px;
  height: 44px;
  flex: 0 0 44px;
  cursor: pointer;
  margin: 0;
}

.merge-check input {
  margin: 0;
}

.merge-help, .merge-outcome, .merge-error {
  flex: 1 0 100%;
  margin: 0;
  font-size: 14px;
  line-height: 1.6;
}

.merge-help, .merge-outcome {
  color: var(--ui-text);
}

.merge-error {
  color: var(--ui-danger);
}

.table-review {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
  min-width: 145px;
}

.table-review strong {
  font-size: 15px;
}

.table-review progress {
  width: 140px;
  max-width: 100%;
  height: 5px;
}

.table-review small {
  margin: 0;
}

.auto-attention, .row-hold-reason {
  color: var(--ui-warning);
}

.result-meta {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.row-hold-reason {
  margin-top: 8px;
  font-size: 13px;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.review-overview {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 0;
  border-bottom: 1px solid var(--ui-line);
}

.review-progress-copy {
  display: grid;
  grid-template-columns: auto minmax(100px, 190px);
  gap: 7px 16px;
  align-items: center;
}

.review-progress-copy > strong {
  font-size: 18px;
  font-weight: 650;
}

.review-progress-copy > progress {
  height: 6px;
  width: 100%;
}

.review-progress-copy > span {
  grid-column: 1/-1;
  color: var(--ui-muted);
  font-size: 14px;
}

.remaining-count {
  color: var(--ui-ink);
  margin-left: 16px;
  font-weight: 600;
}

.attention-button {
  color: var(--ui-warning);
  background: var(--ui-paper);
  border-color: #b79770;
}

.attention-button:hover:not(:disabled) {
  background: #fff6e9;
}

.review-finished {
  color: var(--ui-success);
  font-weight: 600;
}

.review-guide {
  padding: 2px 0;
  color: var(--ui-text);
}

.review-guide summary {
  cursor: pointer;
  width: fit-content;
  padding: 10px 0;
  min-height: 44px;
  font-size: 14px;
}

.review-guide p {
  margin: 0 0 12px;
  max-width: 85ch;
}

.review-guide kbd {
  font: inherit;
  padding: 2px 5px;
  border: 1px solid var(--ui-line);
  border-radius: 3px;
}

.execution-overview {
  margin-bottom: 0;
}

.execution-info > .generation-progress {
  max-width: 800px;
  padding: 16px 0;
}

.execution-settings {
  margin-top: 12px;
}

.execution-settings > summary {
  cursor: pointer;
  min-height: 44px;
  padding: 10px 0;
  font-size: 15px;
  font-weight: 600;
}

.run-filter-note {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 16px;
  padding: 8px 16px;
  background: var(--ui-selected);
  border-bottom: 1px solid var(--ui-line);
  font-size: 14px;
}

.run-filter-note > span {
  flex: 1 1 300px;
  overflow-wrap: anywhere;
}

.run-actions {
  align-items: center;
}

.run-actions .muted {
  font-size: 13px;
}

.reading-taxonomy {
  color: var(--ui-muted);
  font-size: 14px;
  padding-top: 16px;
}

.reading-jumps {
  display: none;
}

#qa-answer-region, #qa-evidence-region, #qa-decision-region, #qa-inspector {
  scroll-margin-top: 116px;
}

.datasets-content .button, .datasets-content .text-button {
  min-height: 36px;
}

.result-search .text-button {
  min-width: 44px;
  padding: 8px;
}

.result-search input {
  min-height: 36px;
}

.result-toolbar select {
  min-height: 36px;
  font-size: 13px;
  width: auto;
  max-width: 190px;
}

.item-navigation .icon-button {
  width: 36px;
  height: 36px;
}

.result-jump input, .result-jump .button {
  min-height: 36px;
}

.evidence-item > a {
  display: inline-flex;
  align-items: center;
  min-height: 44px;
  padding: 6px 4px;
}

.source-context > summary, .evidence-item > summary, .review-disclosure > summary {
  min-height: 44px;
  padding-top: 10px;
  padding-bottom: 10px;
}

.datasets-content small, .result-meta, .result-meta .state, .review-bar-note, .state {
  font-size: 13px;
}

.qa-workbench {
  height: max(530px, 100dvh - 385px);
}

.qa-inspector .review-save-actions {
  flex-wrap: wrap;
}

.qa-inspector .review-bar {
  flex-shrink: 0;
}

@media (max-width: 1050px) {
  .review-overview {
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 12px;
  }
  .review-start-actions {
    margin-left: auto;
  }
  .qa-workbench {
    display: block;
    height: auto;
  }
  .qa-list-pane {
    height: auto;
    max-height: none;
  }
  .has-selection .qa-list-pane {
    display: none;
  }
  .qa-workbench:not(.has-selection) .inspector-empty {
    display: none;
  }
  .results-tools {
    grid-template-columns: minmax(0, 1fr);
  }
  .results-tools .queue-heading {
    display: none;
  }
  .inspector-controls {
    justify-content: space-between;
  }
  .qa-inspector {
    height: auto;
    overflow: visible;
  }
  .inspection-columns {
    display: block;
    overflow: visible;
  }
  .review-bar {
    position: static;
  }
  .reading-jumps {
    display: flex;
    align-items: center;
    gap: 12px;
    position: sticky;
    top: 100px;
    z-index: 3;
    background: var(--ui-paper);
    border-bottom: 1px solid var(--ui-line);
    padding: 0 12px;
  }
  .reading-jumps button {
    flex: 1;
  }
  #qa-answer-region, #qa-evidence-region, #qa-decision-region, #qa-inspector {
    scroll-margin-top: 160px;
  }
  .review-fields {
    flex-wrap: wrap;
  }
}
@media (max-width: 767px) {
  .page-heading {
    flex-wrap: wrap;
    gap: 10px;
  }
  .heading-actions {
    width: 100%;
    justify-content: flex-end;
  }
  .review-progress-copy {
    grid-template-columns: auto minmax(80px, 1fr);
    width: 100%;
    gap: 6px 12px;
  }
  .review-progress-copy > strong {
    font-size: 17px;
  }
  .review-start-actions {
    width: 100%;
    margin: 0;
  }
  .review-start-actions > .button {
    flex: 1;
    padding: 8px;
    font-size: 13px;
  }
  .review-start-actions > .review-finished {
    font-size: 14px;
  }
  .dataset-title-cell {
    align-items: center;
    gap: 8px;
  }
  .dataset-name {
    flex: 1;
  }
  .table-review {
    min-width: 0;
  }
  .table-review strong {
    font-size: 14px;
  }
  .datasets-content .dataset-table td:nth-child(3) {
    font-size: 13px;
  }
  .datasets-content .dataset-table td:nth-child(4), .datasets-content .dataset-table .date {
    font-size: 13px;
  }
  .review-bar .review-fields {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1.2fr);
  }
  .review-save-actions button {
    padding: 8px;
  }
  .run-history-row {
    gap: 8px;
  }
  .item-navigation {
    gap: 2px;
  }
  .result-jump {
    gap: 4px;
  }
  .result-jump input {
    width: 48px;
  }
  .inspector-controls {
    padding: 6px;
    gap: 4px;
  }
  .inspector-controls > .text-button {
    padding: 4px;
    font-size: 13px;
  }
  .result-jump .button {
    padding: 6px;
  }
  .result-search {
    flex-basis: 100%;
  }
  .result-toolbar {
    margin-left: auto;
  }
}
@media (max-width: 1050px) {
  .has-question .execution-overview, .has-question .review-guide {
    display: none;
  }
  .has-question .review-overview {
    padding: 8px 0 12px;
  }
  .has-question .review-progress-copy > progress {
    display: none;
  }
}
@media (max-width: 767px) {
  .result-search {
    flex: 1 1 130px;
  }
  .has-question .review-progress-copy {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  .has-question .review-progress-copy > span {
    font-size: 13px;
  }
}
@media (min-width: 768px) and (max-width: 1050px) {
  .datasets-content .dataset-table, .datasets-content .dataset-table tbody {
    display: block;
  }
  .datasets-content .dataset-table thead {
    display: none;
  }
  .datasets-content .dataset-table tr {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: 10px 24px;
    padding: 16px 20px;
    border-bottom: 1px solid var(--ui-line);
  }
  .datasets-content .dataset-table tr:last-child {
    border-bottom: 0;
  }
  .datasets-content .dataset-table td {
    display: block;
    height: auto;
    min-width: 0;
    max-width: none;
    padding: 0;
    border: 0;
    white-space: normal;
  }
  .datasets-content .dataset-table td:first-child {
    grid-column: 1/-1;
  }
  .datasets-content .dataset-table td:nth-child(3), .datasets-content .dataset-table .date {
    text-align: right;
  }
  .datasets-content .dataset-table td:nth-child(3) > span {
    white-space: nowrap;
  }
  .dataset-table .dataset-title-cell {
    flex-wrap: nowrap;
  }
  .dataset-table .dataset-type {
    margin-left: auto;
  }
  .dataset-table .table-review {
    min-width: 0;
  }
}
.export-workspace {
  max-width: 1100px;
  padding: 24px;
}

.export-summary {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px 20px;
  padding: 20px 0 16px;
  border-bottom: 1px solid var(--ui-line);
}

.export-summary > strong {
  font-size: 20px;
}

.export-summary > span {
  color: var(--ui-muted);
}

.export-summary > .button {
  margin-left: auto;
}

.export-held {
  color: var(--ui-warning);
  margin-top: 16px;
}

.export-reasons {
  margin: 12px 0;
  padding-left: 20px;
  line-height: 1.9;
}

.export-format {
  margin-top: 16px;
}

.export-boundary {
  font-size: 13px;
}

.export-history {
  margin-top: 28px;
}

.export-history-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 0;
  border-bottom: 1px solid var(--ui-line);
}

.export-history-row:last-child {
  border-bottom: 0;
}

@media (max-width: 767px) {
  .export-workspace {
    padding: 16px;
  }
  .export-workspace .section-heading {
    flex-wrap: wrap;
    gap: 4px;
  }
  .export-summary {
    gap: 8px 12px;
  }
  .export-summary > .button {
    width: 100%;
    margin: 4px 0 0;
  }
  .export-history-row {
    gap: 8px;
  }
  .export-history-row .button {
    padding: 8px;
  }
}
/* Dataset layout: identity, navigation and task-specific work surfaces. */
:host {
  background: var(--ui-soft);
}

.datasets-content {
  min-height: calc(100dvh - 64px);
  font-size: 15px;
}

.datasets-content .page-heading {
  margin-bottom: 20px;
  gap: 20px;
}

.detail-heading-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: none;
}

.detail-heading-actions .button {
  min-height: 36px;
}

.detail-heading-actions .refresh-detail {
  width: 36px;
  padding: 0;
}

.dataset-identity {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px 16px;
  margin-top: 10px;
  color: var(--ui-muted);
  font-size: 14px;
}

.dataset-identity > span:last-child {
  display: flex;
  align-items: center;
  gap: 6px;
}

.datasets-content .panel, .creation-frame {
  border: 1px solid var(--ui-line);
  background: var(--ui-paper);
  border-radius: 8px;
}

.datasets-content .detail-workspace {
  overflow: clip;
}

.datasets-content h2 {
  font-size: 20px;
  line-height: 1.45;
}

.datasets-content h3 {
  font-size: 16px;
}

.datasets-content .collection-toolbar {
  padding: 20px 24px;
  gap: 12px;
  background: var(--ui-paper);
}

.datasets-content .dataset-table th {
  padding: 14px 24px;
  font-size: 14px;
  background: var(--ui-canvas);
  border-top: 1px solid var(--ui-line);
}

.datasets-content .dataset-table td {
  padding: 20px 24px;
}

.dataset-symbol {
  color: var(--ui-accent);
  font-size: 22px;
  flex: none;
}

.dataset-title-cell {
  flex-wrap: nowrap;
}

.dataset-title-cell .dataset-name {
  font-size: 17px;
  font-weight: 650;
}

.dataset-type {
  margin-left: auto;
}

.compact-column-label {
  display: none;
}

.automatic-count {
  display: block;
  margin-bottom: 8px;
  white-space: nowrap;
}

.dataset-table .table-review strong {
  font-size: 16px;
}

.dataset-table .table-review progress {
  height: 6px;
}

.dataset-table .table-review small {
  font-size: 14px;
}

.dataset-table td .state {
  width: fit-content;
  font-size: 13px;
}

.datasets-content .register-footer {
  background: var(--ui-soft);
  padding: 16px 24px;
}

.datasets-content .workspace-toolbar {
  padding: 0 20px;
  background: var(--ui-canvas);
  min-height: 60px;
  border-bottom: 1px solid var(--ui-line);
}

.workspace-tabs {
  gap: 8px;
  align-self: stretch;
  align-items: stretch;
}

.workspace-tabs button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 20px;
  min-height: 60px;
  font-size: 15px;
  border: 0;
  border-radius: 0;
  color: var(--ui-text);
}

.workspace-tabs button[aria-pressed=true] {
  background: var(--ui-paper);
  color: var(--ui-accent);
  box-shadow: inset 0 -3px var(--ui-accent);
}

.workspace-tabs button:hover:not([aria-pressed=true]) {
  background: var(--ui-canvas);
}

.workspace-tabs button span {
  margin: 0;
  padding: 1px 6px;
  background: var(--ui-selected);
  border-radius: 4px;
  font-size: 13px;
}

.qa-results .review-overview {
  padding: 16px 24px;
  border-bottom: 1px solid var(--ui-line);
  background: var(--ui-paper);
}

.qa-results .review-progress-copy {
  grid-template-columns: auto 120px;
  gap: 6px 16px;
}

.qa-results .review-progress-copy > strong {
  font-size: 17px;
}

.qa-results .review-progress-copy > span {
  font-size: 13px;
}

.qa-results .review-start-actions .button {
  min-height: 36px;
}

.qa-filterbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  padding: 14px 24px;
  background: var(--ui-soft);
  border-bottom: 1px solid var(--ui-line);
}

.qa-filterbar .result-search {
  margin: 0;
  max-width: 540px;
  flex: 1;
  min-width: 120px;
}

.qa-filterbar .result-toolbar {
  padding: 0;
  margin: 0;
}

.datasets-content .qa-filterbar .review-guide {
  display: block;
  margin-left: auto;
  padding: 0;
}

.qa-filterbar .review-guide summary {
  min-height: 44px;
  padding: 10px 4px;
}

.qa-filterbar .review-guide[open] {
  flex-basis: 100%;
}

.qa-filterbar .review-guide p {
  padding: 8px 0 0;
  max-width: 90ch;
  font-size: 14px;
}

.datasets-content .results-tools {
  border: 0;
  border-bottom: 1px solid var(--ui-line);
  background: var(--ui-paper);
}

.results-tools .queue-heading {
  background: var(--ui-canvas);
  font-size: 15px;
}

.datasets-content .qa-workbench {
  border: 0;
  height: max(610px, 100dvh - 390px);
}

.qa-list-pane {
  background: var(--ui-soft);
}

.qa-result-row {
  padding: 18px 32px 18px 20px;
  background: transparent;
}

.qa-result-row strong {
  font-size: 16px;
  line-height: 1.6;
}

.qa-result-row.selected {
  background: var(--ui-selected);
}

.qa-result-row.selected strong {
  color: var(--ui-accent-hover);
  font-weight: 650;
}

.qa-reading {
  padding: 0 24px 24px;
  background: var(--ui-paper);
}

.qa-reading .qa-question {
  margin: 0 -24px 24px;
  padding: 16px 24px 24px;
  background: var(--ui-soft);
  border-bottom: 1px solid var(--ui-line);
}

.qa-question h3 {
  font-size: 23px;
  line-height: 1.55;
}

.qa-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  margin-bottom: 12px;
}

.qa-label > i {
  color: var(--ui-accent);
}

.qa-answer {
  font-size: 17px;
  line-height: 1.9;
  max-width: 72ch;
}

.reading-taxonomy {
  border-top: 1px solid var(--ui-line);
  margin-top: 24px;
  padding-top: 16px;
  font-size: 14px;
}

.qa-support {
  padding: 20px;
  background: var(--ui-selected);
  border-left: 1px solid var(--ui-line);
}

.source-evidence > h3 {
  padding-bottom: 16px;
  border-bottom: 1px solid var(--ui-line);
  margin-bottom: 4px;
}

.source-evidence > h3 .support-title {
  display: flex;
  gap: 8px;
  align-items: center;
  color: var(--ui-ink);
  font-size: 16px;
  font-weight: 650;
}

.evidence-item summary {
  font-size: 14px;
  font-weight: 600;
}

.evidence-item .evidence-quotes blockquote {
  background: var(--ui-paper);
  padding: 16px;
  border: 1px solid var(--ui-line);
  line-height: 1.85;
  font-size: 15px;
}

.evidence-item .evidence-quotes blockquote p {
  margin: 0;
  font-size: inherit;
  line-height: inherit;
}

.review-disclosure {
  margin-top: 16px;
  padding-top: 8px;
}

.qa-inspector .review-bar {
  background: var(--ui-soft);
  padding: 18px 20px 12px;
  border-top: 1px solid var(--ui-control);
}

.review-fields label {
  font-size: 14px;
  font-weight: 650;
}

.review-fields input, .review-fields select {
  background: var(--ui-paper);
}

.datasets-content .detail-tab-content {
  padding: 28px;
}

.datasets-content .export-workspace {
  padding: 0;
  max-width: none;
}

.export-heading {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  padding: 24px 28px;
  border-bottom: 1px solid var(--ui-line);
}

.export-heading p {
  font-size: 14px;
  margin-top: 6px;
}

.export-layout {
  display: grid;
  grid-template-columns: minmax(0, 1.5fr) minmax(300px, 1fr);
}

.export-preparation {
  padding: 28px;
  min-width: 0;
}

.export-preparation > h3 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.section-meta {
  color: var(--ui-muted);
  font-size: 13px;
  font-weight: 450;
}

.export-summary {
  padding: 16px 0;
  gap: 12px 20px;
}

.export-summary > strong {
  display: flex;
  gap: 8px;
  align-items: center;
  font-size: 22px;
}

.export-summary > strong > i {
  color: var(--ui-accent);
  font-size: 20px;
}

.export-held {
  display: flex;
  gap: 12px;
  padding: 14px 16px;
  background: #fff4e3;
  border: 1px solid #dfc6a4;
  color: var(--ui-warning);
  margin-top: 16px;
}

.export-held > i {
  margin-top: 3px;
}

.export-held p {
  margin: 4px 0 0;
  font-size: 14px;
}

.export-reasons {
  padding: 0;
  list-style: none;
}

.export-reasons li {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid var(--ui-line);
  font-size: 14px;
}

.export-contents {
  margin-top: 28px;
}

.export-file {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 0;
  border-bottom: 1px solid var(--ui-line);
}

.export-file > i {
  font-size: 22px;
  color: var(--ui-muted);
  width: 24px;
  text-align: center;
}

.export-file div {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.export-file strong {
  font-size: 15px;
  font-weight: 650;
}

.export-file span {
  font-size: 14px;
  color: var(--ui-muted);
}

.export-create {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding-top: 24px;
}

.export-create .button {
  min-width: 140px;
}

.export-create p {
  flex: 1 1 180px;
  margin: 0;
  font-size: 13px;
}

.export-layout .export-history {
  margin: 0;
  padding: 28px;
  background: var(--ui-soft);
  border-left: 1px solid var(--ui-line);
}

.export-history > h3 {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--ui-line);
}

.export-history-row {
  flex-wrap: wrap;
  padding: 20px 0;
  gap: 16px;
}

.export-version {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.export-version small {
  flex-basis: 100%;
  margin: 0;
  font-size: 14px;
}

.version-label {
  background: var(--ui-selected);
  color: var(--ui-accent-hover);
  padding: 5px 10px;
  font-size: 16px;
  font-weight: 700;
  border-radius: 4px;
}

.latest-label {
  font-size: 12px;
  color: var(--ui-accent-hover);
}

.export-version > strong {
  margin-left: 8px;
  font-weight: 600;
}

.export-history-empty {
  padding: 40px 0;
  text-align: center;
  color: var(--ui-muted);
}

.export-history-empty > i {
  font-size: 32px;
  margin-bottom: 8px;
}

.execution-info > .generation-progress {
  max-width: none;
  background: var(--ui-paper);
  padding: 20px 0;
  margin: 20px 0;
  border-block: 1px solid var(--ui-line);
}

.execution-settings {
  padding: 0;
  border: 0;
  border-bottom: 1px solid var(--ui-line);
  background: var(--ui-paper);
}

.run-history > h3 {
  padding: 16px 0;
  margin: 0;
  background: var(--ui-paper);
  border-top: 1px solid var(--ui-line);
}

.run-history-row {
  padding: 20px;
  margin: 0;
}

.run-history-row:nth-child(odd) {
  background: var(--ui-paper);
}

.run-name strong {
  font-size: 16px;
  line-height: 1.6;
}

.snapshot-file > header {
  background: var(--ui-paper);
}

.settings {
  background: var(--ui-canvas);
}

.settings .panel-heading, .creation-materials .panel-heading {
  padding: 20px 24px 12px;
}

.settings-body {
  padding: 8px 24px 20px;
}

.creation-materials .panel-heading {
  border-bottom: 1px solid var(--ui-line);
  padding-bottom: 20px;
}

@media (max-width: 1279px) {
  .workspace-tabs button {
    padding: 0 16px;
  }
  .dataset-table td, .dataset-table th {
    padding-left: 16px;
    padding-right: 16px;
  }
  .export-layout {
    grid-template-columns: minmax(0, 1.25fr) minmax(280px, 1fr);
  }
  .export-preparation, .export-layout .export-history {
    padding: 24px;
  }
}
@media (max-width: 1050px) {
  .datasets-content .dataset-table td {
    padding: 0;
  }
  .datasets-content .dataset-table tr {
    padding: 20px;
    gap: 16px 24px;
  }
  .compact-column-label {
    display: block;
    color: var(--ui-muted);
    font-size: 13px;
    font-weight: 600;
    margin-bottom: 8px;
  }
  .datasets-content .dataset-table td:nth-child(3) {
    text-align: left;
  }
  .datasets-content .dataset-table .dataset-title-cell {
    align-items: center;
    justify-content: flex-start;
  }
  .datasets-content .dataset-table .dataset-name {
    flex: 1;
  }
  .dataset-table .table-review {
    gap: 6px;
  }
  .datasets-content .workspace-toolbar {
    flex-wrap: nowrap;
    padding: 0 16px;
  }
  .qa-results .review-progress-copy {
    grid-template-columns: 1fr;
  }
  .qa-results .review-progress-copy > progress {
    display: none;
  }
  .datasets-content .qa-workbench {
    height: auto;
  }
  .qa-support {
    border-left: 0;
    border-top: 1px solid var(--ui-line);
  }
  .export-layout {
    grid-template-columns: 1fr;
  }
  .export-layout .export-history {
    border-left: 0;
    border-top: 1px solid var(--ui-line);
  }
  .export-history-row {
    flex-wrap: nowrap;
  }
  .datasets-content .qa-filterbar .review-guide {
    margin-left: 0;
  }
}
@media (max-width: 767px) {
  .datasets-content {
    padding: 16px 12px 24px;
  }
  .datasets-content .page-heading {
    gap: 12px;
    margin-bottom: 16px;
  }
  .dataset-identity {
    font-size: 13px;
    gap: 6px 12px;
  }
  .datasets-content .collection-toolbar {
    padding: 16px;
  }
  .datasets-content .dataset-table tr {
    padding: 16px;
    gap: 16px;
  }
  .dataset-symbol {
    font-size: 18px;
  }
  .dataset-title-cell .dataset-name {
    font-size: 16px;
  }
  .datasets-content .dataset-table .table-review strong {
    font-size: 15px;
  }
  .datasets-content .dataset-table .table-review small {
    font-size: 13px;
  }
  .automatic-count {
    font-size: 13px;
  }
  .datasets-content .register-footer {
    padding: 14px 16px;
    align-items: flex-start;
  }
  .datasets-content .workspace-toolbar {
    padding: 0;
    min-height: 52px;
  }
  .workspace-tabs {
    gap: 0;
    width: 100%;
  }
  .workspace-tabs button {
    padding: 0 8px;
    flex: 1;
    min-height: 52px;
    font-size: 13px;
    gap: 5px;
  }
  .workspace-tabs button > i {
    display: none;
  }
  .workspace-tabs button span {
    padding: 0;
    background: none;
    font-size: 12px;
  }
  .qa-results .review-overview, .has-question .qa-results .review-overview {
    padding: 12px 14px;
    gap: 12px;
    flex-wrap: wrap;
  }
  .qa-results .review-progress-copy > strong {
    font-size: 16px;
  }
  .qa-results .review-progress-copy > span {
    font-size: 12px;
  }
  .qa-results .remaining-count {
    margin-left: 8px;
  }
  .qa-results .review-start-actions {
    flex: 0 1 auto;
    gap: 8px;
  }
  .qa-results .review-start-actions .button {
    padding: 8px;
    font-size: 12px;
    min-height: 44px;
    flex: 1;
  }
  .qa-filterbar {
    padding: 12px;
    gap: 8px;
  }
  .qa-filterbar .result-search {
    flex: 1;
    min-width: 0;
    padding: 0 8px;
    gap: 4px;
  }
  .qa-filterbar .result-search input {
    font-size: 13px;
  }
  .qa-filterbar .result-search .text-button {
    min-width: 44px;
    padding: 4px;
    font-size: 12px;
  }
  .qa-filterbar .result-toolbar select {
    max-width: 105px;
    font-size: 13px;
    padding: 8px 4px;
  }
  .qa-filterbar .review-guide {
    flex: none;
  }
  .qa-filterbar .review-guide summary {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 44px;
    height: 44px;
    padding: 0;
    list-style: none;
  }
  .qa-filterbar .review-guide summary::-webkit-details-marker {
    display: none;
  }
  .qa-filterbar .review-guide summary > span {
    display: none;
  }
  .qa-filterbar .review-guide[open] summary {
    width: auto;
    text-align: left;
  }
  .qa-filterbar .review-guide[open] summary > span {
    display: inline;
  }
  .qa-reading {
    padding: 0 16px 20px;
  }
  .qa-reading .qa-question {
    padding: 12px 16px 20px;
    margin: 0 -16px 20px;
  }
  .qa-question h3 {
    font-size: 21px;
  }
  .qa-answer {
    font-size: 16px;
  }
  .qa-support {
    padding: 20px 16px;
  }
  .qa-inspector .review-bar {
    padding: 16px;
  }
  .datasets-content .detail-tab-content {
    padding: 20px 16px;
  }
  .datasets-content .export-workspace {
    padding: 0;
  }
  .export-heading {
    padding: 20px 16px;
    gap: 8px;
    flex-wrap: wrap;
  }
  .export-heading h2 {
    font-size: 20px;
  }
  .export-heading .text-button {
    padding-left: 0;
  }
  .export-preparation, .export-layout .export-history {
    padding: 20px 16px;
  }
  .export-summary > strong {
    font-size: 20px;
  }
  .export-summary > span {
    font-size: 13px;
  }
  .export-held {
    padding: 12px;
    font-size: 14px;
  }
  .export-held p {
    font-size: 13px;
  }
  .export-create .button {
    width: 100%;
  }
  .export-history-row {
    flex-wrap: wrap;
  }
  .export-history-row .button {
    width: 100%;
  }
  .export-version small {
    font-size: 13px;
  }
  .settings .panel-heading, .creation-materials .panel-heading {
    padding: 16px;
  }
  .settings-body {
    padding: 0 16px 16px;
  }
}
/* Progressive disclosure keeps the reading task in the foreground. */
.qa-results .review-progress-copy {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 0 0 auto;
}

.qa-results .review-progress-copy > strong {
  white-space: nowrap;
}

.qa-results .review-progress-copy > progress {
  width: 120px;
  flex: none;
}

.qa-result-row strong {
  -webkit-line-clamp: 2;
}

.qa-result-row {
  padding-top: 14px;
  padding-bottom: 14px;
}

.inspector-controls .item-navigation {
  margin-left: auto;
}

.qa-details {
  border-top: 1px solid var(--ui-line);
  margin-top: 20px;
  padding-top: 8px;
}

.qa-details > summary, .export-contents > summary {
  min-height: 44px;
  padding: 12px 0;
  color: var(--ui-text);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.qa-details .reading-taxonomy {
  border: 0;
  margin: 0;
  padding: 12px 0;
  font-size: 14px;
}

.qa-details .issue-list {
  font-size: 14px;
}

.qa-details .review-disclosure {
  margin-top: 0;
  padding-top: 0;
}

.selected-attention {
  color: var(--ui-warning);
  margin-top: 20px;
}

.evidence-item > summary {
  display: list-item;
  font-size: 14px;
  line-height: 1.7;
  overflow-wrap: anywhere;
}

.evidence-page {
  white-space: nowrap;
  font-weight: 500;
}

.evidence-item .evidence-quotes blockquote {
  margin: 12px 0;
}

.evidence-actions {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 8px 20px;
}

.evidence-actions .source-context {
  flex: 1;
  margin: 0;
}

.evidence-actions .source-context[open] {
  flex-basis: 100%;
}

.evidence-version {
  display: block;
  color: var(--ui-muted);
  font-size: 13px;
  margin: 12px 0;
}

.evidence-actions a, .quote-toggle, .more-evidence {
  min-height: 44px;
  display: inline-flex;
  align-items: center;
}

.more-evidence {
  margin-top: 8px;
}

.review-fields .note-toggle {
  margin-right: auto;
  white-space: nowrap;
  min-height: 36px;
}

.review-save-actions {
  margin-left: auto;
}

.export-contents > summary {
  display: flex;
  align-items: center;
  gap: 12px;
}

.export-contents > summary::before {
  content: "";
  width: 7px;
  height: 7px;
  border-right: 1px solid currentColor;
  border-bottom: 1px solid currentColor;
  transform: rotate(-45deg);
}

.export-contents[open] > summary::before {
  transform: rotate(45deg);
}

.export-contents > summary span {
  font-weight: 400;
  color: var(--ui-muted);
}

.datasets-content .register-footer {
  justify-content: flex-end;
}

@media (max-width: 767px) {
  .qa-results .review-progress-copy {
    flex: 1;
    width: auto;
  }
  .qa-results .review-start-actions {
    width: auto;
  }
  .qa-results .review-start-actions {
    flex: 0 1 auto;
  }
  .qa-results .review-start-actions .button {
    padding: 8px 10px;
  }
  .qa-results .review-progress-copy > strong {
    font-size: 15px;
  }
  .qa-results .review-progress-copy > progress {
    display: none;
  }
  .qa-results .review-overview {
    gap: 8px;
  }
  .review-fields .note-toggle {
    justify-self: end;
    margin: 0;
  }
  .review-fields .review-note-field {
    grid-column: 1/-1;
  }
  .export-contents > summary {
    flex-wrap: wrap;
    gap: 8px;
  }
}
/* Research workspace: quiet chrome, cobalt wayfinding and open reading surfaces. */
:host {
  color: var(--ui-text);
  background: var(--ui-canvas);
  font-size: 13px;
  line-height: 1.55;
  min-height: calc(100dvh - var(--workspace-header-height, 0px));
}

button, input, select, textarea {
  font-family: inherit;
}

::selection {
  background: var(--ui-selected);
  color: var(--ui-ink);
}

:is(button, a, input, select, textarea, summary):focus-visible {
  outline: 2px solid var(--ui-accent);
  outline-offset: 3px;
}

.datasets-content {
  min-height: calc(100dvh - var(--workspace-header-height, 0px));
  padding: 16px var(--workspace-gutter, 16px);
  font-size: 13px;
}

.datasets-content .page-heading {
  min-height: 36px;
  margin-bottom: 12px;
  gap: 12px;
}

.datasets-content .page-heading h1 {
  font-size: 24px;
  line-height: 1.3;
  font-weight: 700;
  letter-spacing: -0.03em;
  color: var(--ui-ink);
}

.datasets-content h2 {
  font-size: 18px;
  color: var(--ui-ink);
}

.datasets-content h3 {
  color: var(--ui-ink);
}

.heading-count {
  font-size: 14px;
  margin-left: 8px;
}

.dataset-identity {
  margin-top: 4px;
  gap: 8px 12px;
  font-size: 13px;
}

.datasets-content .panel, .creation-frame {
  border-color: var(--ui-line);
  border-radius: 0 0 var(--ui-radius, 12px) var(--ui-radius, 12px);
  box-shadow: none;
  border-top: 0;
}

.dataset-type-switch {
  display: flex;
  align-items: stretch;
  gap: 8px;
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0 16px;
  border: 1px solid var(--ui-line);
  border-radius: var(--ui-radius, 12px) var(--ui-radius, 12px) 0 0;
  background: var(--ui-paper);
}

.datasets-content .dataset-type-switch .button {
  min-height: 42px;
  padding: 8px 8px;
  border: 0;
  border-bottom: 2px solid transparent;
  border-radius: 0;
  background: transparent;
  color: var(--ui-muted);
  font-size: 14px;
  font-weight: 550;
  box-shadow: none;
}

.datasets-content .dataset-type-switch .button[aria-pressed=true] {
  background: transparent;
  color: var(--ui-accent);
  border-bottom-color: var(--ui-accent);
  font-weight: 650;
  box-shadow: none;
}

.datasets-content .dataset-type-switch .button:hover {
  background: transparent;
  color: var(--ui-accent);
}

.datasets-content .button {
  min-height: 36px;
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 13px;
}

.datasets-content .text-button {
  min-height: 36px;
  padding: 6px 8px;
  font-size: 13px;
}

.datasets-content .secondary {
  border-color: var(--ui-control);
}

.datasets-content input:not([type=checkbox]), .datasets-content select {
  min-height: 36px;
  padding: 6px 10px;
  border-color: var(--ui-control);
  border-radius: 8px;
  font-size: 13px;
}

.datasets-content textarea {
  border-color: var(--ui-control);
  border-radius: 8px;
}

.datasets-content input::placeholder, .datasets-content textarea::placeholder {
  color: var(--ui-muted);
  opacity: 1;
}

.datasets-content .collection-search input, .datasets-content .result-search input {
  border: 0;
  border-radius: 0;
  padding-inline: 0;
}

.datasets-content .collection-toolbar {
  padding: 8px 16px;
  gap: 8px;
}

.collection-search, .result-search {
  border-color: var(--ui-control);
  border-radius: 8px;
  background: var(--ui-paper);
}

.collection-search:focus-within, .result-search:focus-within {
  border-color: var(--ui-accent);
}

.datasets-content .dataset-table th {
  padding: 10px 16px;
  background: var(--ui-soft);
  color: var(--ui-muted);
  font-size: 12px;
  font-weight: 600;
  border-top: 0;
}

.datasets-content .dataset-table td {
  padding: 12px 16px;
  font-size: 13px;
}

.dataset-title-cell .dataset-name {
  color: var(--ui-ink);
  font-size: 16px;
  font-weight: 650;
  line-height: 1.5;
}

.dataset-title-cell .dataset-name:hover {
  color: var(--ui-accent);
}

.dataset-symbol {
  color: var(--ui-muted);
  font-size: 18px;
}

.dataset-table .table-review strong {
  font-size: 14px;
  font-weight: 600;
  color: var(--ui-ink);
}

.dataset-table .table-review small, .automatic-count, .dataset-table td .state {
  font-size: 12px;
}

.dataset-table .table-review progress {
  height: 4px;
  margin-top: 6px;
}

.automatic-count {
  margin-bottom: 4px;
}

.datasets-content .register-footer {
  padding: 8px 16px;
  background: var(--ui-paper);
}

.datasets-content .workspace-toolbar {
  min-height: 40px;
  padding: 4px 12px;
  background: var(--ui-paper);
  border-bottom: 1px solid var(--ui-line);
}

.workspace-tabs {
  gap: 4px;
}

.workspace-tabs button {
  min-height: 32px;
  padding: 0 12px;
  border-radius: 7px;
  font-size: 13px;
  font-weight: 550;
  gap: 8px;
}

.workspace-tabs button[aria-pressed=true] {
  background: var(--ui-selected);
  color: var(--ui-accent);
  font-weight: 650;
  box-shadow: none;
}

.workspace-tabs button span {
  background: var(--ui-selected);
}

.qa-results .review-overview {
  padding: 6px 16px;
  gap: 12px;
  background: var(--ui-paper);
  border-bottom: 0;
}

.qa-results .review-progress-copy {
  gap: 12px;
}

.qa-results .review-progress-copy > strong {
  font-size: 13px;
  font-weight: 650;
}

.qa-results .review-progress-copy > progress {
  width: 100px;
  height: 4px;
  margin: 0;
}

.qa-filterbar {
  background: var(--ui-paper);
  padding: 8px 16px;
  gap: 8px;
}

.qa-filterbar .review-guide summary {
  min-height: 36px;
  padding: 6px 4px;
  font-size: 13px;
}

.datasets-content .results-tools {
  background: var(--ui-paper);
}

.results-tools .queue-heading {
  background: var(--ui-soft);
  font-size: 12px;
  font-weight: 600;
  color: var(--ui-muted);
  padding: 8px 14px;
}

.inspector-controls {
  padding: 4px 12px;
  gap: 8px;
}

.result-jump {
  gap: 6px;
}

.datasets-content .result-jump input {
  width: 56px;
}

.qa-list-pane {
  background: var(--ui-soft);
}

.qa-result-row {
  padding: 12px 28px 12px 14px;
  border-bottom-color: transparent;
}

.qa-result-row:hover {
  background: var(--ui-paper);
}

.qa-result-row .result-open {
  color: var(--ui-muted);
}

.qa-result-row.selected .result-open {
  color: var(--ui-accent);
}

.qa-result-row strong {
  font-size: 14px;
  line-height: 1.55;
  color: var(--ui-text);
}

.result-meta {
  margin-bottom: 6px;
}

.result-meta .state {
  padding: 0;
  border-radius: 0;
  background: transparent;
  font-size: 12px;
  font-weight: 500;
}

.qa-result-row.selected .state[data-tone=neutral] {
  color: var(--ui-accent-hover);
}

.qa-result-row.selected {
  background: var(--ui-selected);
}

.qa-result-row.selected strong {
  color: var(--ui-ink);
  font-weight: 650;
}

.qa-reading {
  padding: 0 20px 24px;
}

.qa-reading .qa-question {
  margin: 0 -20px 16px;
  padding: 12px 20px 16px;
  background: var(--ui-paper);
  border-bottom: 1px solid var(--ui-line);
}

.qa-question h3 {
  font-size: 22px;
  line-height: 1.55;
  font-weight: 650;
  letter-spacing: -0.025em;
  color: var(--ui-ink);
}

.qa-label {
  font-size: 13px;
  color: var(--ui-muted);
  margin-bottom: 8px;
}

.qa-answer {
  max-width: 72ch;
  font-size: 16px;
  line-height: 1.8;
  color: var(--ui-ink);
}

.qa-support {
  padding: 16px;
  background: var(--ui-paper);
}

.source-evidence > h3 {
  padding-bottom: 6px;
  border-bottom: 0;
}

.source-evidence > h3 .support-title {
  font-size: 15px;
}

.evidence-item {
  padding: 8px 0;
}

.evidence-item .evidence-quotes blockquote {
  border: 0;
  border-radius: 8px;
  background: var(--ui-soft);
  margin: 10px 0;
  padding: 14px;
  font-size: 16px;
  line-height: 1.8;
  color: var(--ui-text);
}

.qa-details {
  margin-top: 12px;
}

.qa-inspector .review-bar {
  background: var(--ui-paper);
  border-top-color: var(--ui-line);
  padding: 8px 12px;
}

.review-fields {
  gap: 8px;
}

.review-fields label {
  font-size: 12px;
  font-weight: 600;
  gap: 4px;
}

.review-fields label input, .review-fields label select {
  margin-top: 0;
}

.review-save-actions {
  gap: 8px;
}

.review-bar :is(input, select, button), .qa-reading :is(input, select, textarea, button) {
  scroll-margin-block: 16px;
}

.datasets-content .detail-tab-content {
  padding: 20px;
  line-height: 1.65;
}

.datasets-content .export-workspace {
  padding: 0;
}

.export-heading {
  padding: 16px 20px;
}

.export-preparation, .export-layout .export-history {
  padding: 20px;
}

.export-layout .export-history {
  background: var(--ui-paper);
}

.export-summary > strong {
  font-size: 20px;
  color: var(--ui-ink);
}

.export-held {
  border-radius: 6px;
}

.export-contents {
  margin-top: 16px;
}

.export-history-row {
  padding-block: 12px;
}

.settings {
  background: var(--ui-paper);
}

.settings .panel-heading, .creation-materials .panel-heading {
  padding: 12px 16px;
  gap: 12px;
}

.settings-body {
  padding: 0 16px 12px;
}

.material-heading {
  min-height: 48px;
}

.source-preview {
  background: var(--ui-paper);
}

.source-preview .preview-text {
  font-size: 16px;
  line-height: 1.8;
  color: var(--ui-text);
}

.source-picker {
  border-radius: var(--ui-radius, 12px);
  box-shadow: 0 24px 80px rgba(35, 39, 47, 0.1803921569);
}

.source-picker::backdrop {
  background: rgba(35, 39, 47, 0.4392156863);
}

.datasets-content .detail-workspace, .inspection-columns {
  position: relative;
}

@media (min-width: 1051px) {
  .datasets-content.is-detail:has(.qa-results) {
    display: flex;
    flex-direction: column;
    height: calc(100dvh - var(--workspace-header-height, 0px));
    min-height: 640px;
  }
  .is-detail:has(.qa-results) > .page-heading {
    flex: none;
    margin-bottom: 12px;
  }
  .is-detail:has(.qa-results) > .dataset-type-switch {
    flex: none;
  }
  .is-detail:has(.qa-results) > .detail-workspace {
    flex: 1 0 440px;
    min-height: 0;
    display: flex;
    flex-direction: column;
  }
  .is-detail .detail-workspace > .workspace-toolbar {
    flex: none;
  }
  .is-detail .qa-results {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
  }
  .qa-results > .review-overview, .qa-results > .qa-filterbar, .qa-results > .results-tools, .qa-results > .run-filter-note {
    flex: none;
  }
  .datasets-content .qa-workbench {
    height: auto;
    min-height: 240px;
    flex: 1;
    grid-template-columns: 224px minmax(0, 1fr);
  }
  .datasets-content .results-tools {
    grid-template-columns: 224px minmax(0, 1fr);
  }
  .qa-list-pane, .qa-inspector {
    min-height: 0;
  }
  .inspection-columns {
    grid-template-columns: minmax(0, 1fr) 310px;
  }
}
@media (min-width: 1051px) and (max-width: 1365px) {
  .inspection-columns {
    display: block;
  }
  .qa-support {
    border-left: 0;
    border-top: 1px solid var(--ui-line);
  }
  .qa-reading .qa-answer {
    max-width: 72ch;
  }
}
@media (min-width: 1366px) {
  .inspection-columns {
    display: grid;
    align-items: start;
  }
  .qa-support {
    min-height: 100%;
  }
}
@media (min-width: 961px) and (max-width: 1050px) {
  .reading-jumps {
    top: 0;
  }
  #qa-answer-region, #qa-evidence-region, #qa-decision-region, #qa-inspector {
    scroll-margin-top: 72px;
  }
}
@media (max-width: 1050px) {
  .datasets-content .qa-workbench {
    height: auto;
    min-height: 0;
  }
  .qa-inspector .review-bar {
    position: static;
  }
  .datasets-content .dataset-table td {
    padding: 0;
  }
  .datasets-content .dataset-table tr {
    padding: 12px 16px;
    gap: 12px 20px;
  }
}
@media (max-width: 960px) {
  .reading-jumps {
    top: var(--workspace-header-height, 92px);
  }
  #qa-answer-region, #qa-evidence-region, #qa-decision-region, #qa-inspector {
    scroll-margin-top: calc(var(--workspace-header-height, 92px) + 64px);
  }
}
@media (max-width: 767px) {
  .datasets-content {
    padding: 12px var(--workspace-gutter, 12px) 20px;
  }
  .datasets-content .page-heading {
    margin-bottom: 12px;
  }
  .dataset-type-switch {
    padding: 0 4px;
  }
  .datasets-content .dataset-type-switch .button {
    flex: 1;
    min-width: 0;
    min-height: 44px;
    padding: 8px;
  }
  .datasets-content .button, .datasets-content .text-button, .qa-filterbar .review-guide summary {
    min-height: 44px;
  }
  .datasets-content input:not([type=checkbox]), .datasets-content select {
    min-height: 44px;
    font-size: 16px;
  }
  .datasets-content .collection-toolbar, .qa-filterbar {
    padding: 8px 12px;
  }
  .datasets-content .dataset-table tr {
    padding: 12px;
  }
  .datasets-content .workspace-toolbar {
    padding: 0;
    min-height: 44px;
  }
  .workspace-tabs button {
    min-height: 44px;
    padding: 0 6px;
    font-size: 13px;
  }
  .qa-results .review-overview, .has-question .qa-results .review-overview {
    padding: 6px 12px;
  }
  .qa-results .review-progress-copy > strong {
    font-size: 13px;
  }
  .qa-reading {
    padding: 0 16px 20px;
  }
  .qa-reading .qa-question {
    margin: 0 -16px 16px;
    padding: 12px 16px 16px;
  }
  .qa-question h3 {
    font-size: 20px;
  }
  .qa-support {
    padding: 16px;
  }
  .qa-inspector .review-bar {
    padding: 12px;
  }
  .item-navigation .icon-button {
    width: 44px;
    height: 44px;
  }
  .datasets-content .result-jump input {
    width: 56px;
  }
  .datasets-content .detail-tab-content {
    padding: 16px;
  }
  .datasets-content .export-workspace {
    padding: 0;
  }
  .export-heading, .export-preparation, .export-layout .export-history {
    padding: 16px;
  }
}
@media (max-width: 600px) {
  .datasets-content.is-detail .page-heading {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: center;
    gap: 8px;
  }
  .is-detail .heading-copy {
    display: contents;
  }
  .datasets-content.is-detail .page-heading h1 {
    grid-column: 1/-1;
    font-size: 21px;
    line-height: 1.4;
  }
  .is-detail .dataset-identity {
    grid-column: 1;
    margin-top: 0;
    gap: 4px 8px;
    min-width: 0;
    font-size: 12px;
  }
  .is-detail .detail-heading-actions {
    grid-column: 2;
    margin: 0;
    gap: 6px;
  }
  .is-detail .detail-heading-actions .button {
    padding: 8px;
    min-height: 44px;
  }
  .is-detail .detail-heading-actions .refresh-detail {
    width: 44px;
  }
  .inspector-controls {
    padding: 4px 6px;
  }
}
@media (pointer: coarse) {
  .datasets-content .button, .datasets-content .text-button, .datasets-content .dataset-type-switch .button, .workspace-tabs button, .qa-filterbar .review-guide summary {
    min-height: 44px;
  }
  .datasets-content input:not([type=checkbox]), .datasets-content select {
    min-height: 44px;
  }
  .item-navigation .icon-button {
    width: 44px;
    height: 44px;
  }
}
/* Short windows keep reading and saving in the document flow. */
@media (min-width: 1051px) and (max-height: 800px) {
  .datasets-content.is-detail:has(.qa-results) {
    display: block;
    height: auto;
    min-height: 0;
  }
  .is-detail:has(.qa-results) > .detail-workspace {
    display: block;
    min-height: 0;
  }
  .is-detail .qa-results {
    display: block;
  }
  .datasets-content .qa-workbench {
    height: auto;
    min-height: 0;
    align-items: start;
  }
  .qa-list-pane {
    height: auto;
    max-height: min(560px, 100dvh - 32px);
    position: sticky;
    top: 16px;
  }
  .qa-inspector {
    height: auto;
    overflow: visible;
  }
  .inspection-columns {
    flex: none;
    overflow: visible;
  }
  .qa-inspector .review-bar {
    position: static;
  }
}
/* Review workspace: progress belongs to the task tabs; search belongs to the queue. */
.datasets-content .workspace-toolbar {
  flex-wrap: wrap;
  gap: 4px 16px;
}

.workspace-toolbar .workspace-tabs {
  flex: 0 1 auto;
  width: auto;
}

.workspace-toolbar .review-overview {
  flex: 0 1 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-width: 0;
  margin-left: auto;
  padding: 0;
  border: 0;
}

.workspace-toolbar .review-progress-copy {
  display: flex;
  align-items: center;
  flex: none;
  gap: 8px;
  width: auto;
}

.workspace-toolbar .review-progress-copy > strong {
  font-size: 13px;
  font-weight: 650;
  white-space: nowrap;
}

.workspace-toolbar .review-progress-copy > progress {
  display: block;
  width: 64px;
  height: 4px;
  margin: 0;
}

.workspace-toolbar .review-start-actions {
  width: auto;
  margin: 0;
  gap: 8px;
}

.workspace-toolbar .review-start-actions > .button {
  min-height: 36px;
  padding: 6px 10px;
  font-size: 13px;
}

.qa-queue {
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  border-right: 1px solid var(--ui-line);
  background: var(--ui-soft);
}

.qa-queue .qa-filterbar {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  flex: none;
  gap: 8px;
  padding: 10px 12px;
  background: var(--ui-soft);
}

.qa-queue .result-search {
  grid-column: 1/-1;
  width: 100%;
  min-width: 0;
  max-width: none;
  gap: 4px;
  padding: 0 8px;
  margin: 0;
}

.qa-queue .result-search input {
  width: 0;
  min-width: 0;
  flex: 1;
}

.qa-queue .result-search .text-button {
  padding-inline: 4px;
  min-width: 36px;
}

.qa-queue .result-toolbar {
  min-width: 0;
}

.qa-queue .result-toolbar select {
  width: 100%;
  max-width: none;
  min-width: 0;
  padding-left: 8px;
  padding-right: 4px;
}

.datasets-content .qa-queue .review-guide {
  margin: 0;
  min-width: 0;
}

.qa-queue .review-guide summary {
  width: auto;
  padding: 6px 0;
  white-space: nowrap;
  font-size: 12px;
}

.qa-queue .review-guide summary > span {
  display: inline;
}

.qa-queue .review-guide[open] {
  grid-column: 1/-1;
}

.qa-queue .review-guide p {
  font-size: 13px;
  line-height: 1.65;
  overflow-wrap: anywhere;
}

.qa-queue .qa-list-pane {
  flex: 1;
  min-height: 0;
  height: auto;
  border-right: 0;
  position: static;
}

@media (min-width: 1051px) {
  .datasets-content .results-tools {
    min-height: 44px;
  }
  .qa-queue {
    height: 100%;
    overflow: hidden;
  }
  .qa-queue .qa-filterbar {
    flex: 0 1 auto;
    max-height: calc(100dvh - 120px);
    overflow-y: auto;
  }
  .qa-queue .qa-list-pane {
    max-height: none;
  }
}
@media (max-width: 1050px) {
  .workspace-toolbar .workspace-tabs {
    flex: 1 1 100%;
  }
  .workspace-toolbar .review-overview {
    flex: 1 1 100%;
    margin: 0;
    padding: 4px 0;
    flex-wrap: wrap;
  }
  .qa-queue {
    border-right: 0;
  }
  .qa-queue .qa-filterbar {
    display: flex;
    flex-wrap: wrap;
    padding: 8px 12px;
  }
  .qa-queue .result-search {
    flex: 1 1 240px;
  }
  .qa-queue .result-toolbar {
    flex: 0 1 130px;
  }
  .qa-queue .review-guide[open] {
    flex: 1 1 100%;
  }
}
@media (max-width: 767px) {
  .datasets-content .workspace-toolbar {
    padding: 4px 8px;
  }
  .workspace-toolbar .workspace-tabs {
    gap: 0;
  }
  .workspace-toolbar .review-overview {
    gap: 8px;
    padding: 4px;
  }
  .workspace-toolbar .review-progress-copy {
    flex-wrap: wrap;
    gap: 4px 8px;
  }
  .workspace-toolbar .review-start-actions {
    flex-wrap: wrap;
    gap: 6px;
    margin-left: auto;
  }
  .workspace-toolbar .review-start-actions > .button {
    min-height: 44px;
  }
  .qa-queue .result-search {
    flex-basis: 100%;
  }
  .qa-queue .result-search .text-button {
    min-width: 44px;
    min-height: 44px;
  }
  .qa-queue .result-toolbar {
    flex: 1;
  }
  .qa-queue .review-guide summary {
    display: list-item;
    min-height: 44px;
    height: auto;
    font-size: 13px;
    align-content: center;
  }
  .qa-queue .review-guide summary > span {
    display: inline;
  }
  .inspector-controls > .text-button {
    order: 0;
  }
}
@media (pointer: coarse) {
  .workspace-toolbar .workspace-tabs button,
  .workspace-toolbar .review-start-actions > .button,
  .qa-queue .result-search .text-button,
  .qa-queue .review-guide summary {
    min-height: 44px;
  }
}
@media (min-width: 1051px) and (max-height: 800px) {
  .qa-queue {
    position: sticky;
    top: 16px;
    height: auto;
    max-height: min(560px, 100dvh - 32px);
  }
  .qa-queue .qa-list-pane {
    position: static;
    height: auto;
    max-height: none;
  }
}
/* Keep repeated question navigation available while reading on narrow screens. */
@media (max-width: 1050px) {
  .datasets-content.has-question {
    --qa-navigation-height:54px;
  }
  .datasets-content.has-question .results-tools {
    position: sticky;
    top: var(--workspace-header-height, 0px);
    z-index: 4;
    min-height: var(--qa-navigation-height);
  }
  .has-question .inspector-controls {
    flex-wrap: nowrap;
    min-height: 52px;
    padding: 4px 6px;
    gap: 4px;
  }
  .has-question .reading-jumps {
    top: calc(var(--workspace-header-height, 0px) + var(--qa-navigation-height));
  }
  .has-question #qa-inspector {
    scroll-margin-top: calc(var(--workspace-header-height, 0px) + var(--qa-navigation-height) + 12px);
  }
  .has-question :is(#qa-answer-region, #qa-evidence-region, #qa-decision-region),
  .has-question .qa-workbench :is(button, input, select, textarea, summary) {
    scroll-margin-top: calc(var(--workspace-header-height, 0px) + var(--qa-navigation-height) + 56px);
  }
}
@media (max-width: 380px) {
  .datasets-content.has-question {
    --qa-navigation-height:102px;
  }
  .has-question .inspector-controls {
    flex-direction: column;
    align-items: stretch;
  }
  .has-question .inspector-controls .item-navigation {
    margin: 0;
    justify-content: center;
  }
  .has-question .inspector-controls > .text-button {
    width: 100%;
  }
}
@media (max-width: 1050px) and (max-height: 599px) {
  .has-question .reading-jumps {
    position: static;
  }
  .has-question :is(#qa-answer-region, #qa-evidence-region, #qa-decision-region),
  .has-question .qa-workbench :is(button, input, select, textarea, summary) {
    scroll-margin-top: calc(var(--workspace-header-height, 0px) + var(--qa-navigation-height) + 12px);
  }
}
@media (max-width: 1050px) and (max-height: 480px) {
  .datasets-content.has-question .results-tools {
    position: static;
  }
  .has-question :is(#qa-inspector, #qa-answer-region, #qa-evidence-region, #qa-decision-region),
  .has-question .qa-workbench :is(button, input, select, textarea, summary) {
    scroll-margin-top: calc(var(--workspace-header-height, 0px) + 12px);
  }
}
/* Review and export scopes share counts without mixing their populations. */
.collection-scope {
  margin-right: auto;
}

.workspace-toolbar .review-progress-copy {
  flex-wrap: wrap;
  max-width: 390px;
}

.workspace-toolbar .review-breakdown {
  flex: 1 1 100%;
  font-size: 12px;
  line-height: 1.6;
  color: var(--ui-muted);
}

.review-breakdown small {
  display: block;
  font-size: 11px;
  font-weight: 400;
}

.result-scope {
  margin: 0;
  padding: 8px 14px;
  border-bottom: 1px solid var(--ui-line);
  color: var(--ui-text);
  font-size: 12px;
  line-height: 1.6;
}

.result-scope small {
  display: block;
  color: var(--ui-muted);
  font-size: 11px;
}

.export-population {
  margin: 10px 0 0;
  color: var(--ui-muted);
  font-size: 12px;
  line-height: 1.7;
}

.export-reasons li {
  padding: 0;
}

.export-reasons li > button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  padding: 10px 0;
  border: 0;
  background: transparent;
  color: var(--ui-text);
  text-align: left;
  font: inherit;
  cursor: pointer;
}

.export-reasons button:hover, .export-reasons button[aria-pressed=true] {
  color: var(--ui-accent);
}

.export-reasons strong {
  white-space: nowrap;
}

.export-reasons i {
  margin-left: 6px;
  font-size: 10px;
}

.exclusion-toggle {
  padding-left: 0;
}

.exclusion-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 13px;
}

.exclusion-list {
  max-height: 360px;
  overflow-y: auto;
  padding: 0;
  margin: 8px 0;
  list-style: none;
}

.exclusion-list li {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid var(--ui-line);
}

.exclusion-list li > div {
  flex: 1;
  min-width: 0;
}

.exclusion-list strong {
  display: block;
  font-size: 13px;
  line-height: 1.6;
  font-weight: 500;
  overflow-wrap: anywhere;
}

.exclusion-list small {
  display: block;
  color: var(--ui-muted);
  font-size: 12px;
}

.exclusion-list button {
  flex-shrink: 0;
}

.export-return {
  flex: none;
  padding: 4px 14px;
  border-bottom: 1px solid var(--ui-line);
}

@media (max-width: 600px) {
  .workspace-toolbar .review-progress-copy {
    max-width: none;
  }
  .result-scope {
    padding-inline: 12px;
  }
  .exclusion-list li {
    gap: 8px;
  }
  .export-reasons li > button {
    min-height: 44px;
  }
}
.preparation .input-scope-note {
  margin: 0 20px 10px;
  color: var(--ui-text);
  font-size: 13px;
  line-height: 1.6;
}

.preparation-table .input-scope-inline {
  display: block;
  margin-top: 4px;
  color: var(--ui-text);
  font-size: 12px;
  line-height: 1.6;
}

@media (max-width: 620px) {
  .preparation .input-scope-note {
    margin-inline: 12px;
  }
}
/* Inspectors open at their final position, without moving text or row controls. */
@media (prefers-reduced-motion: no-preference) {
  .dataset-type-switch .button, .workspace-tabs button, .qa-result-row,
  .picker-file-row, .picker-parent {
    transition: background-color var(--motion-fast, 120ms), color var(--motion-fast, 120ms), border-color var(--motion-fast, 120ms);
  }
  .creation-frame, .detail-tab-content, .qa-inspector, .source-preview {
    animation: none;
  }
}
@keyframes dataset-content-arrive {
  from {
    opacity: 0.85;
  }
  to {
    opacity: 1;
  }
}
/* Dataset register: compare names and real states without repeated decoration. */
.datasets-content .collection-toolbar {
  padding: 12px 16px;
  gap: 8px 12px;
}

.datasets-content .collection-toolbar :is(input, select) {
  font-size: 14px;
}

.datasets-content select {
  appearance: auto;
}

.datasets-content .dataset-table th {
  font-size: 13px;
  color: var(--ui-text);
}

.datasets-content .dataset-table td {
  padding: 12px 16px;
  font-size: 14px;
  vertical-align: middle;
}

.dataset-table .dataset-title-cell {
  gap: 8px;
}

.dataset-table .dataset-title-cell .dataset-name {
  font-size: 16px;
  line-height: 1.5;
  font-weight: 600;
}

.dataset-table .table-review {
  gap: 4px;
}

.dataset-table .table-review strong {
  font-size: 15px;
  line-height: 1.5;
}

.dataset-table .table-review small {
  font-size: 13px;
  line-height: 1.5;
}

.review-remaining {
  color: var(--ui-warning);
}

.review-resolved {
  color: var(--ui-muted);
}

.dataset-table .automatic-count {
  display: block;
  font-size: 14px;
  line-height: 1.5;
  margin-bottom: 4px;
}

.dataset-table .automatic-count strong {
  color: var(--ui-accent);
  font-size: 15px;
  font-weight: 650;
}

.dataset-table td .state, .dataset-table .auto-attention {
  font-size: 13px;
}

.dataset-table td.date {
  font-size: 13px;
  line-height: 1.5;
  white-space: normal;
}

.dataset-table td[data-label="사용 자료"] small {
  display: block;
  margin-top: 3px;
  font-size: 13px;
}

.datasets-content .register-footer {
  font-size: 13px;
}

/* Keep task navigation and the dataset-wide review scope on separate lines. */
.datasets-content .workspace-toolbar {
  display: block;
  padding: 0 12px;
}

.workspace-toolbar .workspace-tabs {
  display: flex;
  width: 100%;
  gap: 4px;
  padding: 6px 0;
}

.workspace-toolbar .workspace-tabs button {
  min-height: 40px;
  font-size: 14px;
}

.datasets-content .workspace-toolbar .review-overview {
  display: flex;
  width: 100%;
  margin: 0;
  padding: 8px 4px;
  gap: 8px 16px;
  border-top: 1px solid var(--ui-line);
}

.workspace-toolbar .review-progress-copy {
  flex: 1 1 auto;
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 4px 16px;
  max-width: none;
}

.workspace-toolbar .review-progress-copy > strong {
  font-size: 14px;
  line-height: 1.5;
}

.workspace-toolbar .review-breakdown {
  display: flex;
  flex: 0 1 auto;
  flex-wrap: wrap;
  gap: 4px 12px;
  font-size: 13px;
  line-height: 1.5;
}

.review-scope {
  color: var(--ui-muted);
  font-size: 13px;
  line-height: 1.5;
}

.workspace-toolbar .review-start-actions {
  flex: 0 0 auto;
}

.workspace-toolbar .review-start-actions > .button {
  min-height: 40px;
}

.qa-result-row strong {
  font-size: 15px;
  line-height: 1.55;
}

.result-meta .state {
  font-size: 13px;
}

.result-scope, .result-scope small {
  font-size: 13px;
  line-height: 1.55;
}

.question-heading {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.question-heading .qa-label {
  margin: 0;
}

.question-heading > .text-button {
  margin-left: auto;
}

.question-heading .selected-review-state {
  padding: 3px 8px;
  font-size: 13px;
  font-weight: 550;
}

.qa-answer {
  font-size: 17px;
  line-height: 1.85;
}

.qa-support {
  background: var(--ui-soft);
}

.evidence-item .evidence-quotes blockquote {
  background: var(--ui-paper);
  color: var(--ui-ink);
  font-size: 16px;
  line-height: 1.8;
}

.evidence-item .evidence-quotes blockquote p {
  font-size: inherit;
  line-height: inherit;
}

.source-empty h3 {
  font-size: 16px;
}

@media (min-width: 1051px) {
  .dataset-table th:first-child {
    width: 36%;
  }
  .dataset-table th:nth-child(2) {
    width: 23%;
  }
  .dataset-table th:nth-child(3) {
    width: 17%;
  }
  .dataset-table th:nth-child(4) {
    width: 10%;
  }
  .dataset-table th:nth-child(5) {
    width: 14%;
  }
}
@media (max-width: 1050px) {
  .datasets-content.has-question .qa-workbench.has-selection > .qa-queue {
    display: none;
  }
  .datasets-content.has-question .workspace-toolbar .review-overview {
    display: none;
  }
}
@media (max-width: 767px) {
  .datasets-content .collection-toolbar {
    padding: 12px;
  }
  .datasets-content .collection-toolbar :is(input, select) {
    min-height: 44px;
    font-size: 16px;
  }
  .datasets-content .dataset-table td {
    padding: 0;
  }
  .dataset-table .table-review strong {
    font-size: 15px;
  }
  .dataset-table .dataset-title-cell .dataset-name {
    font-size: 16px;
  }
  .datasets-content .workspace-toolbar {
    padding: 0 8px;
  }
  .workspace-toolbar .workspace-tabs {
    gap: 0;
  }
  .workspace-toolbar .workspace-tabs button {
    min-height: 44px;
    padding-inline: 8px;
    font-size: 13px;
  }
  .datasets-content .workspace-toolbar .review-overview {
    flex-wrap: wrap;
    padding: 8px 4px;
  }
  .workspace-toolbar .review-progress-copy {
    flex-basis: 100%;
    gap: 4px 12px;
  }
  .workspace-toolbar .review-scope {
    flex-basis: 100%;
  }
  .workspace-toolbar .review-start-actions {
    margin: 0 0 0 auto;
  }
  .workspace-toolbar .review-start-actions > .button {
    min-height: 44px;
  }
  .question-heading .selected-review-state {
    font-size: 13px;
  }
  .qa-answer {
    font-size: 16px;
    line-height: 1.85;
  }
}
/* Keep operational scope and creation details at the shared metadata size. */
.dataset-identity > span, .required, .workspace-tabs button span {
  font-size: 13px;
}

.creation-main .section-heading p, .creation-main .prepare-actions, .creation-main details summary {
  font-size: 13px;
}

@media (max-width: 600px) {
  .datasets-content .creation-main details > summary {
    min-height: 44px;
  }
  .datasets-content .picker-file-name {
    min-height: 44px;
  }
}
/* Compare a question and its evidence without moving either reading pane. */
.datasets-content .review-workspace .qa-workbench.queue-open .qa-list-pane {
  display: block;
}

.datasets-content .review-workspace .workspace-toolbar {
  padding: 0 16px;
}

.datasets-content .workspace-tabs {
  width: 100%;
  padding: 0;
  gap: 12px;
}

.datasets-content .workspace-tabs button {
  min-height: 48px;
  border-radius: 0;
  border-bottom: 2px solid transparent;
  background: transparent;
}

.datasets-content .workspace-tabs button[aria-pressed=true] {
  border-bottom-color: var(--ui-accent);
  background: transparent;
  color: var(--ui-accent);
}

.datasets-content .review-workspace .qa-results {
  padding: 0;
}

.datasets-content .review-workspace .qa-workbench {
  display: block;
  position: relative;
  height: max(400px, 100dvh - 164px);
  min-height: 0;
  border: 0;
}

.datasets-content .review-workspace .qa-queue {
  display: none;
  position: absolute;
  inset: 0 auto 0 0;
  z-index: 4;
  width: min(320px, 100%);
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  border: 0;
  background: var(--ui-paper);
  box-shadow: 8px 0 24px color-mix(in srgb, var(--ui-ink) 12%, transparent);
}

.datasets-content .review-workspace .qa-workbench:not(.has-selection) > .qa-queue {
  display: flex;
  position: static;
  width: 100%;
  height: 100%;
  box-shadow: none;
}

.datasets-content .review-workspace .qa-workbench.has-selection > .qa-queue {
  display: none;
}

.datasets-content .review-workspace .qa-workbench.has-selection.queue-open > .qa-queue {
  display: flex;
}

.datasets-content .review-workspace .queue-heading {
  justify-content: flex-start;
}

.datasets-content .review-workspace .queue-heading .queue-dismiss {
  order: 3;
  margin-left: auto;
  flex: none;
}

.datasets-content .review-workspace #qa-queue-toggle {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  width: auto;
  flex: none;
}

.datasets-content .review-workspace .queue-heading {
  position: static;
  flex: none;
  padding: 12px 16px;
  gap: 8px;
  background: var(--ui-paper);
  font-size: 15px;
}

.datasets-content .review-workspace .queue-heading > span {
  font-size: 13px;
  font-weight: 450;
}

.datasets-content .review-workspace .review-overview {
  flex: none;
  display: block;
  padding: 12px 16px;
  background: var(--ui-paper);
  border-bottom: 1px solid var(--ui-line);
}

.datasets-content .review-workspace .review-progress-copy {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 10px;
}

.datasets-content .review-workspace .review-progress-copy > strong {
  font-size: 14px;
}

.datasets-content .review-workspace .review-breakdown {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 10px;
  font-size: 13px;
}

.datasets-content .review-workspace .review-scope {
  display: block;
  flex-basis: 100%;
  font-size: 13px;
  color: var(--ui-muted);
}

.datasets-content .review-workspace .review-start-actions {
  margin: 8px 0 0;
  flex-wrap: wrap;
}

.datasets-content .review-workspace .review-start-actions:empty {
  display: none;
}

.datasets-content .review-workspace .review-start-actions .button {
  min-height: 36px;
}

.datasets-content .review-workspace .qa-filterbar {
  flex: none;
  padding: 12px;
  gap: 8px;
}

.datasets-content .review-workspace .result-search {
  width: 100%;
  min-height: 40px;
}

.datasets-content .review-workspace .result-toolbar {
  flex: 1;
}

.datasets-content .review-workspace .result-toolbar select {
  width: 100%;
  min-height: 40px;
}

.datasets-content .review-workspace .result-scope {
  flex: none;
  margin: 0;
  padding: 8px 16px;
  font-size: 13px;
}

.datasets-content .review-workspace .result-scope small {
  display: none;
}

.datasets-content .review-workspace .qa-list-pane {
  flex: 1;
  height: auto;
  overflow: auto;
  min-height: 0;
}

.datasets-content .review-workspace .qa-result-row {
  padding: 14px 34px 14px 16px;
  border-bottom: 1px solid var(--ui-line);
  min-height: 100px;
}

.datasets-content .review-workspace .qa-result-row strong {
  font-size: 15px;
  line-height: 1.6;
  -webkit-line-clamp: 3;
}

.datasets-content .review-workspace .qa-result-row.selected {
  background: var(--ui-selected);
}

.datasets-content .review-workspace .qa-result-row .result-meta {
  margin-bottom: 5px;
}

.datasets-content .review-workspace .qa-list-pane > .pagination {
  position: sticky;
  bottom: 0;
  margin: 0;
  padding: 10px 12px;
  background: var(--ui-paper);
  border-top: 1px solid var(--ui-line);
}

.datasets-content .review-workspace .qa-inspector {
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  height: 100%;
  max-height: none;
  overflow: hidden;
}

.datasets-content .review-workspace .inspector-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  flex: none;
  gap: 0 12px;
  padding: 4px 12px;
  border-bottom: 1px solid var(--ui-line);
  background: var(--ui-paper);
}

.datasets-content .review-workspace .inspector-controls {
  display: flex;
  gap: 4px;
  padding: 0;
  order: 2;
  margin-left: auto;
}

.datasets-content .review-workspace .item-navigation {
  gap: 6px;
  margin: 0;
}

.datasets-content .review-workspace .item-navigation .icon-button {
  width: 36px;
  height: 36px;
  flex: none;
}

.datasets-content .review-workspace .result-jump {
  gap: 6px;
}

.datasets-content .review-workspace .result-jump input {
  width: 56px;
  min-height: 36px;
}

.datasets-content .review-workspace .result-jump button {
  min-height: 36px;
  padding: 6px 10px;
}

.datasets-content .review-workspace .reading-jumps {
  position: static;
  display: flex;
  order: 1;
  align-items: center;
  gap: 4px;
  padding: 0;
  border: 0;
  background: transparent;
}

.datasets-content .review-workspace .reading-jumps .text-button {
  min-height: 44px;
  font-size: 13px;
}

.datasets-content .review-workspace .inspection-columns {
  display: grid;
  grid-template-columns: minmax(0, 55%) minmax(300px, 45%);
  flex: 1;
  min-height: 0;
  overflow: hidden;
  align-items: stretch;
  background: var(--ui-paper);
}

.datasets-content .review-workspace .qa-reading {
  display: block;
  padding: 0;
  min-height: 0;
  height: 100%;
  overflow: auto;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
}

.datasets-content .review-workspace .qa-question {
  margin: 0;
  padding: 20px 24px 16px;
}

.datasets-content .review-workspace .qa-question h3 {
  margin: 10px 0 0;
  font-size: 21px;
  line-height: 1.65;
  letter-spacing: -0.02em;
}

.datasets-content .review-workspace .question-heading {
  gap: 8px;
}

.datasets-content .review-workspace .qa-answer-section {
  padding: 18px 24px 24px;
  border-top: 1px solid var(--ui-line);
}

.datasets-content .review-workspace .qa-answer {
  margin: 8px 0 0;
  max-width: 78ch;
  font-size: 17px;
  line-height: 1.85;
}

.datasets-content .review-workspace .qa-reading .review-taxonomy, .datasets-content .review-workspace .selected-attention {
  margin: 0 24px 16px;
}

.datasets-content .review-workspace .qa-support {
  padding: 20px 24px;
  border-left: 1px solid var(--ui-line);
  border-top: 0;
  min-height: 0;
  height: 100%;
  overflow: auto;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
  background: var(--ui-soft);
}

.datasets-content .review-workspace .source-evidence > h3 {
  margin: 0;
  font-size: 15px;
}

.datasets-content .review-workspace .source-evidence > h3 .support-title {
  font-size: 15px;
  color: var(--ui-ink);
  font-weight: 650;
}

.datasets-content .review-workspace .evidence-item {
  padding: 12px 0;
}

.datasets-content .review-workspace .source-evidence > .evidence-item:last-of-type {
  border-bottom: 0;
}

.datasets-content .review-workspace .evidence-item .evidence-quotes blockquote {
  padding: 14px 16px;
  font-size: 16px;
  line-height: 1.8;
}

.datasets-content .review-workspace .review-bar {
  position: static;
  flex: none;
  padding: 10px 16px;
  background: var(--ui-paper);
  border-top: 1px solid var(--ui-control);
}

.datasets-content .review-workspace .review-fields {
  display: flex;
  align-items: end;
  flex-wrap: wrap;
  gap: 8px 12px;
}

.datasets-content .review-workspace .decision-field {
  flex: 0 0 142px;
}

.datasets-content .review-workspace .review-note-field {
  flex: 1 1 200px;
  min-width: 0;
}

.datasets-content .review-workspace .review-save-actions {
  margin-left: auto;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.datasets-content .review-workspace .review-save-actions .button {
  min-height: 44px;
}

.datasets-content .review-workspace .current-result-label {
  align-self: center;
  font-size: 13px;
  color: var(--ui-muted);
  white-space: nowrap;
}

.datasets-content .review-workspace .review-progress {
  margin: 0 0 8px;
  color: var(--ui-text);
  font-size: 13px;
}

.datasets-content .review-workspace .review-feedback {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 16px;
}

.datasets-content .review-workspace .review-feedback > div {
  flex: 1 1 200px;
}

.datasets-content .review-workspace .review-feedback strong, .datasets-content .review-workspace .review-feedback span {
  display: block;
}

.datasets-content .review-workspace .review-feedback .text-button {
  min-height: 44px;
}

.datasets-content .review-workspace #qa-answer-section {
  scroll-margin-top: 16px;
}

@media (max-width: 960px) {
  .datasets-content .review-workspace :is(#qa-answer-region, #qa-answer-section, #qa-evidence-region, #qa-decision-region, #qa-review-feedback) {
    scroll-margin-top: calc(var(--workspace-header-height, 0px) + 112px);
  }
}
@media (max-width: 960px) and (max-height: 560px) {
  .datasets-content .review-workspace .inspector-topbar {
    position: static;
  }
  .datasets-content .review-workspace :is(#qa-answer-region, #qa-answer-section, #qa-evidence-region, #qa-decision-region, #qa-review-feedback) {
    scroll-margin-top: calc(var(--workspace-header-height, 0px) + 12px);
  }
}
.datasets-content .review-workspace .inspector-empty {
  display: none;
}

@media (max-width: 960px) {
  .datasets-content .review-workspace .qa-workbench {
    display: block;
    height: auto;
    min-height: 0;
  }
  .datasets-content .review-workspace .qa-workbench.queue-open > .qa-queue {
    position: static;
    width: 100%;
    height: auto;
    box-shadow: none;
    overflow: visible;
  }
  .datasets-content .review-workspace .qa-workbench.queue-open > .qa-inspector {
    display: none;
  }
  .datasets-content .review-workspace .qa-queue {
    border-right: 0;
  }
  .datasets-content .review-workspace .qa-list-pane {
    overflow: visible;
  }
  .datasets-content .review-workspace .qa-inspector {
    height: auto;
    overflow: visible;
  }
  .datasets-content .review-workspace .inspection-columns {
    display: block;
    overflow: visible;
  }
  .datasets-content .review-workspace .qa-reading, .datasets-content .review-workspace .qa-support {
    height: auto;
    overflow: visible;
  }
  .datasets-content .review-workspace .qa-support {
    border-left: 0;
    border-top: 1px solid var(--ui-line);
  }
  .datasets-content .review-workspace .inspector-topbar {
    position: sticky;
    top: var(--workspace-header-height, 0px);
    z-index: 3;
  }
  .datasets-content .review-workspace .review-bar {
    position: static;
  }
  .datasets-content .review-workspace .inspector-empty {
    display: none;
  }
}
@media (max-width: 600px) {
  .datasets-content .review-workspace .workspace-toolbar {
    padding: 0 8px;
  }
  .datasets-content .workspace-tabs {
    justify-content: space-between;
    gap: 0;
  }
  .datasets-content .workspace-tabs button {
    min-height: 44px;
    padding: 8px;
    font-size: 13px;
  }
  .datasets-content .review-workspace .inspector-topbar {
    padding: 4px 8px;
    gap: 0;
  }
  .datasets-content .review-workspace .inspector-controls {
    order: 1;
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
  }
  .datasets-content .review-workspace .item-navigation .icon-button {
    width: 36px;
    height: 40px;
  }
  .datasets-content .review-workspace .result-jump input {
    width: 48px;
    min-height: 40px;
    font-size: 16px;
  }
  .datasets-content .review-workspace .reading-jumps {
    order: 2;
    width: 100%;
    justify-content: space-between;
    border-top: 1px solid var(--ui-line);
  }
  .datasets-content .review-workspace .reading-jumps .text-button {
    flex: 1;
    min-height: 44px;
    justify-content: center;
    padding: 8px 4px;
  }
  .datasets-content .review-workspace .qa-question {
    padding: 16px;
  }
  .datasets-content .review-workspace .qa-question h3 {
    font-size: 19px;
    line-height: 1.65;
  }
  .datasets-content .review-workspace .qa-answer-section, .datasets-content .review-workspace .qa-support {
    padding: 16px;
  }
  .datasets-content .review-workspace .qa-answer {
    font-size: 16px;
  }
  .datasets-content .review-workspace .review-bar {
    padding: 10px 12px;
  }
  .datasets-content .review-workspace .decision-field {
    flex: 1 1 120px;
  }
  .datasets-content .review-workspace .review-save-actions {
    flex: 1 1 100%;
    justify-content: flex-end;
    margin: 0;
  }
  .datasets-content .review-workspace .review-save-actions .button {
    min-height: 44px;
  }
  .datasets-content .review-workspace .review-note-field {
    flex-basis: 100%;
  }
}
/* Readable supporting text keeps the same minimum as primary list metadata. */
.datasets-content .review-guide summary, .datasets-content .review-disclosure > summary span,
.datasets-content .check-verdict, .datasets-content .review-fields label,
.datasets-content .policy-note :is(summary, p), .datasets-content .execution-policy :is(summary, p),
.datasets-content .material-heading p {
  font-size: 13px;
}

@media (max-width: 380px) {
  .datasets-content .review-workspace #qa-queue-toggle {
    min-width: 44px;
    min-height: 44px;
    justify-content: center;
    padding: 6px;
  }
  .datasets-content .review-workspace #qa-queue-toggle span {
    display: none;
  }
  .datasets-content .review-workspace .item-navigation, .datasets-content .review-workspace .result-jump {
    gap: 4px;
  }
  .datasets-content .review-workspace .result-jump input {
    width: 44px;
  }
}
@media (max-width: 960px) and (max-height: 480px) {
  .datasets-content .review-workspace .inspector-topbar, .datasets-content .review-workspace .review-bar {
    position: static;
  }
}
@media (prefers-reduced-motion: no-preference) {
  .datasets-content .review-workspace .qa-workbench.has-selection.queue-open > .qa-queue {
    animation: reader-queue-arrive 140ms var(--motion-ease);
  }
}
@keyframes reader-queue-arrive {
  from {
    opacity: 0.86;
  }
  to {
    opacity: 1;
  }
}
.datasets-content .review-workspace .item-navigation span, .datasets-content .review-workspace .result-search .text-button {
  font-size: 13px;
}

/* Dataset detail: one containing layout, one item toolbar, parallel reading and attached decision. */
.datasets-content .dataset-type-switch {
  margin: 0 0 20px;
  padding: 0 20px;
  gap: 24px;
  border-bottom: 1px solid var(--ui-line);
}

.datasets-content .dataset-type-switch .button {
  min-height: 44px;
  padding: 10px 0;
  border: 0;
  border-bottom: 2px solid transparent;
  border-radius: 0;
  background: transparent;
  color: var(--ui-muted);
  font-size: 14px;
  font-weight: 550;
}

.datasets-content .dataset-type-switch .button.primary {
  color: var(--ui-accent);
  border-bottom-color: var(--ui-accent);
  font-weight: 650;
}

.datasets-content .dataset-register {
  border: 1px solid var(--ui-line);
  border-radius: 12px;
  overflow: hidden;
}

.datasets-content .collection-toolbar {
  padding: 16px 20px;
  gap: 12px;
  background: var(--ui-paper);
  border-bottom: 1px solid var(--ui-line);
}

.datasets-content .dataset-table thead th {
  padding-block: 12px;
  background: var(--ui-soft);
  font-size: 12px;
  font-weight: 550;
  color: var(--ui-muted);
}

.datasets-content .dataset-table tbody td {
  padding-block: 18px;
  border-color: var(--ui-line);
}

.datasets-content .dataset-table .dataset-title-cell .dataset-name {
  font-size: 15px;
  line-height: 1.55;
  font-weight: 600;
  color: var(--ui-ink);
}

.datasets-content .register-footer {
  padding: 12px 20px;
  border-top: 1px solid var(--ui-line);
  font-size: 12px;
}

.datasets-content.is-detail .page-heading {
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}

.datasets-content .review-workspace {
  border: 1px solid var(--ui-line);
  border-radius: 12px;
  overflow: visible;
}

.datasets-content .workspace-tabs {
  padding-inline: 16px;
  background: var(--ui-paper);
  border-color: var(--ui-line);
}

.datasets-content .workspace-tabs button {
  min-height: 46px;
  font-size: 14px;
}

.datasets-content .review-workspace .inspector-topbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  flex: none;
  gap: 8px 16px;
  padding: 8px 20px;
  min-height: 52px;
  border-bottom: 1px solid var(--ui-line);
  background: var(--ui-paper);
}

.datasets-content .review-workspace .inspector-controls {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}

.datasets-content .review-workspace .reading-jumps {
  display: flex;
  align-items: center;
  gap: 4px;
}

.datasets-content .reading-menu-toggle {
  display: none;
}

.datasets-content .review-workspace .qa-reading {
  padding: 0;
}

.datasets-content .review-workspace .qa-question {
  margin: 0;
  padding: 20px 24px;
  border-color: var(--ui-line);
}

.datasets-content .review-workspace .qa-question h3 {
  font-size: 20px;
  line-height: 1.6;
  font-weight: 650;
  letter-spacing: -0.025em;
}

.datasets-content .review-workspace .qa-answer-section {
  padding: 20px 24px;
}

.datasets-content .review-workspace .qa-answer {
  font-size: 16px;
  line-height: 1.85;
  color: var(--ui-ink);
}

.datasets-content .review-workspace .qa-support {
  padding: 20px 24px;
  border-color: var(--ui-line);
  background: var(--ui-soft);
}

.datasets-content .review-workspace .source-evidence {
  padding: 0;
  background: transparent;
  border: 0;
}

.datasets-content .review-workspace .evidence-quotes {
  padding: 0;
  border: 0;
  background: transparent;
}

.datasets-content .review-workspace .evidence-quotes blockquote {
  margin: 12px 0;
  padding: 16px;
  border: 0;
  border-radius: 8px;
  background: var(--ui-paper);
}

.datasets-content .review-workspace .evidence-quotes blockquote p {
  white-space: pre-line;
  font-size: 16px;
  line-height: 1.85;
}

.datasets-content .review-workspace .review-bar {
  flex: none;
  padding: 14px 20px;
  background: var(--ui-paper);
  border-color: var(--ui-line);
}

@media (min-width: 1101px) and (min-height: 701px) {
  main.datasets-content.is-detail:has(.review-workspace) {
    display: flex;
    flex-direction: column;
    height: calc(100dvh - 24px);
    min-height: 0;
    padding-top: 28px;
    padding-bottom: 24px;
  }
  main.datasets-content.is-detail:has(.review-workspace) > .page-heading {
    flex: none;
  }
  main.datasets-content.is-detail:has(.review-workspace) > .detail-workspace {
    display: flex;
    flex-direction: column;
    flex: 1 1 0;
    min-height: 0;
  }
  .datasets-content .review-workspace .workspace-toolbar {
    flex: none;
  }
  .datasets-content .review-workspace .qa-results {
    display: flex;
    flex-direction: column;
    flex: 1 1 0;
    min-height: 0;
  }
  .datasets-content .review-workspace .qa-workbench {
    flex: 1 1 0;
    min-height: 0;
    height: auto;
  }
  .datasets-content .review-workspace .qa-inspector {
    height: 100%;
    min-height: 0;
  }
}
@media (max-width: 960px) {
  .datasets-content .review-workspace .inspector-topbar {
    position: sticky;
    top: var(--workspace-header-height);
    z-index: 6;
    padding: 6px 10px;
    flex-wrap: nowrap;
  }
  .datasets-content .review-workspace .inspector-controls {
    width: 100%;
    min-width: 0;
    margin: 0;
    gap: 4px;
  }
  .datasets-content .review-workspace .item-navigation {
    flex: 1;
    min-width: 0;
    gap: 4px;
  }
  .datasets-content .review-workspace .result-jump {
    flex: 1;
    min-width: 0;
    gap: 4px;
  }
  .datasets-content .review-workspace .result-jump input {
    width: 48px;
    min-width: 40px;
    padding-inline: 4px;
  }
  .datasets-content .review-workspace .result-jump > span {
    white-space: nowrap;
    font-size: 12px;
  }
  .datasets-content .review-workspace #qa-queue-toggle {
    min-width: 44px;
    padding: 8px;
  }
  .datasets-content .review-workspace #qa-queue-toggle > span {
    display: none;
  }
  .datasets-content .reading-menu-toggle {
    display: inline-flex;
    flex: none;
  }
  .datasets-content .review-workspace .reading-jumps {
    display: none;
  }
  .datasets-content .review-workspace .reading-jumps.is-open {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    position: absolute;
    top: calc(100% + 4px);
    right: 10px;
    min-width: 240px;
    padding: 8px;
    background: var(--ui-paper);
    border: 1px solid var(--ui-line);
    border-radius: 8px;
    box-shadow: 0 12px 28px rgba(35, 39, 47, 0.1490196078);
    z-index: 10;
  }
  .datasets-content .review-workspace .reading-jumps button {
    min-height: 44px;
    justify-content: flex-start;
  }
  .datasets-content .review-workspace :is(.qa-reading, .qa-answer-section, .qa-support, .review-bar) {
    scroll-margin-top: calc(var(--workspace-header-height) + 72px);
  }
  .datasets-content .review-workspace .qa-question, .datasets-content .review-workspace .qa-answer-section, .datasets-content .review-workspace .qa-support {
    padding: 18px;
  }
  .datasets-content .review-workspace .qa-question h3 {
    font-size: 18px;
  }
  .datasets-content .review-workspace .review-bar {
    position: static;
    padding: 14px;
  }
}
@media (max-width: 600px) {
  .datasets-content .dataset-type-switch {
    padding-inline: 14px;
    gap: 20px;
  }
  .datasets-content .dataset-type-switch .button {
    font-size: 13px;
  }
  .datasets-content .collection-toolbar {
    padding: 14px;
  }
  .datasets-content .dataset-table tbody tr {
    padding: 16px;
    row-gap: 16px;
  }
  .datasets-content .dataset-table tbody td {
    padding: 0;
  }
  .datasets-content .workspace-tabs {
    padding-inline: 10px;
  }
  .datasets-content .workspace-tabs button {
    font-size: 13px;
  }
}
/* Korean prose wraps at words; the section menu closes like other task menus. */
.datasets-content .review-workspace :is(.qa-answer, .qa-answer p, .qa-question h3, .evidence-quotes blockquote p) {
  word-break: keep-all;
  overflow-wrap: anywhere;
}

@media (max-width: 960px) {
  .datasets-content .review-workspace .inspector-controls, .datasets-content .review-workspace .item-navigation, .datasets-content .review-workspace .result-jump {
    min-height: 44px;
  }
  .datasets-content .review-workspace .inspector-controls .reading-menu-toggle {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    text-align: center;
  }
  .datasets-content .review-workspace .reading-menu-toggle > i {
    width: 18px;
    margin: 0;
    text-align: center;
  }
  .datasets-content .review-workspace :is(#qa-answer-region, #qa-answer-section, #qa-evidence-region, #qa-decision-region) {
    scroll-margin-top: calc(var(--workspace-header-height) + 72px);
  }
}
.datasets-content .dataset-materials {
  display: block;
  margin-top: 6px;
  color: var(--ink-muted, var(--ui-muted));
  font-size: 12px;
}
.datasets-content .output-readiness {
  font-size: 13px;
}
.datasets-content .output-readiness strong {
  display: block;
  color: var(--ink, var(--ui-ink));
  font-size: 13px;
  font-weight: 600;
}
.datasets-content .qa-assignments {
  max-width: 900px;
  padding: 28px;
}
.datasets-content .qa-assignments h2 {
  margin: 0 0 8px;
  font-size: 20px;
}
.datasets-content .qa-assignments header p {
  margin: 0;
  line-height: 1.7;
}
.datasets-content .assignment-scope {
  margin: 12px 0 28px;
  color: var(--ui-muted);
  font-size: 13px;
  line-height: 1.6;
}
.datasets-content .assignment-form {
  display: flex;
  gap: 12px;
  align-items: flex-end;
  margin-bottom: 28px;
}
.datasets-content .assignment-form label {
  display: grid;
  gap: 8px;
  flex: 1;
  max-width: 480px;
  font-size: 13px;
  font-weight: 600;
}
.datasets-content .assignment-form select {
  width: 100%;
  min-width: 0;
  min-height: 44px;
  border: 1px solid var(--ui-control);
  border-radius: 8px;
  background: var(--ui-paper);
  padding: 10px 36px 10px 12px;
  color: var(--ui-ink);
  font: inherit;
}
.datasets-content .qa-assignments h3 {
  margin: 28px 0 12px;
  font-size: 15px;
}
.datasets-content .qa-assignments h3 span {
  color: var(--ui-muted);
  font-weight: 500;
  margin-left: 6px;
}
.datasets-content .assignee-list {
  padding: 0;
  margin: 0;
  list-style: none;
  border-top: 1px solid var(--ui-line);
}
.datasets-content .assignee-list li {
  display: flex;
  gap: 16px;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1px solid var(--ui-chrome);
}
.datasets-content .assignee-list li > div {
  min-width: 0;
}
.datasets-content .assignee-list strong {
  display: block;
  overflow-wrap: anywhere;
  font-size: 14px;
}
.datasets-content .assignee-list span {
  display: block;
  margin-top: 5px;
  color: var(--ui-muted);
  font-size: 12px;
}
.datasets-content .assignee-list button {
  flex-shrink: 0;
  min-height: 44px;
}
@media (max-width: 640px) {
  .datasets-content .qa-assignments {
    padding: 20px 16px;
  }
  .datasets-content .assignment-form {
    flex-direction: column;
    align-items: stretch;
  }
  .datasets-content .assignment-form label {
    max-width: none;
  }
}

.datasets-content .output-readiness small {
  display: block;
  margin-top: 5px;
  line-height: 1.5;
}

@media (max-width: 640px) {
  .datasets-content .workspace-toolbar .workspace-tabs {
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 0 4px;
    padding-inline: 0;
  }
  .datasets-content .workspace-toolbar .workspace-tabs button {
    flex: 0 0 auto;
    padding-inline: 9px;
  }
}
.datasets-content .export-check-time {
  margin: 12px 0 20px;
  color: var(--ui-muted);
  font-size: 13px;
  line-height: 1.6;
}

.datasets-content .export-workspace .export-check-time {
  padding-inline: 20px;
}

.datasets-content .qa-assignments .assignment-scope {
  margin: 12px 0 28px;
}

/* Task-first dataset library and content-height review workspace. */
:host {
  background: transparent;
  min-height: 100%;
  color: var(--ui-ink);
}

.datasets-content {
  padding: 24px;
  max-width: 1800px;
  background: transparent;
}

.datasets-content .page-heading {
  margin: 0 0 20px;
}

.datasets-content .heading-count {
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  margin-left: 10px;
  padding: 2px 8px;
  border-radius: 7px;
  background: var(--ui-soft);
  color: var(--ui-text);
  font-size: 13px;
  font-weight: 600;
  vertical-align: middle;
}

.datasets-content .dataset-type-switch {
  display: inline-flex;
  max-width: 100%;
  gap: 4px;
  padding: 4px;
  margin: 0 0 18px;
  background: var(--ui-soft);
  border: 1px solid var(--ui-line);
  border-radius: 10px;
}

.datasets-content .dataset-type-switch .button {
  min-height: 36px;
  padding: 7px 16px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: var(--ui-text);
  font-size: 13px;
  box-shadow: none;
}

.datasets-content .dataset-type-switch .button.primary {
  background: var(--ui-accent);
  color: var(--ui-on-navy);
}

.datasets-content .dataset-register {
  border: 1px solid var(--ui-line);
  border-radius: 14px;
  background: var(--ui-paper);
  box-shadow: none;
  overflow: hidden;
}

.datasets-content .collection-toolbar {
  padding: 14px 18px;
  background: var(--ui-soft);
  border-bottom: 1px solid var(--ui-line);
  gap: 10px;
}

.datasets-content .collection-search {
  background: var(--ui-paper);
  border-radius: 8px;
}

.datasets-content .dataset-table {
  table-layout: fixed;
  white-space: normal;
}

.datasets-content .dataset-table thead th {
  background: var(--ui-soft);
  padding: 10px 18px;
  color: var(--ui-muted);
  font-size: 12px;
  border-bottom: 1px solid var(--ui-line);
}

.datasets-content .dataset-table th:first-child {
  width: 52%;
}

.datasets-content .dataset-table th:nth-child(2) {
  width: 27%;
}

.datasets-content .dataset-table th:nth-child(3) {
  width: 21%;
}

.datasets-content .dataset-table tbody td {
  padding: 14px 18px;
  vertical-align: top;
  border-bottom-color: var(--ui-line);
}

.datasets-content .dataset-table tbody tr:hover {
  background: var(--ui-hover);
}

.datasets-content .dataset-table .dataset-title-cell {
  gap: 8px;
  align-items: center;
}

.datasets-content .dataset-table .dataset-title-cell .dataset-name {
  font-size: 16px;
  line-height: 1.55;
  font-weight: 650;
  display: inline;
  min-height: 28px;
  overflow-wrap: anywhere;
  max-width: none;
}

.datasets-content .dataset-table .dataset-type {
  background: var(--ui-soft);
  border: 0;
  border-radius: 5px;
  white-space: nowrap;
}

.dataset-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 14px;
  margin-top: 5px;
  color: var(--ui-muted);
  font-size: 13px;
  line-height: 1.6;
}

.dataset-facts {
  margin-top: 7px;
  font-size: 12px;
  color: var(--ui-muted);
}

.dataset-facts > summary {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  min-height: 28px;
  cursor: pointer;
  list-style: none;
}

.dataset-facts > summary::before {
  content: "";
  width: 6px;
  height: 6px;
  border-right: 1.5px solid currentColor;
  border-bottom: 1.5px solid currentColor;
  transform: rotate(-45deg);
  margin-right: 2px;
}

.dataset-facts[open] > summary::before {
  transform: rotate(45deg);
}

.dataset-facts > summary::-webkit-details-marker {
  display: none;
}

.dataset-facts dl {
  display: grid;
  gap: 7px;
  margin: 8px 0 0;
  padding: 10px 0;
  border-top: 1px solid var(--ui-line);
  font-size: 13px;
  line-height: 1.65;
}

.dataset-facts dl > div {
  display: grid;
  grid-template-columns: 64px minmax(0, 1fr);
  gap: 8px;
}

.dataset-facts dt {
  color: var(--ui-muted);
}

.dataset-facts dd {
  margin: 0;
  color: var(--ui-text);
  overflow-wrap: anywhere;
}

.dataset-review-cell > ng-container {
  display: contents;
}

.dataset-review-cell strong, .dataset-review-cell small {
  display: block;
}

.dataset-review-cell strong {
  font-size: 14px;
  color: var(--ui-text);
  font-weight: 600;
}

.dataset-review-cell strong.review-remaining {
  color: var(--ui-warning);
}

.dataset-review-cell small {
  font-size: 12px;
  color: var(--ui-muted);
  margin-top: 4px;
  line-height: 1.6;
}

.dataset-review-cell progress {
  display: block;
  appearance: none;
  width: 100%;
  max-width: 180px;
  height: 4px;
  margin-top: 10px;
  border: 0;
  border-radius: 2px;
  overflow: hidden;
  background: var(--ui-line);
  accent-color: var(--ui-accent);
}

.dataset-review-cell progress::-webkit-progress-bar {
  background: var(--ui-line);
}

.dataset-review-cell progress::-webkit-progress-value {
  background: var(--ui-accent);
}

.dataset-review-cell progress::-moz-progress-bar {
  background: var(--ui-accent);
}

.datasets-content .dataset-next-cell {
  text-align: right;
  vertical-align: middle;
}

.datasets-content .dataset-next {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  background: transparent;
  border-color: transparent;
  color: var(--ui-accent);
  font-size: 13px;
  padding: 8px 14px;
  gap: 10px;
}

.datasets-content .dataset-next > i {
  flex: 0 0 auto;
  line-height: 1;
}

.datasets-content .dataset-next:hover {
  background: var(--ui-selected);
  border-color: transparent;
}

.datasets-content .register-footer {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  align-items: center;
  justify-content: stretch;
  gap: 12px;
  padding: 12px 18px;
  background: var(--ui-soft);
  border: 0;
}

.datasets-content .register-footer > .collection-scope {
  grid-column: 1;
  grid-row: 1;
  min-width: 0;
  margin: 0;
  overflow-wrap: anywhere;
}

.datasets-content .register-footer > .pagination {
  grid-column: 2;
  grid-row: 1;
  justify-self: center;
}

.datasets-content .pagination {
  width: 100%;
  justify-content: center;
}

.datasets-content .register-footer > .pagination {
  width: max-content;
  max-width: 100%;
}

.datasets-content :is(.button, .icon-button) {
  border-radius: 8px;
  font-size: 14px;
  min-height: 38px;
  transition: background-color var(--ui-duration, 180ms) var(--ui-ease), border-color var(--ui-duration, 180ms) var(--ui-ease);
}

.datasets-content .button.primary {
  background: var(--ui-accent);
  color: var(--ui-paper);
  border-color: transparent;
}

.datasets-content .button.primary:hover:not(:disabled) {
  background: var(--ui-accent-hover);
}

.datasets-content .button.secondary {
  background: var(--ui-paper);
  border-color: var(--ui-control);
  color: var(--ui-text);
}

.datasets-content :is(input, select, textarea) {
  border-color: var(--ui-control);
  border-radius: 8px;
  accent-color: var(--ui-accent);
}

.datasets-content select {
  appearance: auto;
}

.datasets-content input[type=checkbox] {
  appearance: auto;
  width: 18px;
  height: 18px;
  min-height: 18px;
  padding: 0;
  flex: 0 0 18px;
}

.datasets-content :is(.creation-workspace, .creation-materials, .execution-overview, .detail-workspace) {
  border: 0;
  border-radius: 14px;
  background: var(--ui-paper);
  box-shadow: none;
}

.datasets-content .creation-workspace .settings {
  background: var(--ui-soft);
  border: 0;
  border-right: 1px solid var(--ui-line);
}

.datasets-content .creation-workspace .panel-heading {
  background: transparent;
  padding: 16px 20px;
}

.datasets-content .creation-workspace .settings-body {
  padding: 18px 20px;
}

.datasets-content .creation-materials {
  overflow: hidden;
}

.datasets-content .creation-footer {
  padding: 16px 20px;
  background: var(--ui-soft);
  border-top: 1px solid var(--ui-line);
  border-radius: 0 0 14px 14px;
}

.datasets-content .detail-workspace {
  overflow: visible;
  border: 1px solid var(--ui-line);
}

.datasets-content .workspace-toolbar, .datasets-content .review-workspace .workspace-toolbar {
  position: sticky;
  top: var(--workspace-header-height, 0px);
  z-index: 8;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px 10px;
  padding: 8px 12px;
  background: var(--ui-soft);
  border: 0;
  border-bottom: 1px solid var(--ui-line);
  border-radius: 14px 14px 0 0;
  overflow: visible;
}

.datasets-content .workspace-tabs, .datasets-content .workspace-toolbar .workspace-tabs {
  display: flex;
  flex: 1 1 100%;
  width: 100%;
  min-width: 0;
  gap: 4px;
  flex-wrap: nowrap;
  padding: 0;
  background: transparent;
  border: 0;
  overflow-x: auto;
  scrollbar-width: thin;
}

.datasets-content .workspace-tabs button {
  flex: 0 0 auto;
  min-height: 40px;
  padding: 7px 11px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: var(--ui-text);
  font-size: 13px;
  white-space: nowrap;
}

.datasets-content .workspace-tabs button[aria-pressed=true] {
  background: var(--ui-accent);
  color: var(--ui-on-navy);
  box-shadow: none;
  border: 0;
}

.datasets-content .review-workspace .inspector-topbar {
  position: relative;
  top: auto;
  z-index: auto;
  display: flex;
  align-items: center;
  flex: 1 1 auto;
  justify-content: flex-end;
  min-height: 36px;
  padding: 0;
  margin: 0;
  border: 0;
  background: transparent;
  overflow: visible;
}

.datasets-content .review-workspace .inspector-controls {
  display: flex;
  width: auto;
  align-items: center;
  gap: 6px;
  padding: 0;
  margin: 0;
}

.datasets-content .review-workspace .item-navigation {
  display: flex;
  gap: 4px;
  width: auto;
  align-items: center;
  margin: 0;
}

.datasets-content .review-workspace .result-jump {
  display: flex;
  gap: 5px;
  min-width: 0;
}

.datasets-content .review-workspace .result-jump input {
  width: 48px;
  min-height: 36px;
}

.datasets-content .review-workspace .result-jump .button {
  min-height: 36px;
  padding: 6px 9px;
  font-size: 12px;
}

.datasets-content .review-workspace .item-navigation .icon-button {
  width: 34px;
  min-width: 34px;
  height: 36px;
  min-height: 36px;
}

.datasets-content .review-workspace #qa-queue-toggle {
  min-height: 36px;
  padding: 6px 9px;
  gap: 7px;
  border: 1px solid var(--ui-control);
  border-radius: 7px;
  background: var(--ui-paper);
  font-size: 13px;
}

.datasets-content .review-workspace #qa-queue-toggle span {
  display: inline;
}

.datasets-content .review-workspace .reading-menu-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 36px;
  min-height: 36px;
}

.datasets-content .review-workspace .reading-jumps {
  display: none;
  position: absolute;
  right: 0;
  left: auto;
  top: calc(100% + 8px);
  bottom: auto;
  width: 160px;
  z-index: 14;
  padding: 6px;
  border: 1px solid var(--ui-control);
  border-radius: 10px;
  background: var(--ui-paper);
  box-shadow: var(--ui-overlay-shadow);
}

.datasets-content .review-workspace .reading-jumps.is-open {
  display: grid;
  border: 1px solid var(--ui-control);
}

.datasets-content .review-workspace .reading-jumps .text-button {
  justify-content: flex-start;
  padding: 8px 10px;
  min-height: 40px;
  font-size: 13px;
}

.datasets-content .review-workspace .reading-jumps .text-button:hover {
  background: var(--ui-selected);
}

.datasets-content .review-workspace .qa-results {
  display: block;
  flex: none;
  min-height: 0;
}

.datasets-content .review-workspace .qa-workbench {
  display: block;
  position: relative;
  height: auto;
  min-height: 0;
  overflow: visible;
}

.datasets-content .review-workspace .qa-inspector {
  display: block;
  height: auto;
  min-height: 0;
  max-height: none;
  overflow: visible;
}

.datasets-content .review-workspace .inspection-columns {
  display: grid;
  grid-template-columns: minmax(0, 1.15fr) minmax(300px, 0.85fr);
  grid-template-areas: "reading evidence" "decision evidence";
  grid-template-rows: min-content 1fr;
  align-items: start;
  gap: 0;
  min-height: 0;
  overflow: visible;
  flex: none;
  background: var(--ui-paper);
}

.datasets-content .review-workspace .qa-reading {
  grid-area: reading;
  height: auto;
  min-height: 0;
  overflow: visible;
  scrollbar-gutter: auto;
  padding: 0;
}

.datasets-content .review-workspace .qa-question {
  padding: 22px 24px 18px;
  margin: 0;
  background: var(--ui-paper);
  border-bottom: 1px solid var(--ui-line);
}

.datasets-content .review-workspace .qa-question h3 {
  font-size: 21px;
  line-height: 1.65;
  letter-spacing: -0.025em;
  margin-top: 10px;
}

.datasets-content .review-workspace .qa-label {
  font-size: 13px;
  font-weight: 600;
  color: var(--ui-muted);
}

.datasets-content .review-workspace .qa-answer-section {
  padding: 20px 24px 24px;
  border: 0;
}

.datasets-content .review-workspace .qa-answer {
  font-size: 17px;
  line-height: 1.85;
  max-width: 72ch;
  color: var(--ui-ink);
}

.datasets-content .review-workspace .qa-support {
  grid-area: evidence;
  position: sticky;
  top: calc(var(--workspace-header-height, 0px) + 70px);
  align-self: start;
  min-height: 0;
  height: auto;
  max-height: calc(100dvh - var(--workspace-header-height, 0px) - 90px);
  overflow: auto;
  scrollbar-gutter: auto;
  padding: 22px;
  background: var(--ui-soft);
  border-left: 1px solid var(--ui-line);
  border-top: 0;
  border-radius: 0 0 12px 0;
}

.datasets-content .review-workspace .evidence-quotes blockquote {
  padding: 12px 0;
  border: 0;
  border-bottom: 1px solid var(--ui-line);
  border-radius: 0;
  background: transparent;
}

.datasets-content .review-workspace .review-bar {
  grid-area: decision;
  align-self: start;
  position: static;
  width: 100%;
  height: auto;
  padding: 16px 24px;
  margin: 0;
  background: var(--ui-soft);
  border-top: 1px solid var(--ui-line);
  border-radius: 0 0 0 12px;
}

.datasets-content .review-workspace .review-fields {
  gap: 10px;
  align-items: end;
}

.datasets-content .review-workspace .decision-field {
  flex: 0 1 132px;
}

.datasets-content .review-workspace .review-save-actions {
  display: flex;
  flex: 1 1 auto;
  justify-content: flex-end;
  gap: 8px;
  margin-left: 0;
}

.datasets-content .review-workspace .review-save-actions .button {
  min-height: 40px;
  font-size: 13px;
  padding: 9px 12px;
}

.datasets-content .review-workspace .qa-queue {
  background: var(--ui-paper);
  border: 1px solid var(--ui-line);
  border-radius: 0 0 12px 12px;
}

.datasets-content .review-workspace .qa-workbench.has-selection.queue-open > .qa-queue {
  position: absolute;
  inset: 0 auto auto 0;
  width: min(360px, 100%);
  max-height: calc(100dvh - var(--workspace-header-height, 0px) - 90px);
  height: auto;
  z-index: 7;
  box-shadow: var(--ui-overlay-shadow);
}

.datasets-content .review-workspace .qa-workbench:not(.has-selection) > .qa-queue {
  height: auto;
  max-height: none;
  overflow: visible;
}

.datasets-content .review-workspace .qa-list-pane {
  padding: 0;
  height: auto;
  max-height: 420px;
  overflow: auto;
}

.datasets-content .review-workspace .qa-result-row {
  padding: 14px 38px 14px 16px;
  min-height: 78px;
  border-color: var(--ui-line);
}

.datasets-content .review-workspace .qa-result-row.selected {
  background: var(--ui-selected);
  box-shadow: none;
  border-radius: 0;
}

.datasets-content .review-workspace :is(#qa-answer-region, #qa-answer-section, #qa-evidence-region, #qa-decision-region, #qa-review-feedback) {
  scroll-margin-top: calc(var(--workspace-header-height, 0px) + 74px);
}

.datasets-content .export-workspace {
  background: var(--ui-paper);
}

.datasets-content .export-summary {
  background: var(--ui-soft);
  border-radius: 10px;
}

.datasets-content .export-create {
  background: var(--ui-soft);
  border: 1px solid var(--ui-line);
  border-radius: 12px;
}

.datasets-content .source-picker {
  border: 0;
  border-radius: 16px;
  box-shadow: var(--ui-overlay-shadow);
}

.datasets-content .picker-header, .datasets-content .picker-footer, .datasets-content .picker-selection {
  background: var(--ui-soft);
}

@media (min-width: 1101px) and (min-height: 701px) {
  main.datasets-content.is-detail:has(.review-workspace) {
    display: block;
    height: auto;
    min-height: 0;
    padding: 24px;
  }
  main.datasets-content.is-detail:has(.review-workspace) > .detail-workspace {
    display: block;
    flex: none;
    height: auto;
  }
}
@media (max-width: 1200px) {
  .datasets-content .dataset-table th:first-child {
    width: 46%;
  }
  .datasets-content .dataset-table th:nth-child(2) {
    width: 29%;
  }
  .datasets-content .dataset-table th:nth-child(3) {
    width: 25%;
  }
  .datasets-content .review-workspace .inspection-columns {
    grid-template-columns: minmax(0, 1fr) minmax(280px, 0.85fr);
  }
  .datasets-content .review-workspace .review-save-actions {
    flex-basis: 100%;
    justify-content: flex-start;
  }
}
@media (max-width: 960px) {
  .datasets-content {
    padding: 20px 18px;
  }
  .datasets-content .creation-workspace .settings {
    border: 0;
    border-bottom: 1px solid var(--ui-line);
  }
  .datasets-content .review-workspace .inspection-columns {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    grid-template-areas: "reading" "evidence" "decision";
    grid-template-rows: auto;
  }
  .datasets-content .review-workspace .qa-support {
    position: static;
    max-height: none;
    overflow: visible;
    border-left: 0;
    border-top: 1px solid var(--ui-line);
    border-radius: 0;
  }
  .datasets-content .review-workspace .review-bar {
    border-radius: 0 0 12px 12px;
  }
  .datasets-content .review-workspace .qa-workbench.has-selection.queue-open > .qa-queue {
    position: static;
    width: 100%;
    max-height: none;
    box-shadow: none;
    overflow: visible;
  }
  .datasets-content .review-workspace .qa-list-pane {
    max-height: none;
    overflow: visible;
  }
  .datasets-content .workspace-toolbar, .datasets-content .review-workspace .workspace-toolbar {
    position: static;
  }
}
@media (max-width: 760px) {
  .datasets-content .dataset-table, .datasets-content .dataset-table tbody {
    display: block;
    width: 100%;
  }
  .datasets-content .dataset-table thead {
    display: none;
  }
  .datasets-content .dataset-table tbody tr {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 12px 14px;
    padding: 18px;
    border-bottom: 1px solid var(--ui-line);
  }
  .datasets-content .dataset-table tbody td {
    display: block;
    padding: 0;
    border: 0;
    width: auto;
  }
  .datasets-content .dataset-identity-cell {
    grid-column: 1/-1;
  }
  .datasets-content .dataset-table .dataset-title-cell .dataset-name {
    min-height: 44px;
  }
  .datasets-content .dataset-facts > summary {
    min-height: 44px;
  }
  .datasets-content .dataset-table .dataset-review-cell {
    grid-column: 1;
    grid-row: 2;
  }
  .datasets-content .dataset-table .dataset-next-cell {
    grid-column: 2;
    grid-row: 2;
    align-self: end;
  }
  .datasets-content .dataset-next-cell::before, .datasets-content .dataset-review-cell::before {
    display: none;
  }
  .datasets-content .dataset-review-cell progress {
    max-width: 160px;
  }
  .datasets-content .dataset-next {
    font-size: 13px;
    min-height: 44px;
  }
}
@media (max-width: 600px) {
  .datasets-content {
    padding: 18px 12px 24px;
  }
  .datasets-content .dataset-type-switch {
    display: flex;
    gap: 3px;
    width: 100%;
    padding: 4px;
  }
  .datasets-content .dataset-type-switch .button {
    flex: 1;
    min-height: 44px;
    padding: 8px 6px;
    font-size: 13px;
    white-space: normal;
  }
  .datasets-content :is(.button, .icon-button) {
    min-height: 44px;
  }
  .datasets-content :is(input:not([type=checkbox]), select, textarea) {
    min-height: 44px;
    font-size: 16px;
  }
  .datasets-content .collection-toolbar {
    padding: 12px;
    gap: 8px;
  }
  .datasets-content .dataset-table tbody tr {
    padding: 16px 14px;
  }
  .datasets-content .register-footer {
    grid-template-columns: minmax(0, 1fr);
    justify-items: center;
    padding: 12px 14px;
  }
  .datasets-content .register-footer > .collection-scope {
    grid-column: 1;
    grid-row: 1;
    text-align: center;
  }
  .datasets-content .register-footer > .pagination {
    grid-column: 1;
    grid-row: 2;
  }
  .datasets-content .workspace-toolbar, .datasets-content .review-workspace .workspace-toolbar {
    gap: 6px;
    padding: 8px;
  }
  .datasets-content .workspace-toolbar .workspace-tabs {
    gap: 3px;
  }
  .datasets-content .workspace-toolbar .workspace-tabs button {
    min-height: 44px;
    padding: 8px 10px;
  }
  .datasets-content .review-workspace .inspector-topbar {
    flex-basis: 100%;
    justify-content: flex-start;
    border-top: 1px solid var(--ui-line);
    padding-top: 7px;
  }
  .datasets-content .review-workspace .inspector-controls {
    display: flex;
    width: 100%;
    justify-content: space-between;
    gap: 4px;
  }
  .datasets-content .review-workspace .item-navigation {
    display: flex;
    width: auto;
    gap: 3px;
  }
  .datasets-content .review-workspace .result-jump input {
    width: 44px;
  }
  .datasets-content .review-workspace .item-navigation .icon-button, .datasets-content .review-workspace .reading-menu-toggle {
    min-height: 44px;
    min-width: 32px;
    width: 32px;
  }
  .datasets-content .review-workspace .result-jump .button {
    padding: 7px;
    min-height: 44px;
  }
  .datasets-content .review-workspace #qa-queue-toggle {
    padding: 7px;
    min-height: 44px;
  }
  .datasets-content .review-workspace .qa-question, .datasets-content .review-workspace .qa-answer-section, .datasets-content .review-workspace .qa-support {
    padding: 18px 16px;
  }
  .datasets-content .review-workspace .qa-question h3 {
    font-size: 19px;
  }
  .datasets-content .review-workspace .review-bar {
    padding: 14px;
  }
  .datasets-content .review-workspace .review-save-actions {
    justify-content: flex-end;
  }
  .datasets-content .creation-footer {
    padding: 14px;
  }
  .dataset-facts > summary {
    min-height: 36px;
  }
}
@media (max-width: 360px) {
  .datasets-content .review-workspace #qa-queue-toggle span {
    display: none;
  }
  .datasets-content .review-workspace .inspector-controls {
    display: flex;
    gap: 2px;
  }
  .datasets-content .review-workspace .item-navigation {
    display: flex;
    grid-column: auto;
    grid-row: auto;
  }
  .datasets-content .review-workspace .result-jump {
    gap: 3px;
  }
  .datasets-content .review-workspace #qa-queue-toggle {
    min-width: 36px;
    justify-content: center;
  }
}
@media (prefers-reduced-motion: reduce) {
  .datasets-content :is(.button, .icon-button, .qa-result-row) {
    transition: none;
  }
}`],
})
export class PageDatasetsComponent implements OnInit, OnDestroy {
    @ViewChild('instructions') instructions:any;
    queueOpen=false;
    private queueScroll=0;
    async toggleQueue() {
        if(this.reviewSaving) return;
        if(this.queueOpen) return this.closeQueue();
        this.queueScroll=window.scrollY || 0; this.queueOpen=true;
        await this.service.render();
        const list=document.getElementById('qa-question-list');
        if(window.innerWidth<=960) list?.scrollIntoView({block:'start',behavior:'instant'});
        const current=document.getElementById('result-'+this.selectedResult?.item_id);
        current?.scrollIntoView({block:'nearest',behavior:'instant'}); current?.focus({preventScroll:true});
    }
    async closeQueue(restoreFocus=true) {
        this.queueOpen=false; await this.service.render();
        if(window.innerWidth<=960) window.scrollTo({top:this.queueScroll,behavior:'instant'});
        if(restoreFocus) document.getElementById('qa-queue-toggle')?.focus({preventScroll:true});
    }
    dismissQueue(event:MouseEvent) {
        if(this.queueOpen && !(event.target as Element)?.closest('#qa-queue-toggle')) {
            this.queueOpen=false; this.service.render();
        }
    }
    instructionMode=false;
    async switchType(instruction:boolean) {
        if(instruction && !this.canWrite) return;
        if(this.instructionMode && this.instructions && !this.instructions.canLeave()) return;
        if(!this.instructionMode && !this.canDeactivate()) return;
        await this.router.navigate(['/datasets'],{queryParams:instruction ? {type:'instruction'}:{}});
        if(!instruction) await this.refresh();
    }
    @ViewChild('sourcePicker') sourcePicker!:ElementRef<HTMLDialogElement>;
    pickerOpen=false; pickerLoading=false; pickerSaving=false; pickerError='';
    pickerPath='storage'; pickerQuery=''; pickerSelected:any[]=[];
    pickerData:any={items:[],page:1,pages:1,total:0}; private pickerEpoch=0;
    private bodyOverflow:string|null=null;
    results:any={items:[],page:1,pages:1,total:0}; resultFilter='R:ALL'; detailTab='results'; inspectorTab='answer'; selectedResult:any=null; resultLoading=false;

    exportData:any=null; exportLoading=false; exportError=''; exportNotice=''; exportOperation=''; private exportEpoch=0;
    exportReason=''; exportExclusionsOpen=false; exportReturn=false;
    async loadExport(page=1, reason=this.exportReason) {
        if(!this.detail) return;
        const id=this.detail.request_id, epoch=++this.exportEpoch;
        this.exportLoading=true; this.exportError=''; await this.service.render();
        try {
            const data=await this.call('export_preview',{id,page,reason});
            if(epoch!==this.exportEpoch || this.detail?.request_id!==id) return;
            this.exportData=data; this.exportReason=data.excluded_items?.reason || ''; this.exportOperation='';
        } catch(e:any) { if(epoch===this.exportEpoch) { this.exportError=e.message; } }
        finally { if(epoch===this.exportEpoch) { this.exportLoading=false; await this.service.render(); } }
    }
    async filterExportReason(reason:string) {
        this.exportExclusionsOpen=true;
        await this.loadExport(1,reason);
    }
    async openExportItem(item:any) {
        if(this.busy || this.exportLoading || this.navigatingResult || !item.can_open || !this.leaveReview()) return;
        const epoch=this.detailEpoch;
        this.navigatingResult=true; this.exportReturn=true; this.detailTab='results';
        this.runFilter=this.detail.is_group ? item.request_id : '';
        this.resultFilter=this.appliedResultFilter='';
        this.resultQuery=this.appliedResultQuery=''; this.clearResult(); this.jumpError='';
        await this.service.render();
        try {
            if(!await this.loadResults(this.runFilter ? item.run_page : item.result_page,epoch) || epoch!==this.detailEpoch) return;
            const target=this.results.items.find((row:any)=>row.item_id===item.item_id);
            if(target) await this.showResult(target);
            else this.resultsError='문항 목록이 변경되었습니다. 내보내기 대상에서 다시 확인해 주세요.';
        } finally {
            if(epoch===this.detailEpoch) { this.navigatingResult=false; await this.service.render(); }
        }
    }
    async createExport() {
        if(this.busy || this.exportLoading || this.exportError || !this.exportData?.included) return;
        this.busy=true; this.exportError=''; this.exportNotice=''; await this.service.render();
        if(!this.exportOperation) this.exportOperation=Array.from(crypto.getRandomValues(new Uint8Array(16))).map(x=>x.toString(16).padStart(2,'0')).join('');
        try {
            const saved=await this.call('export_create',{id:this.detail.request_id,fingerprint:this.exportData.fingerprint,operation:this.exportOperation});
            this.exportNotice='v'+saved.version_no+' · '+saved.included_count+'건을 저장했습니다. ZIP 다운로드로 받을 수 있습니다.';
            await this.loadExport();
        } catch(e:any) { this.exportError=e.message; }
        finally { this.busy=false; await this.service.render(); }
    }
    async downloadExport(row:any) {
        if(this.busy) return;
        this.busy=true; this.exportError=''; await this.service.render();
        try {
            const response=await fetch('/wiz/api/page.datasets/export_download?export_id='+encodeURIComponent(row.export_id),{credentials:'same-origin'});
            if(!response.ok || !response.headers.get('content-type')?.includes('application/zip')) {
                const failure=await response.json();
                throw new Error(failure.data?.message || '다운로드하지 못했습니다. 다시 시도해 주세요.');
            }
            const url=URL.createObjectURL(await response.blob()), link=document.createElement('a');
            link.href=url; link.download='qa-v'+row.version_no+'-'+row.export_id.slice(0,8)+'.zip';
            document.body.appendChild(link); link.click(); link.remove(); setTimeout(()=>URL.revokeObjectURL(url),1000);
        } catch(e:any) { this.exportError=e.message || '다운로드하지 못했습니다.'; }
        finally { this.busy=false; await this.service.render(); }
    }

    mergeMode=false; mergeError=''; runFilter=''; historyScroll=0; private restoring=false;
    mergeSelected:any[]=[]; mergeName=''; mergeTarget:any=0; mergeOperation='';
    toggleMergeMode() { if(this.busy || !this.canWrite) return; this.mergeMode=!this.mergeMode; this.clearMerge(); }
    datasetRemaining(item:any) { return Number(item.review_summary?.pending || 0)+Number(item.review_summary?.held || 0); }
    datasetTask(item:any) {
        if(this.datasetRemaining(item)>0)return 'review';
        if(this.canWrite && item.review_summary?.total && item.capabilities?.can_export===true)return 'export';
        return item.review_summary?.total || this.isReviewer ? 'results' : 'execution';
    }
    datasetTaskLabel(item:any) {
        if(Number(item.review_summary?.pending || 0)>0)return item.review_summary?.resolved ? '이어서 검토' : '검토 시작';
        if(Number(item.review_summary?.held || 0)>0)return '보류 재검토';
        if(item.review_summary?.total)return this.canWrite && item.capabilities?.can_export===true ? '내보내기' : '검토 결과 보기';
        if(this.isReviewer) return '배정 내용 확인';
        return item.status_code==='PREPARED' ? '생성 준비 확인' : '진행 확인';
    }
    get reviewSummary() { return this.detail?.review_summary || {total:0,pending:0,reviewed:0,held:0,excluded:0,resolved:0,remaining:0,auto_held:0}; }
    get selectedRun() { return this.detail?.runs?.find((r:any)=>r.request_id===this.runFilter); }
    remember() {
        if(!this.detail || this.restoring) return;
        try { sessionStorage.setItem('qa-workspace:'+this.user?.id+':'+this.detail.request_id,JSON.stringify({
            filter:this.appliedResultFilter,q:this.appliedResultQuery,page:this.results.page,item:this.selectedResult?.item_id,
            tab:this.detailTab,run:this.runFilter,historyScroll:this.historyScroll})); } catch {}
    }
    recalled(id:string):any {
        try { return JSON.parse(sessionStorage.getItem('qa-workspace:'+this.user?.id+':'+id) || '{}'); } catch { return {}; }
    }
    canOpenTab(tab:string) {
        return tab==='results' || (this.canWrite && (['sources','execution'].includes(tab) ||
            (tab==='assignments' && this.canAssignDetail) || (tab==='export' && this.canExportDetail)));
    }
    async setTab(tab:string) {
        if(this.busy || this.assignmentBusy || this.reviewSaving || !this.leaveReview()) return;
        if(!this.canOpenTab(tab)) return;
        if(this.detailTab==='execution') this.historyScroll=window.scrollY;
        this.queueOpen=false; this.detailTab=tab; this.remember(); await this.service.render();
        if(tab==='execution') window.scrollTo({top:this.historyScroll});
        if(tab==='results' && !this.selectedResult && this.results.items.length) await this.showResult(this.results.items[0]);
        if(tab==='assignments') await this.loadAssignments();
        if(tab==='export') await this.loadExport(this.exportData?.excluded_items?.page || 1);
    }
    async viewRun(run:any) {
        if(!this.leaveReview()) return;
        this.historyScroll=window.scrollY; this.runFilter=run.request_id; this.detailTab='results';
        this.resultQuery=''; this.resultFilter=''; await this.filterResults();
        document.getElementById('results-title')?.scrollIntoView({block:'start'});
    }
    async clearRun() {
        if(!this.leaveReview()) return;
        this.runFilter=''; await this.filterResults();
    }
    async startReview(filter='R:PENDING') {
        if(!this.leaveReview()) return;
        this.runFilter=''; this.resultQuery=''; this.resultFilter=filter; this.detailTab='results';
        await this.filterResults();
        if(this.results.items.length && !this.selectedResult) await this.showResult(this.results.items[0]);
    }
    async reviewShortcut(event:KeyboardEvent) {
        if(!this.detail || this.detailTab!=='results' || this.reviewSaving || this.pickerOpen) return;
        if(event.key==='Escape' && this.queueOpen) { event.preventDefault(); await this.closeQueue(); return; }
        if(event.altKey && ['ArrowLeft','ArrowRight'].includes(event.key)) {
            event.preventDefault(); await this.moveResult(event.key==='ArrowLeft' ? -1 : 1);
        } else if((event.ctrlKey || event.metaKey) && event.key==='Enter' && this.reviewDirty) {
            event.preventDefault(); await this.saveReview(true);
        }
    }
    @HostListener('document:keydown', ['$event'])
    onReviewKey(event:KeyboardEvent) {
        if(event.key==='Escape' && this.readingMenuOpen){this.closeReadingMenuKey(event);return;}
        this.reviewShortcut(event);
    }
    readingMenuOpen=false;
    closeReadingMenuKey(event:KeyboardEvent) {
        if(!this.readingMenuOpen)return;
        event.preventDefault();this.readingMenuOpen=false;this.service.render();
        document.querySelector<HTMLElement>('.reading-menu-toggle')?.focus({preventScroll:true});
    }
    @HostListener('document:click',['$event'])
    closeReadingMenuOutside(event:MouseEvent) {
        if(!this.readingMenuOpen || (event.target as Element)?.closest?.('#qa-reading-menu, .reading-menu-toggle'))return;
        this.readingMenuOpen=false;this.service.render();
    }
    quoteText(value:string) {
        return String(value || '').replace(/\r\n?/g,'\n').split(/\n[ \t]*\n+/).map(block=>
            /[\t|]|^\s*(?:[-*•]|\d+[.)])\s/m.test(block) ? block : block.split('\n').map(line=>line.trim()).join(' ')
        ).join('\n\n');
    }
    jumpSection(id:string) {
        if(this.reviewSaving || this.resultLoading || !this.selectedResult)return;
        this.readingMenuOpen=false;this.service.render();
        const element=document.getElementById(id);
        if(!element)return;
        element.scrollIntoView({block:'start',behavior:'instant'});
        element.focus({preventScroll:true});
    }
    async focusReviewElement(id:string) {
        await this.service.render();
        const element=document.getElementById(id);
        element?.scrollIntoView({block:'nearest',behavior:'instant'});element?.focus({preventScroll:true});
    }
    taxonomy(values:any[],value:string) { return values.find(x=>x.value===value)?.label || value || '미분류'; }
    async completeAndNext() {
        if(this.reviewSaving || this.resultLoading || !this.reviewForm || this.reviewEditing || this.reviewDirty) return;
        this.reviewForm.decision='REVIEWED'; await this.saveReview(true);
    }
    async unmerge() {
        if(this.busy || !this.detail?.can_unmerge || !this.leaveReview()) return;
        if(!window.confirm('원래 '+this.detail.runs.length+'개 데이터셋으로 나눕니다. 문항과 검토 이력은 그대로 유지됩니다. 묶기를 해제하시겠습니까?')) return;
        this.busy=true; this.error=''; await this.service.render();
        try { await this.call('unmerge',{id:this.detail.request_id}); this.busy=false; await this.back(); this.notice='묶기를 해제했습니다. 문항과 검토 이력은 유지됩니다.'; }
        catch(e:any) { this.error=e.message; }
        finally { this.busy=false; await this.service.render(); }
    }
    toggleMerge(item:any) {
        if(this.busy || !item.can_merge) return;
        this.mergeSelected=this.mergeSelected.some(x=>x.request_id===item.request_id) ? this.mergeSelected.filter(x=>x.request_id!==item.request_id) : [...this.mergeSelected,item];
        this.mergeTarget=this.mergeSelected.reduce((sum,x)=>sum+x.target_count,0); this.mergeOperation=''; this.mergeError='';
        this.service.render();
    }
    mergeChecked(id:string) { return this.mergeSelected.some(x=>x.request_id===id); }
    clearMerge() { this.mergeSelected=[]; this.mergeName=''; this.mergeTarget=0; this.mergeOperation=''; this.mergeError=''; }
    async mergeDatasets() {
        if(this.busy || this.mergeSelected.length<2) return;
        if(!this.mergeName.trim() || !Number.isInteger(Number(this.mergeTarget)) || Number(this.mergeTarget)<1) {
            this.mergeError='묶을 데이터셋의 이름과 전체 목표 수량을 입력해 주세요.'; return;
        }
        this.busy=true; this.error=''; await this.service.render();
        if(!this.mergeOperation) this.mergeOperation=Array.from(crypto.getRandomValues(new Uint8Array(16))).map(x=>x.toString(16).padStart(2,'0')).join('');
        try {
            const result=await this.call('merge',{ids:JSON.stringify(this.mergeSelected.map(x=>x.request_id)),name:this.mergeName.trim(),target:this.mergeTarget,operation:this.mergeOperation});
            this.clearMerge(); this.mergeMode=false; this.busy=false; await this.router.navigate(['/datasets'],{queryParams:{id:result.collection_id}});
        } catch(e:any) { this.mergeError=e.message; }
        finally { this.busy=false; await this.service.render(); }
    }
    openRow(event:MouseEvent) { if(!this.busy && !this.loading) activateListRow(event); }
    listQuery=''; listStatus=''; listKind=''; listSort='newest'; listScopeFiltered=false;
    previewFile:any=null; previewUnit:any=null; previewText:any=null; previewLoading=false; previewError='';
    private previewEpoch=0; navigatingResult=false; private previewCache=new Map<number,any>(); private resultsEpoch=0;
    private pollTimer:any; private detailEpoch=0; private detailRequestEpoch=0; private itemEpoch=0;
    resultsLoading=false; resultsError=''; resultQuery=''; private appliedResultQuery=''; resultJump:any=1; jumpError='';
    reviewForm:any=null; reviewBaseline=''; reviewEditing=false; reviewSaving=false; reviewError=''; reviewNotice=''; private appliedResultFilter='R:ALL';
    reviewPhase=''; reviewRecovery:any=null;
    noteExpanded=false; detailsExpanded=false; moreEvidence=false; expandedQuotes:Record<string,boolean>={};
    async openReviewNote() { this.noteExpanded=true; await this.focusReviewElement('review-note'); }
    async openReviewDetails() { this.detailsExpanded=true; await this.service.render(); document.querySelector<HTMLElement>('#qa-review-details>summary')?.focus(); }
    hasLongQuote(key:string) { return this.selectedResult?.result?.candidate?.citations?.some((c:any)=>c.evidence_key===key && c.quote?.length>180); }
    toggleQuote(key:string) { this.expandedQuotes[key]=!this.expandedQuotes[key]; this.service.render(); }
    reviewKinds=[{value:'CONCEPT',label:'개념'},{value:'SYMPTOMS',label:'증상'},{value:'PATTERN',label:'변증'},{value:'MECHANISM',label:'기전'},{value:'DIFFERENTIAL',label:'감별'},{value:'PROCEDURE',label:'절차'},{value:'TREATMENT_SELECTION',label:'치료 선택'},{value:'TREATMENT_PRINCIPLE',label:'치료 원칙'},{value:'ACUPOINT',label:'혈위·혈성'},{value:'MODIFICATION',label:'가감'},{value:'SAFETY',label:'안전'},{value:'SUMMARY',label:'요약'},{value:'REASONING',label:'추론'},{value:'DECISION',label:'의사결정'},{value:'TREATMENT',label:'치료'},{value:'COMPARISON',label:'비교'}];
    reviewStages=[{value:'INTAKE',label:'문진'},{value:'DIAGNOSIS',label:'진단'},{value:'PATTERN',label:'변증'},{value:'TREATMENT',label:'치료'},{value:'FOLLOW_UP',label:'경과 관찰'}];
    get reviewDirty() { return !!this.reviewForm && JSON.stringify(this.reviewForm)!==this.reviewBaseline; }
    reviewLabel(value:string) { return ({PENDING:'검토 대기',REVIEWED:'검토 완료',HELD:'보류',EXCLUDED:'제외'} as any)[value] || '검토 대기'; }
    reviewTone(value:string) { return ({PENDING:'neutral',REVIEWED:'good',HELD:'attention',EXCLUDED:'neutral'} as any)[value] || 'neutral'; }
    acceptReview(result:any) {
        this.reviewRecovery=null;
        this.noteExpanded=false; this.detailsExpanded=false; this.moreEvidence=false; this.expandedQuotes={};
        this.reviewForm=result.review_form ? {...result.review_form} : null;
        this.reviewBaseline=JSON.stringify(this.reviewForm); this.reviewEditing=false; this.reviewError='';
    }
    leaveReview() {
        if(this.reviewSaving) return false;
        if(this.reviewDirty && !window.confirm('저장하지 않은 검토 내용이 있습니다. 변경사항을 버리고 이동하시겠습니까?')) return false;
        if(this.reviewDirty) this.reviewForm=JSON.parse(this.reviewBaseline);
        return true;
    }
    editReview() { this.reviewEditing=true; this.reviewNotice=''; this.service.render().then(()=>document.getElementById('review-question')?.focus()); }
    reviewMetaChanged() {
        if(!this.reviewForm)return;
        if(['HELD','EXCLUDED'].includes(this.reviewForm.decision))this.noteExpanded=true;
        this.reviewNotice='';this.reviewError='';this.service.render();
    }
    reviewTextChanged() { this.reviewForm.decision='PENDING';this.reviewMetaChanged(); }
    cancelReviewEdit() {
        if(!this.leaveReview()) return;
        this.reviewEditing=false; this.reviewError=''; this.service.render();
    }
    async continueReview(context:any) {
        const {epoch,itemId,oldIndex,page,next}=context;
        if(!await this.loadResults(page,epoch))throw new Error(this.resultsError || '검토 목록을 불러오지 못했습니다.');
        if(epoch!==this.detailEpoch)return;
        if(!this.results.items.length && this.results.total && this.results.page>1) {
            if(!await this.loadResults(Math.max(1,Math.min(this.results.pages,this.results.page-1)),epoch))throw new Error(this.resultsError || '검토 목록을 불러오지 못했습니다.');
        }
        if(epoch!==this.detailEpoch)return;
        const index=this.results.items.findIndex((x:any)=>x.item_id===itemId);
        let target:any=null;
        if(next) {
            if(index<0 && this.results.items.length)target=this.results.items[Math.min(oldIndex,this.results.items.length-1)];
            else if(index>=0 && index+1<this.results.items.length)target=this.results.items[index+1];
            else if(index>=0 && this.results.page<this.results.pages) {
                if(!await this.loadResults(this.results.page+1,epoch))throw new Error(this.resultsError || '다음 검토 목록을 불러오지 못했습니다.');
                target=this.results.items[0];
            }
            if(epoch!==this.detailEpoch)return;
            if(target)await this.showResult(target,true);
        }
        if(epoch!==this.detailEpoch)return;
        this.reviewRecovery=null;
        this.reviewNotice=this.reviewSummary.total && !this.reviewSummary.remaining
            ? '모든 문항의 검토 처리가 끝났습니다.'
            : next ? (target ? '저장했습니다. 다음 문항입니다.' : '저장했습니다. 현재 조건의 마지막 문항입니다.')
            : index<0 ? '저장했습니다. 현재 문항은 선택한 목록 조건에서 제외되었습니다.' : '저장했습니다.';
    }
    async retryReviewContinuation() {
        if(!this.reviewRecovery || this.reviewSaving || this.resultLoading || this.navigatingResult || this.reviewDirty)return;
        const context=this.reviewRecovery;
        if(context.epoch!==this.detailEpoch)return;
        this.reviewSaving=true;this.reviewPhase=context.next?'next':'refresh';this.reviewError='';await this.service.render();
        try {await this.continueReview(context);}
        catch(e:any){if(context.epoch===this.detailEpoch){this.reviewRecovery=context;this.reviewError=e.message;}}
        finally {this.reviewSaving=false;this.reviewPhase='';await this.service.render();}
        if(this.reviewError)await this.focusReviewElement('qa-review-feedback');
    }
    async saveReview(next=false) {
        if(this.reviewSaving || this.resultLoading || this.navigatingResult || !this.selectedResult || !this.reviewDirty)return;
        if(['HELD','EXCLUDED'].includes(this.reviewForm.decision) && !this.reviewForm.note?.trim()) {
            this.reviewError='보류·제외 사유를 입력해 주세요.';await this.openReviewNote();return;
        }
        const context={epoch:this.detailEpoch,itemId:this.selectedResult.item_id,oldIndex:this.resultIndex,page:this.results.page,next};
        this.reviewSaving=true;this.reviewPhase='saving';this.reviewRecovery=null;this.reviewError='';this.reviewNotice='';await this.service.render();
        try {
            const result=await this.call('review_save',{id:this.detail.request_id,item_id:context.itemId,
                revision:this.selectedResult.review_revision,data:JSON.stringify(this.reviewForm)});
            if(context.epoch!==this.detailEpoch)return;
            this.queueOpen=false;this.selectedResult=result;this.acceptReview(result);
            this.reviewRecovery=context;this.reviewPhase=next?'next':'refresh';this.reviewNotice='저장했습니다.';await this.service.render();
            await this.continueReview(context);
        } catch(e:any){if(context.epoch===this.detailEpoch)this.reviewError=e.message;}
        finally {this.reviewSaving=false;this.reviewPhase='';await this.service.render();}
        if(this.reviewError)await this.focusReviewElement('qa-review-feedback');
    }

    assignments:any=null; assignmentUser=''; assignmentBusy=false; assignmentLoading=false;
    assignmentError=''; assignmentNotice=''; private assignmentEpoch=0;
    get availableReviewers() {
        const assigned=new Set((this.assignments?.items || []).map((row:any)=>row.user_id));
        return (this.assignments?.eligible_users || []).filter((row:any)=>!assigned.has(row.id));
    }
    async loadAssignments() {
        if(!this.canAssignDetail) return;
        const id=this.detail.request_id, epoch=++this.assignmentEpoch;
        this.assignmentLoading=true; this.assignmentError=''; await this.service.render();
        try {
            const result=await this.call('review_assignments',{id});
            if(epoch===this.assignmentEpoch && this.detail?.request_id===id) this.assignments=result;
        } catch(e:any) { if(epoch===this.assignmentEpoch)this.assignmentError=e.message; }
        finally { if(epoch===this.assignmentEpoch){this.assignmentLoading=false;await this.service.render();} }
    }
    async changeAssignment(row:any=null) {
        if(this.assignmentBusy || this.assignmentLoading || !this.canAssignDetail || (!row && !this.assignmentUser)) return;
        if(row && !window.confirm(row.name+' 님의 검수 배정을 해제하시겠습니까? 기존 검토 이력은 보존됩니다.')) return;
        const id=this.detail.request_id, epoch=this.assignmentEpoch;
        this.assignmentBusy=true;this.assignmentError='';this.assignmentNotice='';await this.service.render();
        try {
            const result=await this.call(row ? 'review_assignment_revoke' : 'review_assignment_save',
                row ? {id,assignment_id:row.assignment_id} : {id,user_id:this.assignmentUser});
            if(epoch!==this.assignmentEpoch || this.detail?.request_id!==id)return;
            this.assignments=result;this.assignmentUser='';
            this.assignmentNotice=row ? '배정을 해제했습니다. 기존 검토 이력은 유지됩니다.' : '검수자를 배정했습니다. 해당 사용자의 QA 목록에서 검토할 수 있습니다.';
        } catch(e:any){if(epoch===this.assignmentEpoch)this.assignmentError=e.message;}
        finally{this.assignmentBusy=false;await this.service.render();}
    }

    requestedDetailId='';
    async retryDataset() {
        if(this.busy || this.loading)return;
        const id=this.requestedDetailId || this.detail?.request_id;
        if(id)await this.openDetail(id,!!this.detail);else await this.refresh();
    }
    workspacePage = '데이터셋'; user:any; csrf='';
    data:any={items:[],page:1,pages:1,total:0}; draft:any={type:'QA',name:'',target:100,selection:[],excluded:[],ranges:{}};
    selectionExpanded=false; revision=0; loading=false; busy=false; error=''; notice=''; editing=false; dirty=false;
    plan:any=null; detail:any=null; previewPage=1; inputPage=1; idempotency=''; private routeSub:any; private alive=true; private listRequest=0;
    constructor(@Inject(Service) public service:Service,@Inject(ActivatedRoute)  private route:ActivatedRoute,@Inject(Router)  private router:Router) {
        const prepared=this.route.snapshot.data['workspace'];
        this.user=prepared?.session?.data?.user; this.csrf=prepared?.session?.data?.csrf || '';
        if(prepared?.instructionMode && this.canWrite) this.instructionMode=true;
        else if(prepared?.result?.code===200) this.apply(prepared.result.data);
        else if(prepared?.result?.code===204) this.loading=!this.instructionMode;
        else this.error=prepared?.result?.data?.message || '데이터셋을 불러오지 못했습니다.';
    }
    get canAccessQA() { return this.user?.status==='active' && ['admin','researcher','reviewer'].includes(this.user?.role); }
    get isReviewer() { return this.user?.status==='active' && this.user?.role==='reviewer'; }
    get pageHeading() { return this.detail ? this.detail.name : this.isReviewer ? 'QA 검수' : this.editing ? '새 데이터셋' : this.requestedDetailId ? '데이터셋 상세' : '데이터셋'; }
    get canManageDetail() { return this.canWrite && this.detail?.capabilities?.can_manage===true; }
    get canExportDetail() { return this.canWrite && this.detail?.capabilities?.can_export===true; }
    get canAssignDetail() { return this.canWrite && this.detail?.capabilities?.can_assign===true; }
    get canWrite() { return this.user?.status==='active' && ['admin','researcher'].includes(this.user?.role); }
    async ngOnInit() {
        await this.service.init(); if(!this.alive)return; document.title=(this.isReviewer ? 'QA 검수' : '데이터셋')+' · 한의문헌 저작도구';
        let initial=true;
        this.routeSub=this.route.queryParamMap.subscribe(params=>{
            this.exportEpoch++; this.navigatingResult=false; this.exportReturn=false;
            clearTimeout(this.pollTimer); this.detailEpoch++; this.previewEpoch++; this.previewFile=null; this.previewText=null; this.results={items:[],page:1,pages:1,total:0}; this.selectedResult=null; this.reviewForm=null; this.reviewBaseline=''; this.reviewNotice=''; this.appliedResultFilter='R:ALL';
            this.detailRequestEpoch++; this.itemEpoch++; this.resultsEpoch++; this.resultLoading=false; this.resultsLoading=false;
            this.runFilter=''; this.detailTab='results'; this.inspectorTab='answer'; this.resultFilter='R:ALL'; this.resultQuery=''; this.appliedResultQuery=''; this.resultsError=''; this.jumpError=''; this.editing=params.get('new')==='1'; this.detail=null; this.error=initial?this.error:'';
            this.requestedDetailId=params.get('id') || '';
            this.instructionMode=this.canWrite && params.get('type')==='instruction';
            this.assignments=null; this.assignmentUser=''; this.assignmentError=''; this.assignmentNotice=''; this.assignmentEpoch++;
            this.editing=this.editing && this.canWrite;
            if(this.user?.role==='reviewer')this.error='';
            if(!this.instructionMode && params.get('id') && this.canAccessQA) this.openDetail(params.get('id')!,false,params.get('task') || '');
            else if(initial && this.loading && !this.instructionMode && this.canAccessQA) this.refresh();
            else this.loading=false;
            initial=false;
            this.service.render();
        });
    }
    ngOnDestroy() { this.alive=false; this.listRequest++; this.exportEpoch++; clearTimeout(this.pollTimer); this.detailEpoch++; this.detailRequestEpoch++; this.itemEpoch++; this.resultsEpoch++; this.previewEpoch++; this.routeSub?.unsubscribe(); this.pickerEpoch++; this.restorePickerScroll(); }
    @HostListener('window:beforeunload', ['$event'])
    beforeUnload(event:BeforeUnloadEvent) { if(this.dirty || this.busy || this.reviewDirty || this.reviewSaving) { event.preventDefault(); event.returnValue=''; } }
    canDeactivate() { if(this.instructionMode && this.instructions) return this.instructions.canLeave(); return !this.busy && !this.assignmentBusy && !this.pickerSaving && this.leaveReview() && (!this.dirty || window.confirm('저장하지 않은 변경사항이 있습니다. 화면을 나가시겠습니까?')); }
    apply(data:any) {
        this.data=data; this.draft=data.draft || {type:'QA',name:'',target:100,selection:[],excluded:[],ranges:{}}; this.revision=data.revision || 0; this.dirty=false;
    }
    async call(action:string, values:any={}) {
        try {
            const response=await wiz.app('page.datasets').call(action,{csrf:this.csrf,...values});
            if(response.code===401) { this.service.href('/access/login'); throw new Error('로그인이 필요합니다.'); }
            if(response.code!==200) throw new Error(response.data?.message || '처리하지 못했습니다. 다시 시도해 주세요.');
            return response.data;
        } catch(error:any) {
            throw new Error(error?.responseJSON?.data?.message || error?.data?.message || error?.message ||
                '요청을 완료하지 못했습니다. 연결을 확인한 뒤 다시 시도해 주세요.');
        }
    }
    async refresh(page=1) {
        if(this.busy || !this.alive) return;
        const request=++this.listRequest;
        this.loading=true; this.error=''; await this.service.render();
        const query={page,q:this.listQuery,status:this.listStatus,kind:this.listKind,sort:this.listSort};
        try {
            const data=await this.call('list',query);
            if(!this.alive || request!==this.listRequest)return;
            this.apply(data);
            this.listScopeFiltered=!!(query.q.trim() || query.status || query.kind); this.plan=null;
        }
        catch(e:any) { if(this.alive && request===this.listRequest)this.error=e.message; }
        finally { if(this.alive && request===this.listRequest){this.loading=false; await this.service.render();} }
    }
    hasDraft(value=this.draft) { return !!(value.name || value.selection.length || value.target!==100); }
    async newDataset() {
        if(this.busy) return;
        this.busy=true; this.error=''; await this.service.render();
        try {
            const current=await this.call('draft');
            if(this.hasDraft(current.draft) && !window.confirm('새로 작성하면 저장된 초안 “'+(current.draft.name || '이름 없는 데이터셋')+'”을 교체합니다. 기존 초안을 이어 쓰려면 취소해 주세요. 새로 작성하시겠습니까?')) return;
            const result=await this.call('draft_save',{revision:current.revision,data:JSON.stringify({type:'QA',name:'',target:100,selection:[],excluded:[],ranges:{}})});
            this.draft=result.draft; this.revision=result.revision; this.dirty=false; this.notice='';
            this.plan=null; this.detail=null; this.closePreview(); this.idempotency='';
            this.busy=false; await this.router.navigate(['/datasets'],{queryParams:{new:1}});
        } catch(e:any) { this.error=e.message; }
        finally { this.busy=false; await this.service.render(); }
    }
    async resumeDraft() {
        if(this.busy) return;
        this.busy=true; this.error=''; await this.service.render();
        try {
            const current=await this.call('draft');
            this.draft=current.draft; this.revision=current.revision; this.dirty=false;
            this.plan=null; this.notice=''; this.idempotency='';
            await this.router.navigate(['/datasets'],{queryParams:{new:1}});
        } catch(e:any) { this.error=e.message; }
        finally { this.busy=false; await this.service.render(); }
    }
    get settingsError() {
        return Number.isInteger(this.draft.target) && this.draft.target>=1 && this.draft.target<=10000 ? '' : '목표 수량은 1~10,000 사이의 정수로 입력해 주세요.';
    }
    change(materials=true) {
        this.dirty=true; this.idempotency=''; this.notice='';
        if(materials) {
            this.closePreview(); this.previewCache.clear();
            if(this.plan) this.plan.stale=true;
        }
    }
    async save() {
        const result=await this.call('draft_save',{data:JSON.stringify(this.draft),revision:this.revision});
        this.draft=result.draft; this.revision=result.revision; this.dirty=false;
    }
    async saveDraft() {
        if(this.busy) return; this.busy=true; this.error=''; await this.service.render();
        try { await this.save(); this.notice='초안을 저장했습니다.'; }
        catch(e:any) { this.error=e.message; }
        finally { this.busy=false; await this.service.render(); }
    }
    async addSources() {
        if(this.busy || this.pickerOpen) return;
        this.pickerSelected=[]; this.pickerError=''; this.pickerOpen=true;
        this.pickerPath='storage'; this.pickerQuery='';
        this.bodyOverflow=document.body.style.overflow; document.body.style.overflow='hidden';
        this.sourcePicker.nativeElement.showModal();
        await this.browsePicker('storage');
    }
    restorePickerScroll() {
        if(this.bodyOverflow!==null) { document.body.style.overflow=this.bodyOverflow; this.bodyOverflow=null; }
    }
    closePicker(event?:Event) {
        if(this.pickerSaving) { event?.preventDefault(); return; }
        this.pickerEpoch++; this.pickerOpen=false; this.pickerLoading=false;
        this.sourcePicker.nativeElement.close(); this.restorePickerScroll();
        this.service.render();
    }
    async browsePicker(path:string, page=1, search=false) {
        if(this.pickerSaving) return;
        const epoch=++this.pickerEpoch;
        if(path!==this.pickerPath || !search) this.pickerQuery='';
        this.pickerPath=path; this.pickerLoading=true; this.pickerError='';
        this.pickerData={items:[],page:1,pages:1,total:0};
        await this.service.render();
        try {
            const res=await wiz.app('page.sources').call('browse',{path,q:this.pickerQuery,page});
            if(epoch!==this.pickerEpoch || !this.pickerOpen) return;
            if(res.code!==200) throw new Error(res.data?.message || '자료를 불러오지 못했습니다.');
            this.pickerData=res.data;
        } catch(e:any) { if(epoch===this.pickerEpoch) this.pickerError=e.message || '자료를 불러오지 못했습니다. 다시 시도해 주세요.'; }
        finally { if(epoch===this.pickerEpoch) { this.pickerLoading=false; await this.service.render(); } }
    }
    pickerCrumbs() {
        const parts=this.pickerPath.split('/');
        return parts.map((name,index)=>({name:index===0?'보관함':name,key:parts.slice(0,index+1).join('/')}));
    }
    alreadyAdded(item:any) {
        return this.draft.selection.some((x:any)=>x.key===item.key || (x.kind==='folder' && item.key.startsWith(x.key+'/')));
    }
    picked(item:any) { return this.pickerSelected.some(x=>x.key===item.key); }
    pickerEligible(item:any) { return !['blocked','missing','changed'].includes(item.state) && !this.alreadyAdded(item); }
    togglePicker(item:any) {
        if(this.pickerSaving || !this.pickerEligible(item)) return;
        if(this.picked(item)) this.pickerSelected=this.pickerSelected.filter(x=>x.key!==item.key);
        else {
            if(this.pickerSelected.length+this.draft.selection.length>=200) { this.pickerError='파일·폴더는 최대 200개까지 담을 수 있습니다.'; return; }
            this.pickerSelected=[...this.pickerSelected,{key:item.key,kind:item.kind,name:item.name}];
        }
        this.service.render();
    }
    removePicked(key:string) { this.pickerSelected=this.pickerSelected.filter(x=>x.key!==key); this.service.render(); }
    pickerAll() {
        const items=this.pickerData.items.filter((x:any)=>this.pickerEligible(x));
        return items.length>0 && items.every((x:any)=>this.picked(x));
    }
    togglePickerPage() {
        const items=this.pickerData.items.filter((x:any)=>this.pickerEligible(x));
        if(this.pickerAll()) { const keys=new Set(items.map((x:any)=>x.key)); this.pickerSelected=this.pickerSelected.filter(x=>!keys.has(x.key)); }
        else for(const item of items) if(!this.picked(item)) this.togglePicker(item);
        this.service.render();
    }
    pickerStatus(item:any) {
        if(this.alreadyAdded(item)) return '이미 담은 자료';
        if(item.state==='missing') return '파일 없음';
        if(item.state==='blocked') return '접근 불가';
        if(item.state==='changed') return '원본 변경됨';
        if(item.kind==='folder') return '하위 파일 포함';
        if(item.state==='unregistered') return '등록 필요';
        return item.format || '파일';
    }
    async confirmPicker() {
        if(this.pickerSaving || !this.pickerSelected.length) return;
        this.pickerSaving=true; this.pickerError=''; await this.service.render();
        const selected=this.pickerSelected.map(x=>({key:x.key,kind:x.kind}));
        const addedKeys=new Set(selected.map(x=>x.key));
        const payload={...this.draft,selection:[...this.draft.selection,...selected],
            excluded:this.draft.excluded.filter((key:string)=>!addedKeys.has(key))};
        try {
            const result=await this.call('draft_save',{data:JSON.stringify(payload),revision:this.revision});
            this.draft=result.draft; this.revision=result.revision; this.dirty=false;
            this.closePreview(); this.previewCache.clear();
            if(this.plan) this.plan.stale=true;
            this.idempotency=''; this.notice=selected.length+'개 항목을 담았습니다.';
            this.pickerSaving=false; this.closePicker();
        } catch(e:any) { this.pickerError=e.message; }
        finally { this.pickerSaving=false; await this.service.render(); }
    }
    remove(key:string) {
        this.draft.selection=this.draft.selection.filter((x:any)=>x.key!==key);
        this.change();
    }
    async prepare() {
        if(this.busy) return; this.busy=true; this.error=''; this.notice=''; await this.service.render();
        try {
            await this.save();
            this.plan=await this.call('prepare',{revision:this.revision}); this.previewPage=1; this.selectionExpanded=false; this.previewCache.clear(); this.previewFile=null; this.previewText=null;
            this.idempotency=Array.from(crypto.getRandomValues(new Uint8Array(16))).map(x=>x.toString(16).padStart(2,'0')).join('');
        } catch(e:any) { this.error=e.message; this.plan=null; }
        finally { this.busy=false; await this.service.render(); }
    }
    exclude(item:any) {
        const excluded=new Set<string>(this.draft.excluded);
        if(excluded.has(item.key)) excluded.delete(item.key); else excluded.add(item.key);
        this.draft.excluded=Array.from(excluded); this.change();
    }
    range(item:any, value:string) { this.draft.ranges[item.key]=value; this.change(); }
    async submit() {
        if(this.busy || !this.plan?.summary?.usable_pages || this.plan.stale || this.settingsError || !this.draft.name.trim()) return;
        this.busy=true; this.error=''; await this.service.render();
        try {
            if(this.dirty) await this.save();
            if(!this.idempotency) this.idempotency=Array.from(crypto.getRandomValues(new Uint8Array(16))).map(x=>x.toString(16).padStart(2,'0')).join('');
            const result=await this.call('submit',{revision:this.revision,fingerprint:this.plan.fingerprint,idempotency:this.idempotency});
            this.dirty=false; this.plan=null; this.busy=false;
            await this.refresh(); await this.router.navigate(['/datasets'],{queryParams:{id:result.request_id}});
            await this.control('start',result.request_id);
        } catch(e:any) { this.error=e.message; }
        finally { this.busy=false; await this.service.render(); }
    }
    status(value:string) { return ({PREPARED:'시작 전',QUEUED:'대기 중',RUNNING:'생성·검수 중',PAUSING:'일시정지 중',PAUSED:'일시정지',CANCELLING:'취소 중',CANCELLED:'취소됨',COMPLETED:'생성 목표 달성',NEEDS_ATTENTION:'목표 미달 · 확인 필요',FAILED:'실행 오류',PASS:'자동 통과',HELD:'보류',DUPLICATE:'중복 제외',OMITTED:'생략',ERROR:'처리 오류'} as any)[value] || value; }
    stage(value:string) { return ({plan:'지식 선정',generate:'QA 생성',review:'주장별 근거 검수',audit:'문답 검수',duplicate:'중복 검사'} as any)[value] || this.status(value); }
    get running() { return ['QUEUED','RUNNING','PAUSING','CANCELLING'].includes(this.detail?.status_code); }
    async openDetail(id:string,quiet=false,launch='') {
        if(!quiet) { this.exportReason=''; this.exportExclusionsOpen=false; this.exportReturn=false; this.exportEpoch++; this.exportData=null; this.exportError=''; this.exportNotice=''; this.exportOperation=''; }
        const epoch=this.detailEpoch, requestEpoch=++this.detailRequestEpoch;
        clearTimeout(this.pollTimer);
        if(!quiet) { this.loading=true; this.error=''; this.inputPage=1; this.clearResult(); }
        await this.service.render();
        try {
            const detail=await this.call('detail',{id});
            if(epoch!==this.detailEpoch || requestEpoch!==this.detailRequestEpoch) return;
            this.detail=detail;
            let saved:any={};
            if(!quiet) {
                saved=['review','results','export','execution'].includes(launch) ? {} : this.recalled(detail.request_id); this.restoring=true;
                if(launch==='review') saved.filter=Number(detail.review_summary?.pending || 0)>0 ? 'R:PENDING' : Number(detail.review_summary?.held || 0)>0 ? 'R:HELD' : 'R:ALL';
                if(['results','export','execution'].includes(launch)) saved.tab=launch;
                const filters=['R:ALL','','PASS','HELD','DUPLICATE','OMITTED','ERROR','R:PENDING','R:REVIEWED','R:HELD','R:EXCLUDED'];
                this.resultFilter=this.appliedResultFilter=filters.includes(saved.filter) ? saved.filter : 'R:ALL';
                this.resultQuery=this.appliedResultQuery=typeof saved.q==='string' ? saved.q.slice(0,150) : '';
                this.results.page=Number.isInteger(saved.page) && saved.page>0 ? saved.page : 1;
                this.runFilter=this.canWrite && detail.runs?.some((r:any)=>r.request_id===saved.run) ? saved.run : '';
                this.detailTab=['results','sources','execution','export','assignments'].includes(saved.tab) ? saved.tab : 'results';
                if(!this.canOpenTab(this.detailTab)) this.detailTab='results';
                this.historyScroll=Number(saved.historyScroll) || 0;
            }
            if(detail.job && (!quiet || (!this.resultsLoading && !this.navigatingResult && !this.reviewDirty && !this.reviewSaving))) await this.loadResults(this.results.page,epoch,quiet);
            if(!quiet && epoch===this.detailEpoch) {
                const item=this.results.items.find((x:any)=>x.item_id===saved.item) ||
                    (this.detailTab==='results' ? this.results.items[0] : null);
                if(item) await this.showResult(item);
                this.restoring=false; this.remember();
            }
        } catch(e:any) { if(epoch===this.detailEpoch && requestEpoch===this.detailRequestEpoch) this.error=e.message; }
        finally {
            if(epoch===this.detailEpoch && requestEpoch===this.detailRequestEpoch) {
                this.loading=false; this.restoring=false; await this.service.render();
                if(!quiet && this.detailTab==='execution') window.scrollTo({top:this.historyScroll});
                if(!quiet && this.detailTab==='export') await this.loadExport();
                if(!quiet && this.detailTab==='assignments') await this.loadAssignments();
                if(this.running) this.pollTimer=setTimeout(()=>this.openDetail(id,true),5000);
            }
        }
    }
    async loadResults(page=1,epoch=this.detailEpoch,quiet=false) {
        if(!this.detail?.job) return false;
        const requestEpoch=++this.resultsEpoch;
        if(!quiet) { this.resultsLoading=true; this.resultsError=''; await this.service.render(); }
        try {
            const result=await this.call('items',{id:this.detail.request_id,run:this.runFilter,page,status:this.appliedResultFilter.startsWith('R:') ? '' : this.appliedResultFilter,review_status:this.appliedResultFilter.startsWith('R:') ? this.appliedResultFilter.slice(2) : '',q:this.appliedResultQuery});
            if(epoch!==this.detailEpoch || requestEpoch!==this.resultsEpoch) return false;
            this.results=result; this.resultsError=''; if(result.review_summary) this.detail.review_summary=result.review_summary;
            if(!this.reviewDirty && !this.reviewSaving && this.selectedResult && !result.items.some((x:any)=>x.item_id===this.selectedResult.item_id)) this.clearResult();
            this.remember(); return true;
        } catch(e:any) {
            if(epoch===this.detailEpoch && requestEpoch===this.resultsEpoch) this.resultsError=e.message;
            return false;
        } finally {
            if(epoch===this.detailEpoch && requestEpoch===this.resultsEpoch) {
                this.resultsLoading=false; await this.service.render();
            }
        }
    }
    clearResult() { this.itemEpoch++; this.selectedResult=null; this.resultLoading=false; this.reviewForm=null; this.reviewBaseline=''; this.reviewEditing=false; this.reviewError=''; this.reviewNotice=''; this.reviewRecovery=null; }
    async filterResults(reset=false) {
        if(!this.leaveReview()) { this.resultFilter=this.appliedResultFilter; return; }
        if(reset) { this.resultQuery=''; this.resultFilter='R:ALL'; }
        this.appliedResultFilter=this.resultFilter; this.appliedResultQuery=this.resultQuery.trim(); this.jumpError=''; this.resultJump=1;
        this.clearResult(); this.results={items:[],page:1,pages:1,total:0};
        await this.loadResults(1);
        if(window.innerWidth>960 && this.results.items.length) await this.showResult(this.results.items[0]);
        document.querySelector('.qa-list-pane')?.scrollTo({top:0});
    }
    async resultPage(page:number) {
        if(this.resultsLoading || this.navigatingResult || !this.leaveReview()) return;
        this.clearResult(); this.jumpError=''; await this.loadResults(page);
        if(window.innerWidth>960 && this.results.items.length) await this.showResult(this.results.items[0]);
        document.querySelector('.qa-list-pane')?.scrollTo({top:0});
    }
    async showResult(item:any,afterSave=false) {
        if(afterSave ? (!this.reviewSaving || this.reviewDirty) : !this.leaveReview())return;
        const epoch=this.detailEpoch, requestEpoch=++this.itemEpoch, id=this.detail.request_id;
        this.resultLoading=true; this.error=''; await this.service.render();
        try {
            const result=await this.call('item',{id,item_id:item.item_id});
            if(epoch!==this.detailEpoch || requestEpoch!==this.itemEpoch) return;
            this.queueOpen=false; this.selectedResult=result; this.acceptReview(result); this.reviewNotice=''; this.inspectorTab='answer'; this.resultJump=(this.results.page-1)*20+this.resultIndex+1; this.remember();
            await this.service.render();
            document.getElementById('qa-inspector')?.focus({preventScroll:true});
            if(!this.restoring) document.getElementById('qa-inspector')?.scrollIntoView({block:'start',behavior:'instant'});
            document.querySelector('.inspection-columns')?.scrollTo({top:0,behavior:'instant'});
            document.querySelectorAll<HTMLElement>('.qa-reading,.qa-support').forEach(panel=>{
                panel.scrollTo({top:0,behavior:'instant'});
                if(!window.matchMedia?.('(prefers-reduced-motion: reduce)').matches &&
                   document.visibilityState!=='hidden' && typeof panel.animate==='function') {
                    panel.getAnimations().forEach(animation=>animation.cancel());
                    panel.animate([{opacity:.88},{opacity:1}],{duration:140,easing:'cubic-bezier(.2,.65,.3,1)'});
                }
            });
        } catch(e:any) {
            if(epoch===this.detailEpoch && requestEpoch===this.itemEpoch) {
                if(afterSave)throw e;
                if(this.selectedResult && this.reviewForm){this.reviewError=e.message;await this.focusReviewElement('qa-review-feedback');}
                else this.error=e.message;
            }
        }
        finally {
            if(epoch===this.detailEpoch && requestEpoch===this.itemEpoch) { this.resultLoading=false; await this.service.render(); }
        }
    }
    closeResult() {
        if(!this.leaveReview()) return;
        const id=this.selectedResult?.item_id; this.clearResult(); this.remember();
        this.service.render().then(()=>document.getElementById('result-'+id)?.focus({preventScroll:true}));
    }
    async jumpToResult() {
        const number=Number(this.resultJump);
        if(!Number.isInteger(number) || number<1 || number>this.results.total) {
            this.jumpError='1~'+this.results.total+' 사이의 문항 번호를 입력해 주세요.'; return;
        }
        if(this.navigatingResult || this.resultsLoading || this.resultLoading || !this.leaveReview()) return;
        const epoch=this.detailEpoch;
        this.jumpError=''; this.navigatingResult=true; this.clearResult(); await this.service.render();
        try {
            const page=Math.floor((number-1)/20)+1;
            if(page!==this.results.page && !await this.loadResults(page)) return;
            if(epoch!==this.detailEpoch) return;
            const item=this.results.items[(number-1)%20];
            if(item) await this.showResult(item);
        } finally { this.navigatingResult=false; await this.service.render(); }
    }
    resetFilters() { this.listQuery=''; this.listStatus=''; this.listKind=''; this.listSort='newest'; this.refresh(); }
    get reviewResultsOnly() { return this.appliedResultFilter.startsWith('R:'); }
    get resultScopeFiltered() { return !!((this.appliedResultFilter && this.appliedResultFilter!=='R:ALL') || this.appliedResultQuery); }
    get filtered() { return !!(this.listQuery || this.listStatus || this.listKind); }
    async previewSource(file:any, unit:any=null) {
        const epoch=++this.previewEpoch, opening=!this.previewFile;
        this.previewFile=file; this.previewUnit=unit || file.preview_pages?.[0]; this.previewText=null; this.previewError='';
        if(!this.previewUnit) { this.previewLoading=false; return; }
        this.previewLoading=true; await this.service.render();
        if(opening) {
            document.getElementById('source-preview-title')?.focus({preventScroll:true});
            document.querySelector('.source-preview')?.scrollIntoView({block:'nearest'});
        }
        try {
            let data=this.previewCache.get(this.previewUnit.id);
            if(!data) data=await this.call('preview',{key:file.key,unit_id:this.previewUnit.id,revision:this.revision});
            if(epoch===this.previewEpoch) { this.previewCache.set(data.id,data); this.previewText=data; }
        } catch(e:any) { if(epoch===this.previewEpoch) this.previewError=e.message; }
        finally { if(epoch===this.previewEpoch) { this.previewLoading=false; await this.service.render(); } }
    }
    @HostListener('document:keydown.escape')
    dismissPreview() { if(this.previewFile && !this.pickerOpen) this.closePreview(true); }
    closePreview(restoreFocus=false) {
        const key=this.previewFile?.key;
        this.previewEpoch++; this.previewFile=null; this.previewText=null; this.previewLoading=false;
        this.service.render().then(()=>{
            if(restoreFocus && key) Array.from(document.querySelectorAll<HTMLButtonElement>('.file-preview-button')).find(el=>el.dataset['sourceKey']===key)?.focus({preventScroll:true});
        });
    }
    get resultIndex() { return this.results.items.findIndex((x:any)=>x.item_id===this.selectedResult?.item_id); }
    canMoveResult(delta:number) {
        if(this.reviewSaving || this.resultLoading || this.resultsLoading || this.navigatingResult || this.resultIndex<0) return false;
        const index=this.resultIndex+delta;
        return index>=0 && index<this.results.items.length || delta<0 && this.results.page>1 || delta>0 && this.results.page<this.results.pages;
    }
    async moveResult(delta:number) {
        if(!this.canMoveResult(delta) || !this.leaveReview()) return;
        const epoch=this.detailEpoch;
        this.navigatingResult=true; await this.service.render();
        try {
            let index=this.resultIndex+delta;
            if(index<0 || index>=this.results.items.length) {
                if(!await this.loadResults(this.results.page+delta)) return;
                index=delta>0 ? 0 : this.results.items.length-1;
            }
            if(epoch!==this.detailEpoch) return;
            if(this.results.items[index]) await this.showResult(this.results.items[index]);
        } finally { this.navigatingResult=false; await this.service.render(); }
    }
    tone(code:string) {
        if(['PASS','COMPLETED'].includes(code)) return 'good';
        if(['HELD','NEEDS_ATTENTION','PAUSED','PAUSING'].includes(code)) return 'attention';
        if(['FAILED','ERROR'].includes(code)) return 'danger';
        if(['CANCELLED','DUPLICATE','OMITTED'].includes(code)) return 'neutral';
        return 'active';
    }
    async control(action:string,id=this.detail?.request_id) {
        if(this.busy || !id) return;
        if(action==='cancel' && !window.confirm('추가 생성을 중단하시겠습니까? 저장된 문항과 사용량은 유지됩니다.')) return;
        this.busy=true; this.error=''; clearTimeout(this.pollTimer); await this.service.render();
        try { await this.call(action,{id}); await this.openDetail(id,true); }
        catch(e:any) { this.error=e.message; if(this.running) this.pollTimer=setTimeout(()=>this.openDetail(id,true),5000); }
        finally { this.busy=false; await this.service.render(); }
    }
    issueText(values:any[]) { return (values || []).map(value=>this.issueLabel(value)).join(' · '); }
    issueLabel(code:string) { return ({SOURCE_REFERENCE_READING_CONFLICT:'원문 표기와 독음 사전이 다릅니다. 용어 표기를 확인한 뒤 다시 검수해 주세요.',REFERENCE_READING_CONFLICT:'한자 독음과 참고 사전이 일치하지 않습니다.',FIXED_LEARNING_GOAL_CHANGED:'보완 과정에서 원래 질문·주제·유형이 바뀌어 보류했습니다.',FIXED_LEARNING_GOAL_NOT_ANSWERED:'원래 질문에서 요구한 내용을 충분히 답하지 못했습니다.',REVIEW_FORMAT_UNRESOLVED:'검수 결과의 답변 연결을 확인하지 못했습니다. 문답은 자동 채택되지 않았습니다.',INVALID_QA_CITATION:'문답 인용문이 원문과 일치하지 않습니다.',INVALID_PLAN_CITATION:'선정 지식의 인용문이 원문과 일치하지 않습니다.',NO_CENTER_EVIDENCE:'선택한 중심 쪽의 근거가 없습니다.',INCOMPLETE_CONTEXT:'필요한 원문 문맥이 완결되지 않았습니다.',SOURCE_REVIEW_REQUIRED:'원문 추출 상태를 확인해야 합니다.',CASE_OR_RESEARCH_ONLY:'연구·증례 결과만으로 일반적인 진료 지식을 만들 수 없습니다.',NO_SUPPORTED_KNOWLEDGE:'원문으로 뒷받침할 지식이 없습니다.',TEXTBOOK_PROCEDURE_EXCLUDED:'현재 생성 기준에서 교과서 시술 절차는 제외합니다.',TEXTBOOK_PROCEDURE_CONTENT:'현재 생성 기준에서 시술 절차·용량은 제외합니다.',KOREAN_READING_MISSING:'한자 용어의 한국어 독음이 빠졌습니다.',KOREAN_READING_MISMATCH:'한자 용어의 독음을 확인해야 합니다.',GRADE_IN_LEARNING_TEXT:'권고등급·근거수준 암기 문항은 제외합니다.',FORMULAIC_SHOULD_CONSIDER:'구체적인 임상 지식 없이 권고 표현을 반복합니다.',EMPTY_RECOMMENDATION:'답변에 구체적인 판단 내용이 없습니다.',NONCLINICAL_TOPIC:'진료지원 학습 지식에 해당하지 않습니다.',UNRESOLVED_REFERENCE:'답변에 해소되지 않은 원문 참조가 있습니다.',KNOWN_SUSPECT_TERM:'원문 용어의 오탈자가 의심됩니다.',KNOWN_SUSPECT_TERM_CODE:'용어와 코드의 일치를 확인해야 합니다.',COMBINATION_CONTEXT_LOST:'원문의 병행 치료 조건이 빠졌습니다.',CLINICAL_AUDIT_REJECTED:'문답·조건 검수에서 확인이 필요한 사항을 발견했습니다.',SEMANTIC_REVIEW_FAILED:'근거 검수 항목을 모두 통과하지 못했습니다.',SEMANTIC_HOLD_OR_REJECT:'근거 검수에서 보류·제외 또는 중복으로 판정했습니다.',UNSUPPORTED_CLAIM:'답변에 원문으로 뒷받침되지 않는 주장이 있습니다.',UNCHECKED_ANSWER_SPAN:'답변의 일부가 근거 검수되지 않았습니다.',DUPLICATE_QUESTION:'이미 채택한 문항과 질문이 같습니다.',NEAR_DUPLICATE:'이미 채택한 문항과 학습 내용이 유사합니다.',CONTEXT_DEPENDENT:'원문 없이 질문을 이해하기 어렵습니다.',PLAN_TOPIC_OR_KIND_CHANGED:'선정 지식과 문답의 주제·유형이 다릅니다.',UNSUPPORTED_HANGUL_HAN_PAIR:'원문에 없는 한자·용어가 추가됐습니다.',CLINICAL_AUDIT_COVERAGE:'문답 검수 항목이 누락됐습니다.',CLINICAL_AUDIT_EMPTY:'문답 검수의 판단 근거가 부족합니다.',REVIEW_CHECK_COVERAGE:'근거 검수 항목이 누락됐습니다.',INVALID_CLAIM_SPAN:'주장별 검수 구간이 답변과 일치하지 않습니다.',INVALID_CLAIM_CITATION:'주장의 인용 근거를 확인할 수 없습니다.',INVALID_DEMAND_SUPPORT:'질문 요구사항을 뒷받침하는 인용이 정확하지 않습니다.',INVALID_CONDITION_SUPPORT:'적용 조건의 인용이 정확하지 않습니다.',OVERLOADED_QUESTION:'한 문항이 너무 많은 요구사항을 묻습니다.',ABSTENTION_SEPARATE:'원문으로 답할 수 없어 별도 보류했습니다.'} as any)[code] || (/^[A-Z_]+$/.test(code) ? '현재 생성 기준에서 추가 확인이 필요한 내용입니다.' : code); }
    checks(value:any) { return Object.entries(value || {}).map(([key,value]:any)=>({key,value})); }
    checkLabel(key:string) { return ({topic_alignment:'주제 일치',question_answer_alignment:'질문·답변 일치',taxonomy_alignment:'유형 적합성',scope_and_conditions:'범위·적용 조건',polarity:'긍정·부정 보존',purpose_vs_outcome:'목적·결과 구분',no_invented_details:'근거 없는 추가',terminology_fidelity:'용어 정확성',numbers_and_units:'수치·단위',standalone_natural_question:'독립적인 질문',direct_answer:'직접적인 답변',evidence_complete:'근거 완결성',source_reliable:'추출문 신뢰성',not_case_or_trial_generalization:'연구·증례 일반화 방지',nonduplicate:'중복 여부',clinical_relevance:'임상적 유용성',question_demands_answered:'질문 요구 충족',standalone:'문답 완결성',source_terminology:'원문 용어',treatment_conditions:'치료 조건',recommendation_modality:'권고 강도',no_historical_generalization:'역사적 맥락',focused_natural_language:'명확한 문답',korean_readings:'한국어 독음'} as any)[key] || key; }
    evidencePdf(e:any) {
        if(!this.canManageDetail) return '/wiz/api/page.datasets/review_evidence_pdf?id='+encodeURIComponent(this.detail.request_id)+'&item_id='+encodeURIComponent(this.selectedResult.item_id)+'&content_unit_id='+encodeURIComponent(e.content_unit_id);
        const target=this.selectedResult?.evidence_targets?.[e.content_unit_id];
        return '/wiz/api/page.sources/pdf?path='+encodeURIComponent(target?.path || e.path)+'&page='+encodeURIComponent(target?.page || e.page);
    }
    evidenceParams(e:any) {
        const target=this.selectedResult?.evidence_targets?.[e.content_unit_id],path=target?.path || e.path;
        return {path:path.split('/').slice(0,-1).join('/'),result:path,pdf_page:target?.page || e.page,job:target?.job || null};
    }
    async back() {
        if(this.busy || !this.leaveReview() || (this.dirty && !window.confirm('초안의 변경사항을 저장하지 않고 목록으로 돌아가시겠습니까?'))) return;
        this.dirty=false; this.editing=false; this.detail=null; this.plan=null;
        await this.router.navigate(['/datasets']); await this.refresh();
    }
    inputGroups() {
        const groups=new Map<string,any>();
        for(const item of this.inputItems()) {
            if(!groups.has(item.storage_object_key)) groups.set(item.storage_object_key,{key:item.storage_object_key,items:[]});
            groups.get(item.storage_object_key).items.push(item);
        }
        return Array.from(groups.values());
    }
    basename(key:string) { return key.split('/').pop(); }
    sourceParams(item:any) { return {path:item.key.split('/').slice(0,-1).join('/'),result:item.key}; }
    date(value:string) { return formatWorkspaceDate(value); }
    previewItems() { return (this.plan?.items || []).slice((this.previewPage-1)*20,this.previewPage*20); }
    inputItems() { return (this.detail?.inputs || []).slice((this.inputPage-1)*30,this.inputPage*30); }
    get previewPages() { return Math.max(1,Math.ceil((this.plan?.items.length || 0)/20)); }
    get inputPages() { return Math.max(1,Math.ceil((this.detail?.inputs.length || 0)/30)); }
}

export default PageDatasetsComponent;